export const en = {
  'common.signOut': 'Sign out',
  'profile.menu': 'My profile',
  'profile.title': 'My profile',
  'profile.subtitle': 'Your personal details: address, IBAN, photo and more.',
  'profile.address': 'Address',
  'profile.zip': 'ZIP',
  'profile.city': 'City',
  'profile.nationality': 'Nationality',
  'profile.iban': 'IBAN',
  'profile.birthDate': 'Date of birth',
  'profile.phone': 'Phone number',
  'profile.uploadPhoto': 'Upload photo',
  'profile.removePhoto': 'Remove photo',
  'profile.noPhoto': 'No photo',
  'profile.photoError': 'The image could not be processed.',
  'profile.saved': 'Profile saved',
  'common.signIn': 'Sign in',
  'common.email': 'Email',
  'common.password': 'Password',
  'common.search': 'Search',
  'common.cancel': 'Cancel',
  'common.save': 'Save',
  'common.create': 'Create',
  'common.new': 'New',
  'pdf.preview': 'Preview',
  'common.edit': 'Edit',
  'common.back': 'Back',
  'picker.product.placeholder': 'Search product (SKU or name)…',
  'picker.product.empty': 'No product found',
  'picker.product.create': 'Create new product',
  'picker.product.required': 'Please pick a product for every line.',
  'common.delete': 'Delete',

  // Invoice print / PDF
  'invoice.print.viewPdf': 'View / PDF',
  'invoice.print.printOrSave': 'Print / Save as PDF',
  'invoice.print.downloadPdf': 'Download PDF',
  'email.title': 'Send by e-mail',
  'email.intro': 'The document is attached as a PDF and sent via your configured SMTP server.',
  'email.to': 'Recipient',
  'email.subject': 'Subject',
  'email.send': 'Send by e-mail',
  'email.message': 'Message',
  'email.body': 'Hello\n\nplease find the document attached.\n\nKind regards',
  'attachments.title': 'Attachments',
  'attachments.upload': 'Upload file',
  'attachments.hint': 'PDF, images or Office files up to 10 MB.',
  'attachments.empty': 'No attachments yet.',
  'attachments.delete': 'Delete',
  'invoice.print.sendMail': 'Send by email',
  'invoice.print.heading': 'Invoice',
  'order.pdf.heading': 'Order confirmation',
  'quote.pdf.heading': 'Quote',
  'quote.pdf.to': 'Quote to',
  'quote.pdf.intro': 'Thank you for your inquiry - we are pleased to quote as follows:',
  'quote.pdf.vatNote': 'All prices in {currency}, excl. VAT.',
  'quote.pdf.validity': 'This quote is valid until {date}.',
  'quote.pdf.closing': 'Kind regards',
  'quote.email.title': 'Send quote to customer',
  'quote.email.subject': 'Quote {number}',
  'quote.email.body': 'Dear Sir or Madam\n\nWe are pleased to submit our quote {number}, valid until {validUntil}. Please find the document attached.\n\nIf you have any questions, we are happy to help.\n\nKind regards',
  'quote.email.markOnly': 'Mark as sent only',
  'order.email.title': 'Send order confirmation to customer',
  'order.email.subject': 'Order confirmation {number}',
  'order.email.body': 'Dear Sir or Madam\n\nThank you for your order. Please find attached the order confirmation {number}.\n\nIf you have any questions, we are happy to help.\n\nKind regards',
  'delivery.email.title': 'Send delivery note to customer',
  'delivery.email.subject': 'Delivery note {number}',
  'delivery.email.body': 'Dear Sir or Madam\n\nYour delivery is on its way. Please find attached the delivery note {number}.\n\nIf you have any questions, we are happy to help.\n\nKind regards',
  'delivery.email.tracking': 'Tracking: {tracking}',
  'invoice.email.title': 'Send invoice to customer',
  'invoice.email.subject': 'Invoice {number}',
  'invoice.email.body': 'Dear Sir or Madam\n\nPlease find attached our invoice {number} for {amount}, payable by {dueDate}.\n\nThank you for your business.\n\nKind regards',
  'po.pdf.heading': 'Purchase order',
  'po.pdf.to': 'Supplier',
  'po.pdf.intro': 'We would like to order the following items:',
  'po.email.title': 'Send purchase order to supplier',
  'po.email.subject': 'Purchase order {number}',
  'po.email.body': 'Dear Sir or Madam\n\nPlease find attached our purchase order {number}. Kindly confirm receipt.\n\nThank you.\n\nKind regards',
  'po.email.expected': 'Requested delivery date: {date}',
  'inv.po.action.email': 'Send to supplier',
  'hr.payslips.title': 'Payslips',
  'hr.payslips.action': 'Payslips',
  'hr.payslips.employee': 'Employee',
  'hr.payslips.empty': 'No payslips in this run.',
  'payslip.pdf.heading': 'Payslip',
  'payslip.pdf.employee': 'Employee',
  'payslip.pdf.employeeNumber': 'Employee no.',
  'payslip.pdf.period': 'Payroll period',
  'payslip.pdf.baseSalary': 'Base salary',
  'payslip.pdf.allowances': 'Allowances',
  'payslip.pdf.gross': 'Gross pay',
  'payslip.pdf.tax': 'Withholding tax',
  'payslip.pdf.deductions': 'Other deductions',
  'payslip.pdf.net': 'Net pay',
  'payslip.pdf.confidential': 'Confidential - for the recipient only.',
  'projects.billing.title': 'Billing',
  'projects.billing.rate': 'Hourly rate',
  'projects.billing.unbilledTime': 'Unbilled hours',
  'projects.billing.expenses': 'Billable expenses',
  'projects.billing.total': 'Open to bill',
  'projects.billing.action': 'Create invoice',
  'projects.billing.empty': 'Nothing open - all approved items are billed.',
  'projects.billing.noCustomer': 'No customer assigned to this project - set one to enable billing.',
  'projects.billing.noRevenueAccount': 'No revenue account found.',
  'projects.billing.lineTime': 'Project services {code} - {hours} h',
  'projects.billing.lineExpenses': 'Project expenses {code}',
  'projects.billing.done': 'Invoice {number} created',
  'projects.billing.markFailed': 'Invoice {number} was created but marking the items failed - do NOT bill this project again!',
  'inv.products.modal.skuHint': 'e.g. ITEM-0001',
  'inv.products.modal.skuHintService': 'e.g. SRV-0001',
  'inv.products.modal.editTitle': 'Edit product',
  'inv.products.modal.active': 'Active',
  'inv.products.modal.type': 'Product type',
  'inv.products.modal.typeGood': 'Item (stock-managed)',
  'inv.products.modal.typeService': 'Service (no stock management)',
  'inv.products.modal.serviceHint': 'Services are managed without inventory - reorder point, traceability and goods movements do not apply.',
  'product.type.GOOD': 'Item',
  'product.type.SERVICE': 'Service',
  'uom.short.EACH': 'pcs',
  'uom.short.BOX': 'box',
  'uom.short.KG': 'kg',
  'uom.short.L': 'l',
  'uom.short.M': 'm',
  'uom.short.HOUR': 'hrs',
  'uom.short.DAY': 'days',
  'uom.short.FLAT': 'flat',
  'uom.unit.EACH': 'Piece',
  'uom.unit.BOX': 'Box',
  'uom.unit.KG': 'Kilogram',
  'uom.unit.L': 'Litre',
  'uom.unit.M': 'Metre',
  'uom.unit.HOUR': 'Hour',
  'uom.unit.DAY': 'Day',
  'uom.unit.FLAT': 'Flat rate',
  'order.pdf.to': 'Customer',
  'pdf.draftMark': 'Draft - not binding',
  'invoice.print.billTo': 'Bill to',
  'invoice.print.total': 'Total amount',
  'invoice.print.mailSubject': 'Invoice',
  'invoice.print.mailGreeting': 'Hello,',
  'invoice.print.mailBody': 'please find attached our invoice',
  'invoice.print.qrMissing': 'To generate the QR code, first enter company name and IBAN under Settings → Company & bank details.',
  'invoice.print.qrError': 'QR code could not be generated. Please check the IBAN in settings.',

  // Settings → company / bank
  'settings.company.title': 'Company & bank details',
  'settings.company.intro': 'These details appear on invoices and in the Swiss QR code.',
  'settings.company.name': 'Company name',
  'settings.company.address': 'Address',
  'settings.company.zip': 'ZIP',
  'settings.company.city': 'City',
  'settings.company.email': 'Email',
  'settings.company.phone': 'Phone',
  'settings.company.bank': 'Bank details',
  'settings.company.iban': 'IBAN',
  'settings.company.bankName': 'Bank',
  'settings.company.vat': 'VAT number',
  'settings.company.saved': 'Saved.',
  'settings.smtp.title': 'Email sending (SMTP)',
  'settings.smtp.intro': 'Mail server for automatic sending of invoices/reminders. The password is stored securely and never shown.',
  'settings.smtp.host': 'SMTP server',
  'settings.smtp.port': 'Port',
  'settings.smtp.user': 'Username',
  'settings.smtp.password': 'Password',
  'settings.smtp.passwordKeep': '•••••• (set - leave empty to keep)',
  'settings.smtp.from': 'Sender address',
  'settings.smtp.secure': 'Use SSL/TLS (port 465)',

  // CSV import/export
  'csv.export': 'Export CSV',
  'csv.import': 'Import CSV',
  'csv.import.intro': 'Upload a CSV file. Columns are mapped automatically (semicolon or comma delimiter).',
  'csv.import.expectedColumns': 'Expected columns',
  'csv.import.file': 'CSV file',
  'csv.import.preview': 'Preview',
  'csv.import.rows': 'rows',
  'csv.import.start': 'Import',
  'csv.import.running': 'Importing',
  'csv.import.done': 'Done',
  'csv.import.imported': 'imported',
  'csv.import.failedCount': 'failed',
  'csv.import.line': 'Line',
  'csv.import.empty': 'The file has no data rows.',
  'csv.import.parseError': 'The file could not be read.',
  'csv.import.missingColumns': 'Required columns missing',
  'common.confirm': 'Confirm',
  'common.actions': 'Actions',
  'common.all': 'All',
  'common.searchPlaceholder': 'Search…',
  'common.loadError': 'Failed to load data',

  'col.code': 'Code',
  'col.number': 'Number',
  'col.name': 'Name',
  'col.type': 'Type',
  'col.email': 'Email',
  'col.date': 'Date',
  'col.due': 'Due',
  'col.total': 'Total',
  'col.paid': 'Paid',
  'col.status': 'Status',
  'col.balance': 'Balance',
  'col.unit': 'Unit',
  'col.product': 'Product',
  'col.warehouse': 'Warehouse',
  'col.amount': 'Amount',
  'col.actions': '',

  'aria.hauptnavigation': 'Main navigation',
  'aria.menueOeffnen': 'Open menu',
  'aria.menueSchliessen': 'Close menu',
  'aria.laedt': 'Loading',
  'aria.schliessen': 'Close',
  'empty.default': 'No data',
  'empty.invoices': 'No invoices yet',
  'empty.accounts': 'No accounts yet',
  'empty.employees': 'No employees yet',
  'empty.leave':    'No leave requests yet',
  'empty.payroll':  'No payroll runs yet',
  'empty.products': 'No products yet',
  'empty.lowStock': 'All items healthy - no low-stock alerts.',
  'empty.po':       'No purchase orders yet',
  'empty.customers':'No customers yet',
  'empty.orders':   'No sales orders yet',
  'empty.opps':     'No opportunities',

  'status.PROCESSED': 'Processed',
  'status.EXPIRED': 'Expired',
  'status.CREDIT_HOLD': 'Credit hold',
  'status.SUBMITTED': 'Submitted',
  'status.REQUESTED': 'Requested',
  'status.PROPOSED': 'Proposed',
  'status.UNMATCHED': 'Unmatched',
  'status.IN_STOCK': 'In stock',
  'status.ACTIVE': 'Active',
  'status.INACTIVE': 'Inactive',
  'status.BLOCKED': 'Blocked',
  'status.DRAFT': 'Draft',
  'status.POSTED': 'Posted',
  'status.PAID': 'Paid',
  'status.CANCELLED': 'Cancelled',
  'status.CONFIRMED': 'Confirmed',
  'status.FULFILLED': 'Fulfilled',
  'status.INVOICED': 'Invoiced',
  'status.PARTIAL': 'Partial',
  'status.PENDING': 'Pending',
  'nav.myTime': 'My time',
  'weekday.mon': 'Monday',
  'weekday.tue': 'Tuesday',
  'weekday.wed': 'Wednesday',
  'weekday.thu': 'Thursday',
  'weekday.fri': 'Friday',
  'weekday.sat': 'Saturday',
  'weekday.sun': 'Sunday',
  'time.my.title': 'My time',
  'time.my.subtitle': 'Record start and end or enter hours later. Missing days stand out.',
  'time.week.loading': 'Loading the week…',
  'time.week.prev': 'Previous week',
  'time.week.next': 'Next week',
  'time.week.thisWeek': 'This week',
  'time.week.of': 'of {target} h',
  'time.week.off': 'off',
  'time.week.holiday': 'Public holiday',
  'time.week.missing': 'missing',
  'time.week.add': 'Add',
  'time.balance.target': 'Target',
  'time.balance.actual': 'Actual',
  'time.balance.balance': 'Balance',
  'time.add.cta': 'Record time',
  'time.add.title': 'Record time',
  'time.add.date': 'Day',
  'time.add.modeClock': 'Start and end',
  'time.add.modeHours': 'Enter hours',
  'time.add.start': 'Start',
  'time.add.end': 'End',
  'time.add.break': 'Break (min.)',
  'time.add.hours': 'Hours',
  'time.add.overnight': 'The shift runs past midnight',
  'time.add.submit': 'Add',
  'time.add.saving': 'Adding…',
  'time.add.failed': 'Could not be added',
  'nav.section.self': 'My data',
  'nav.myLeave': 'My leave',
  'roles.employee': 'Employee',
  'self.title': 'My leave',
  'self.subtitle': 'Signed in as {name}. This page shows only what concerns you.',
  'self.loading': 'Loading…',
  'self.noLink': 'Your account is not linked to a personnel record yet. HR needs to make the link, after which your leave balance appears here.',
  'self.balances.title': 'My balance',
  'self.balances.of': 'of {granted} days, {used} taken',
  'self.balances.empty': 'No entitlement recorded for this year yet.',
  'self.requests.title': 'My requests',
  'self.requests.empty': 'You have not submitted any requests yet.',
  'self.requests.col.period': 'Period',
  'self.requests.col.days': 'Days',
  'self.requests.col.status': 'State',
  'self.requests.col.reason': 'Reason',
  'self.requests.col.note': 'Response',
  'self.leave.request': 'Request leave',
  'self.leave.type': 'Type',
  'self.leave.typePlaceholder': 'Please choose',
  'self.leave.from': 'From',
  'self.leave.to': 'To',
  'self.leave.reason': 'Reason (optional)',
  'self.leave.submit': 'Submit request',
  'self.leave.submitting': 'Submitting…',
  'self.leave.submit.failed': 'The request could not be submitted',
  'self.leave.withdraw': 'Withdraw',
  'self.leave.withdraw.failed': 'Withdrawal not possible',
  'self.leave.orderHint': 'The end date is before the start date.',
  'self.leave.workdayHint': 'Only working days count. Weekends and public holidays are not deducted.',
  'status.PENDING_APPROVAL': 'Pending approval',
  'status.APPROVED': 'Approved',
  'status.REJECTED': 'Rejected',
  'status.RECEIVED': 'Received',
  'status.OPEN': 'Open',
  'status.PAUSED': 'Paused',
  'status.CLOSED': 'Closed',
  'status.ON_LEAVE': 'On leave',
  'status.TERMINATED': 'Terminated',
  'status.SUSPENDED': 'Suspended',
  'status.SENT': 'Sent',
  'status.ACCEPTED': 'Accepted',
  'status.CONVERTED': 'Converted',
  'status.OVERDUE': 'Overdue',
  'status.HIRED': 'Hired',

  'accountType.ASSET': 'Asset',
  'accountType.LIABILITY': 'Liability',
  'accountType.EQUITY': 'Equity',
  'accountType.REVENUE': 'Revenue',
  'accountType.EXPENSE': 'Expense',

  'invoiceType.SALES': 'Sales',
  'invoiceType.PURCHASE': 'Purchase',

  'finance.accounts.title': 'Chart of Accounts',
  'finance.accounts.subtitle': 'Every GL account with its running balance.',

  'finance.invoices.title': 'Invoices',
  'finance.invoices.subtitle': 'AR + AP. Posting a draft generates the GL journal.',
  'finance.invoices.insight.status': 'Status',
  'finance.invoices.insight.open': 'Open invoices',
  'finance.invoices.insight.outstanding': 'Outstanding',
  'finance.invoices.insight.overdue': 'Overdue',
  'finance.invoices.insight.balance': 'Balance (Income − Expenses)',
  'finance.invoices.cat.income': 'Income (Sales)',
  'finance.invoices.cat.expense': 'Expenses (Purchasing)',
  'finance.invoices.filterType.all': 'All types',
  'finance.invoices.filterType.sales': 'Sales (AR)',
  'finance.invoices.filterType.purchase': 'Purchase (AP)',
  'finance.invoices.filterStatus.all': 'All statuses',
  'finance.invoices.action.post': 'Post',
  'finance.invoices.action.delete': 'Delete',
  'finance.invoices.action.cancel': 'Cancel',
  'finance.invoices.confirmDelete': 'Really delete this draft invoice?',
  'finance.invoices.confirmCancel': 'Really cancel this invoice? A reversing entry will be posted.',

  'finance.reports.title': 'Reports',
  'finance.reports.subtitle': 'Trial balance, income statement, balance sheet.',
  'finance.reports.trialBalance': 'Trial Balance',
  'finance.reports.income': 'Income Statement',
  'finance.reports.balanceSheet': 'Balance Sheet',
  'finance.reports.totals.debits': 'Debits',
  'finance.reports.totals.credits': 'Credits',
  'finance.reports.totals.balanced': '✓ balanced',
  'finance.reports.totals.unbalanced': '⚠ unbalanced',
  'finance.reports.totals.assetsEquation': '✓ Assets = Liabilities + Equity',
  'finance.reports.col.debit': 'Debit',
  'finance.reports.col.credit': 'Credit',
  'finance.reports.metric.revenue': 'Revenue',
  'finance.reports.metric.expenses': 'Expenses',
  'finance.reports.metric.netIncome': 'Net income',
  'finance.reports.metric.assets': 'Assets',
  'finance.reports.metric.liabilities': 'Liabilities',
  'finance.reports.metric.equity': 'Equity',

  // Finance - VAT return
  'vat.title': 'VAT return',
  'vat.subtitle': 'Quarterly return on agreed consideration (effective method).',
  'vat.quarter': 'Quarter',
  'vat.year': 'Year',
  'vat.col.code': 'Code',
  'vat.col.label': 'Description',
  'vat.col.base': 'Turnover (CHF)',
  'vat.col.tax': 'Tax (CHF)',
  'vat.row.total': 'Total agreed consideration',
  'vat.row.exempt': 'Of which exempt (0%)',
  'vat.row.rate': 'Supplies at',
  'vat.row.outputTax': 'Total tax due',
  'vat.row.inputTax': 'Input tax',
  'vat.row.payable': 'Amount payable',
  'vat.row.credit': 'Credit balance',
  'vat.counts': '{sales} sales invoices · {purchases} purchase invoices · {credits} credit notes',
  'vat.net': 'Net',
  'vat.tax': 'VAT',
  'vat.rateCol': 'VAT %',

  'hr.employees.title': 'Employees',
  'hr.employees.subtitle': 'All employees with their current status and salary band.',
  'hr.employees.col.hired': 'Hired',
  'hr.employees.col.salary': 'Base salary',
  'hr.leave.title': 'Leave Requests',
  'hr.leave.subtitle': 'Approve or reject pending requests; balances update automatically.',
  'hr.leave.tab.requests': 'Requests',
  'hr.leave.tab.balances': 'Balances',
  'hr.leave.tab.calendar': 'Calendar',
  'hr.leave.col.employee': 'Employee',
  'hr.leave.col.type': 'Type',
  'hr.leave.col.start': 'Start',
  'hr.leave.col.end': 'End',
  'hr.leave.col.days': 'Days',
  'hr.leave.col.reason': 'Reason',
  'hr.leave.action.approve': 'Approve',
  'hr.leave.action.reject': 'Reject',
  'hr.leave.entitlement.action': 'Set entitlement',
  'hr.leave.entitlement.title': 'Set leave entitlement',
  'hr.leave.entitlement.year': 'Year',
  'hr.leave.entitlement.days': 'Entitlement (days)',
  'hr.leave.entitlement.allTypes': 'All types',
  'hr.leave.balance.entitled': 'Entitled',
  'hr.leave.balance.used': 'Used',
  'hr.leave.balance.remaining': 'Remaining',
  'hr.leave.balance.empty': 'No balances for this year',
  'hr.leave.calendar.absences': 'Absences',
  'hr.leave.calendar.empty': 'No approved absences',
  'hr.leave.calendar.holidays': 'Public holidays',
  'hr.leave.calendar.noHolidays': 'No holidays recorded',
  'hr.payroll.title': 'Payroll Runs',
  'hr.payroll.subtitle': 'Monthly payroll runs with gross/tax/net totals.',
  'hr.payroll.col.period': 'Period',
  'hr.payroll.col.gross': 'Gross',
  'hr.payroll.col.tax': 'Tax',
  'hr.payroll.col.deductions': 'Deductions',
  'hr.payroll.col.net': 'Net',

  'inv.products.title': 'Products',
  'inv.products.subtitle': 'Master catalog with pricing and reorder thresholds.',
  'inv.products.action.new': 'New product',
  'inv.products.search': 'Search SKU or name…',
  'inv.products.col.sku': 'SKU',
  'inv.products.col.price': 'List price',
  'inv.products.col.reorder': 'Reorder pt',
  'inv.products.modal.title': 'New product',
  'inv.products.modal.listPrice': 'List price',
  'inv.products.modal.reorderPoint': 'Reorder point',
  'inv.lowStock.title': 'Low Stock',
  'inv.lowStock.subtitle': 'Items at or below their reorder point. Replenish or raise a PO.',
  'inv.lowStock.col.onHand': 'On hand',
  'inv.lowStock.col.severity': 'Severity',
  'inv.lowStock.sev.out': 'Out of stock',
  'inv.lowStock.sev.critical': 'Critical',
  'inv.lowStock.sev.low': 'Low',
  'inv.po.title': 'Purchase Orders',
  'inv.po.subtitle': 'Confirm drafts, then receive - AP invoice is generated automatically.',
  'inv.po.insight.dist': 'Purchase orders by status',
  'inv.po.insight.open': 'Open POs',
  'inv.po.insight.openValue': 'Open value',
  'inv.po.insight.awaiting': 'Awaiting receipt',
  'inv.po.insight.received': 'Received',
  'inv.po.col.date': 'Order date',
  'inv.po.col.expected': 'Expected',
  'inv.po.action.confirm': 'Confirm',
  'inv.po.action.approve': 'Approve',
  'inv.po.action.reject': 'Reject',
  'inv.po.approval.title': 'Approval',
  'inv.po.approval.submitted': 'Submitted for approval - an admin must approve.',
  'inv.po.approval.confirmReject': 'Really reject this purchase order?',
  'inv.po.approval.requestedBy': 'Requested by',
  'inv.po.approval.decidedBy': 'Decided by',
  'inv.po.approval.decidedAt': 'Decided on',
  'inv.po.approval.note': 'Rejection note',

  'sales.customers.title': 'Customers',
  'sales.customers.subtitle': 'Master customer list with credit limits.',
  'sales.customers.insight.revenue': 'Revenue concentration',
  'sales.customers.insight.others': 'Others',
  'sales.customers.insight.total': 'Total customers',
  'sales.customers.insight.active': 'Active',
  'sales.customers.insight.withOpenOrders': 'With open orders',
  'sales.customers.insight.avgRevenue': 'Avg revenue/customer',
  'sales.customers.action.new': 'New customer',
  'sales.customers.search': 'Search name or code…',
  'sales.customers.col.creditLimit': 'Credit limit',
  'sales.customers.modal.title': 'New customer',
  'sales.customers.modal.currency': 'Currency',
  'sales.customers.modal.creditLimit': 'Credit limit (0 = unlimited)',
  'sales.orders.title': 'Sales Orders',
  'sales.orders.subtitle': 'Confirming an order triggers stock issue → fulfilment → AR invoice via events.',
  'sales.orders.insight.dist': 'Orders by status',
  'sales.orders.insight.open': 'Open orders',
  'sales.orders.insight.openValue': 'Open value',
  'sales.orders.insight.toFulfill': 'To fulfil',
  'sales.orders.insight.booked': 'Booked value',
  'sales.orders.col.fulfillment': 'Fulfilment',
  'sales.orders.action.confirm': 'Confirm',
  'sales.orders.action.cancel': 'Cancel',
  'sales.pipeline.title': 'Pipeline',
  'sales.pipeline.subtitle': 'Stage transitions via the dropdown on each card.',
  'sales.pipeline.action.new': 'New opportunity',
  'sales.pipeline.stage.LEAD': 'Lead',
  'sales.pipeline.stage.QUALIFY': 'Qualify',
  'sales.pipeline.stage.PROPOSAL': 'Proposal',
  'sales.pipeline.stage.NEGOTIATE': 'Negotiate',
  'sales.pipeline.stage.CLOSED_WON': 'Won',
  'sales.pipeline.stage.CLOSED_LOST': 'Lost',
  'sales.pipeline.modal.title': 'New opportunity',
  'sales.pipeline.modal.titleField': 'Title',
  'sales.pipeline.modal.amount': 'Amount',
  'sales.pipeline.modal.stage': 'Stage',
  'sales.pipeline.modal.customer': 'Customer',
  'sales.pipeline.modal.customer.none': '- None -',
  'sales.pipeline.modal.close': 'Expected close',
  'sales.reports.title': 'Sales Reports',
  'sales.reports.subtitle': 'Booked revenue by customer / product, plus the pipeline funnel.',
  'sales.reports.funnel': 'Pipeline Funnel',
  'sales.reports.byCustomer': 'Sales by Customer',
  'sales.reports.byProduct': 'Sales by Product',
  'sales.reports.col.stage': 'Stage',
  'sales.reports.col.count': 'Count',
  'sales.reports.col.pipeline': 'Pipeline',
  'sales.reports.col.weighted': 'Weighted',
  'sales.reports.col.orders': 'Orders',
  'sales.reports.col.revenue': 'Revenue',
  'sales.reports.col.units': 'Units',

  'login.title': 'Sign in',
  'login.hint':  'Use your work email and password.',
  'login.cta':   'Sign in',
  'login.cta.loading': 'Signing in…',
  'login.failed':'Login failed',
  'login.askAdmin':'Need an account? Ask your administrator to provision one.',

  'nav.section.overview': 'Overview',
  'nav.section.finance':  'Finance',
  'nav.section.hr':       'HR',
  'nav.section.inventory':'Inventory',
  'nav.section.sales':    'Sales',
  'nav.section.account':  'Account',
  'nav.section.automation': 'Automation',
  'nav.rules': 'Rules',
  'nav.alerts': 'Alerts',

  // Automation / rule engine
  'auto.title': 'Automation rules',
  'auto.subtitle': 'When an event occurs and the condition matches, an alert is raised.',
  'auto.empty': 'No rules defined.',
  'auto.col.name': 'Rule',
  'auto.col.trigger': 'Trigger',
  'auto.col.condition': 'Condition',
  'auto.col.severity': 'Severity',
  'auto.col.fired': 'Fired',
  'auto.col.enabled': 'Active',
  'auto.col.message': 'Message',
  'auto.col.time': 'Time',
  'auto.always': 'always',
  'auto.on': 'On',
  'auto.off': 'Off',
  'auto.severity.INFO': 'Info',
  'auto.severity.WARNING': 'Warning',
  'auto.severity.CRITICAL': 'Critical',
  'auto.action.new': 'New rule',
  'auto.action.delete': 'Delete',
  'auto.action.markRead': 'Mark read',
  'auto.action.markAll': 'Mark all read',
  'auto.metric.rules': 'Rules',
  'auto.metric.active': 'Active',
  'auto.metric.alerts': 'Open alerts',
  'auto.field.name': 'Name',
  'auto.field.trigger': 'Trigger event',
  'auto.field.condition': 'Condition (optional)',
  'auto.field.noCondition': 'No condition (always)',
  'auto.field.value': 'Value',
  'auto.field.severity': 'Severity',
  'auto.field.message': 'Message',
  'auto.field.messageHint': 'Variables in {…} available:',
  'auto.op.lt': 'less than',
  'auto.op.lte': 'at most',
  'auto.op.gt': 'greater than',
  'auto.op.gte': 'at least',
  'auto.op.eq': 'equals',
  'auto.op.neq': 'not equal',
  'auto.op.contains': 'contains',
  'auto.op.exists': 'exists',
  'auto.modal.title': 'New automation rule',
  'auto.error.required': 'Name, trigger and message are required.',
  'auto.alerts.title': 'Alerts',
  'auto.alerts.subtitle': 'Notifications raised by your rules.',
  'auto.alerts.empty': 'No alerts.',

  'nav.dashboard':        'Dashboard',
  'nav.inbox':            'Inbox',
  'nav.calendar':         'Calendar',

  // Calendar view
  'cal.title': 'Calendar',
  'cal.subtitle': 'Due dates across all modules: invoices, maintenance, orders, leave.',
  'cal.today': 'Today',
  'cal.type.invoice': 'Invoice due',
  'cal.type.maintenance': 'Maintenance',
  'cal.type.order': 'Order',
  'cal.type.leave': 'Leave',
  'cal.type.event': 'Event',
  'event.order.confirmed': 'Order confirmed',
  'event.order.credit_hold': 'Order on credit hold',
  'event.order.fulfilled': 'Order fulfilled',
  'event.order.invoiced': 'Order invoiced',
  'event.return.received': 'Return received',
  'event.stock.low': 'Stock below reorder point',
  'event.po.received': 'Goods received for PO',
  'event.po.confirmed': 'Purchase order confirmed',
  'event.po.approval.requested': 'PO approval requested',
  'event.po.approval.decided': 'PO approval decided',
  'event.invoice.posted': 'Invoice posted',
  'event.payment.received': 'Payment received',
  'event.work_order.completed': 'Work order completed',
  'event.work_order.confirmed': 'Work order confirmed',
  'event.payroll.processed': 'Payroll processed',
  'event.leave.requested': 'Leave requested',
  'event.leave.decided': 'Leave decided',
  'event.expense.requested': 'Expense submitted',
  'event.expense.decided': 'Expense decided',
  'event.employee.created': 'Employee created',
  'event.employee.terminated': 'Employee terminated',
  'field.orderNumber': 'Order number',
  'field.orderId': 'Order ID',
  'field.returnNumber': 'Return number',
  'field.returnId': 'Return ID',
  'field.productId': 'Product ID',
  'field.sku': 'SKU',
  'field.productSku': 'SKU',
  'field.quantity': 'Quantity',
  'field.confirmedQuantity': 'Confirmed quantity',
  'field.reorderPoint': 'Reorder point',
  'field.poNumber': 'PO number',
  'field.totalAmount': 'Amount',
  'field.amount': 'Amount',
  'field.approved': 'Approved (yes/no)',
  'field.invoiceNumber': 'Invoice number',
  'field.type': 'Type',
  'field.periodYear': 'Year',
  'field.periodMonth': 'Month',
  'field.payslipCount': 'Payslip count',
  'field.employeeId': 'Employee ID',
  'field.employeeName': 'Employee',
  'field.days': 'Days',
  'field.status': 'Status',
  'field.terminationDate': 'Termination date',
  'cal.day.empty': 'No entries on this day.',
  'cal.day.open': 'Open',
  'cal.event.add': 'Add entry',
  'cal.event.new': 'New entry (visible to everyone)',
  'cal.event.title': 'Title',
  'cal.event.date': 'Date',
  'cal.event.endDate': 'Until (optional)',
  'cal.event.description': 'Description',
  'cal.event.createdBy': 'Added by {name}',

  // Central action inbox
  'inbox.title': 'Action inbox',
  'inbox.subtitle': 'All pending approvals and alerts in one place.',
  'inbox.empty': 'Nothing to do - all clear. 🎉',
  'inbox.metric.total': 'Total pending',
  'inbox.days': 'days',
  'inbox.viewAll': 'View all',
  'inbox.action.approve': 'Approve',
  'inbox.action.reject': 'Reject',
  'inbox.action.read': 'Mark read',
  'inbox.kind.po': 'Order',
  'inbox.kind.req': 'Requisition',
  'inbox.kind.leave': 'Leave',
  'inbox.kind.expense': 'Expense',
  'inbox.kind.alert': 'Alert',
  'inbox.section.po': 'Purchase orders to approve',
  'inbox.section.req': 'Purchase requisitions',
  'inbox.section.leave': 'Leave requests',
  'inbox.section.expense': 'Expenses to approve',
  'inbox.section.alert': 'Automation alerts',
  'nav.accounts':         'Chart of Accounts',
  'nav.invoices':         'Invoices',
  'nav.dunning':          'Dunning',
  'nav.creditNotes': 'Credit notes',
  'nav.recurring':        'Subscriptions',
  'nav.costCenters':      'Cost centers',
  'nav.controlling':      'Controlling',
  'nav.profitCenters':    'Profit centres',
  'nav.downPayments':     'Down payments',
  'nav.intercompany':     'Intercompany',
  'nav.budgets':          'Budget',
  'nav.cashJournal':      'Cash journal',
  'nav.recurringJournals': 'Recurring entries',
  'nav.paymentTerms':     'Payment terms',
  'nav.collectiveInvoice': 'Collective invoice',

  // Collective invoicing
  'ci.title': 'Collective invoicing',
  'ci.subtitle': 'Consolidate several open draft sales invoices for one customer into a single invoice.',
  'ci.empty': 'No open draft sales invoices.',
  'ci.draftsWord': 'drafts',
  'ci.metric.drafts': 'Drafts',
  'ci.metric.customers': 'Customers',
  'ci.metric.selected': 'Selected',
  'ci.col.number': 'No.',
  'ci.col.date': 'Date',
  'ci.col.total': 'Total',
  'ci.combineTitle': 'Combine {n} invoices',
  'ci.invoiceDate': 'Invoice date',
  'ci.dueDate': 'Due date',
  'ci.action.combine': 'Combine',
  'ci.error.min': 'Select at least two invoices.',
  'ci.error.dates': 'Invoice and due date are required.',

  // Payment terms / cash discount
  'pt.title': 'Payment terms',
  'pt.subtitle': 'Net due plus cash discount; the calculator derives the discount and payable per payment date.',
  'pt.empty': 'No payment terms.',
  'pt.days': 'days',
  'pt.col.code': 'Code',
  'pt.col.name': 'Name',
  'pt.col.net': 'Net due',
  'pt.col.discount': 'Discount',
  'pt.action.new': 'New term',
  'pt.action.calc': 'Discount calculator',
  'pt.modal.title': 'New payment term',
  'pt.field.netDays': 'Net days',
  'pt.field.discountDays': 'Discount days',
  'pt.field.discountPercent': 'Discount %',
  'pt.error.required': 'Code, name and net days are required.',
  'pt.calc.title': 'Cash discount calculator',
  'pt.calc.term': 'Term',
  'pt.calc.base': 'Invoice amount',
  'pt.calc.invoiceDate': 'Invoice date',
  'pt.calc.paymentDate': 'Payment date',
  'pt.calc.due': 'Due on',
  'pt.calc.deadline': 'Discount until',
  'pt.calc.discount': 'Discount',
  'pt.calc.payable': 'Payable',
  'pt.calc.within': 'Discount granted',
  'pt.calc.outside': 'No discount (window missed)',
  'pt.error.calcRequired': 'Term, amount and both dates are required.',

  // Recurring journal entries
  'rj.title': 'Recurring journal entries',
  'rj.subtitle': 'Balanced journal templates; a run posts a real journal and reschedules.',
  'rj.empty': 'No templates.',
  'rj.active': 'Active',
  'rj.inactive': 'Inactive',
  'rj.col.description': 'Description',
  'rj.col.frequency': 'Frequency',
  'rj.col.next': 'Next run',
  'rj.col.last': 'Last run',
  'rj.freq.MONTHLY': 'Monthly',
  'rj.freq.QUARTERLY': 'Quarterly',
  'rj.freq.YEARLY': 'Yearly',
  'rj.action.new': 'New template',
  'rj.action.run': 'Post',
  'rj.action.runDue': 'Post due',
  'rj.action.activate': 'Activate',
  'rj.action.deactivate': 'Deactivate',
  'rj.metric.active': 'Active',
  'rj.metric.total': 'Templates',
  'rj.modal.title': 'New journal template',
  'rj.field.nextRun': 'First run',
  'rj.field.lines': 'Journal lines',
  'rj.field.addLine': '+ Line',
  'rj.debit': 'Debit',
  'rj.credit': 'Credit',
  'rj.error.required': 'Description and date are required.',
  'rj.error.unbalanced': 'Debits must equal credits (and be > 0).',

  // Cash journal (FBCJ)
  'cb.title': 'Cash journal',
  'cb.subtitle': 'Petty-cash registers with receipts/payments and a running balance (no negative cash).',
  'cb.empty': 'No entries.',
  'cb.col.number': 'No.',
  'cb.col.date': 'Date',
  'cb.col.type': 'Type',
  'cb.col.description': 'Text',
  'cb.col.amount': 'Amount',
  'cb.col.balance': 'Balance',
  'cb.type.RECEIPT': 'Receipt',
  'cb.type.PAYMENT': 'Payment',
  'cb.action.newJournal': 'New register',
  'cb.action.post': 'Post',
  'cb.metric.balance': 'Cash balance',
  'cb.metric.entries': 'Entries',
  'cb.metric.currency': 'Currency',
  'cb.journal.title': 'New cash register',
  'cb.field.code': 'Code',
  'cb.field.name': 'Name',
  'cb.field.currency': 'Currency',
  'cb.field.category': 'Category',
  'cb.field.reference': 'Reference',
  'cb.error.journalRequired': 'Code and name are required.',
  'cb.post.title': 'Cash entry',
  'cb.error.entryRequired': 'Text and amount are required.',

  // Budget & availability control
  'bud.title': 'Budget',
  'bud.subtitle': 'Budgets per account/period with actuals and availability; manual postings over budget are blocked.',
  'bud.empty': 'No budgets for this year.',
  'bud.over': 'Over budget',
  'bud.within': 'Within budget',
  'bud.col.account': 'Account',
  'bud.col.period': 'Period',
  'bud.col.budgeted': 'Budget',
  'bud.col.actual': 'Actual',
  'bud.col.available': 'Available',
  'bud.action.set': 'Set budget',
  'bud.action.check': 'Check availability',
  'bud.metric.budgeted': 'Total budget',
  'bud.metric.actual': 'Total actual',
  'bud.metric.over': 'Over budget',
  'bud.modal.title': 'Set budget',
  'bud.field.year': 'Year',
  'bud.field.month': 'Month',
  'bud.field.amount': 'Budget amount',
  'bud.error.required': 'Account and amount are required.',
  'bud.check.title': 'Availability control',
  'bud.check.amount': 'Posting amount',
  'bud.check.exceed': 'Would exceed the budget',
  'bud.check.ok': 'Within budget',
  'bud.check.uncontrolled': 'No budget set - not controlled.',
  'bud.error.checkRequired': 'Account and amount are required.',

  // Intercompany postings
  'ic.title': 'Intercompany postings',
  'ic.subtitle': 'Company codes and postings between them; receivable/payable mirrored (group net zero).',
  'ic.col.company': 'Company code',
  'ic.col.receivable': 'Receivable',
  'ic.col.payable': 'Payable',
  'ic.col.net': 'Net',
  'ic.col.doc': 'Document',
  'ic.col.date': 'Date',
  'ic.col.flow': 'From → To',
  'ic.col.description': 'Description',
  'ic.col.amount': 'Amount',
  'ic.action.newCompany': 'New company code',
  'ic.action.newPosting': 'New posting',
  'ic.metric.companies': 'Company codes',
  'ic.metric.receivable': 'Receivables',
  'ic.metric.payable': 'Payables',
  'ic.metric.net': 'Group net',
  'ic.reconciliation': 'Reconciliation per company code',
  'ic.postings': 'Postings',
  'ic.noCompanies': 'No company codes.',
  'ic.noPostings': 'No postings.',
  'ic.company.title': 'New company code',
  'ic.field.name': 'Name',
  'ic.field.currency': 'Currency',
  'ic.error.companyRequired': 'Code and name are required.',
  'ic.posting.title': 'New intercompany posting',
  'ic.posting.from': 'From company',
  'ic.posting.to': 'To company',
  'ic.posting.needTwo': 'At least two company codes are required.',
  'ic.error.postingRequired': 'Both company codes and an amount are required.',
  'ic.error.distinct': 'Source and target company must differ.',

  // Down payments (Anzahlungen)
  'dp.title': 'Down payments',
  'dp.subtitle': 'Request down payments, record their receipt and apply them to the final invoice.',
  'dp.empty': 'No down payments.',
  'dp.col.number': 'No.',
  'dp.col.party': 'Party',
  'dp.col.amount': 'Amount',
  'dp.partyType.CUSTOMER': 'Customer',
  'dp.partyType.VENDOR': 'Vendor',
  'dp.status.REQUESTED': 'Requested',
  'dp.status.RECEIVED': 'Received',
  'dp.status.APPLIED': 'Applied',
  'dp.action.new': 'New down payment',
  'dp.action.receive': 'Record receipt',
  'dp.action.apply': 'Apply',
  'dp.field.partyType': 'Type',
  'dp.field.party': 'Name',
  'dp.field.description': 'Description',
  'dp.modal.title': 'New down payment',
  'dp.error.required': 'Name and amount are required.',
  'dp.apply.title': 'Apply down payment',
  'dp.apply.hint': 'Apply the {amount} down payment from {party} to an open invoice.',
  'dp.apply.invoice': 'Final invoice',
  'dp.apply.open': 'open',
  'dp.apply.noInvoices': 'No open posted invoices available.',
  'dp.error.invoiceRequired': 'Please select an invoice.',

  // Profit centre accounting (CO)
  'pc.title': 'Profit centres',
  'pc.subtitle': 'Profit centre master data with revenue/expense postings and result per profit centre.',
  'pc.empty': 'No profit centres.',
  'pc.inactive': 'Inactive',
  'pc.col.code': 'Code',
  'pc.col.name': 'Name',
  'pc.col.revenue': 'Revenue',
  'pc.col.expense': 'Expense',
  'pc.col.result': 'Result',
  'pc.action.new': 'New profit centre',
  'pc.action.post': 'Post',
  'pc.metric.revenue': 'Total revenue',
  'pc.metric.expense': 'Total expense',
  'pc.metric.result': 'Total result',
  'pc.modal.title': 'New profit centre',
  'pc.field.description': 'Description',
  'pc.error.required': 'Code and name are required.',
  'pc.post.title': 'Profit centre posting',
  'pc.post.type': 'Type',
  'pc.error.postRequired': 'Profit centre and amount are required.',
  'pc.type.REVENUE': 'Revenue',
  'pc.type.EXPENSE': 'Expense',
  'nav.reportBuilder':    'Report builder',

  // Report builder
  'rb.title': 'Report builder',
  'rb.subtitle': 'Compose your own reports, save them and export to CSV.',
  'rb.source': 'Data source',
  'rb.groupBy': 'Group by',
  'rb.noGroup': '- no grouping -',
  'rb.limit': 'Limit',
  'rb.fields': 'Fields',
  'rb.filters': 'Filters',
  'rb.value': 'Value',
  'rb.addFilter': '+ Filter',
  'rb.run': 'Run',
  'rb.save': 'Save',
  'rb.savePrompt': 'Report name:',
  'rb.exportCsv': 'Export CSV',
  'rb.noRows': 'No records.',
  'rb.saved': 'Saved reports',
  'rb.load': 'Load',
  'rb.delete': 'Delete',
  'rb.src.invoices': 'Invoices',
  'rb.src.cost_center_postings': 'CO postings',
  'rb.op.eq': 'equals',
  'rb.op.neq': 'not equal',
  'rb.op.gt': 'greater than',
  'rb.op.gte': 'at least',
  'rb.op.lt': 'less than',
  'rb.op.lte': 'at most',
  'rb.op.contains': 'contains',

  // Controlling (CO) - plan/actual/variance
  'co.title': 'Controlling',
  'co.subtitle': 'Cost-center plan vs. actual with variance per fiscal year.',
  'co.empty': 'No cost centers.',
  'co.col.code': 'Cost center',
  'co.col.name': 'Name',
  'co.col.plan': 'Plan',
  'co.col.actual': 'Actual',
  'co.col.variance': 'Variance',
  'co.metric.plan': 'Total plan',
  'co.metric.actual': 'Total actual',
  'co.metric.variance': 'Variance',
  'co.action.setPlan': 'Set plan',
  'co.action.postCost': 'Post cost',
  'co.field.costCenter': 'Cost center',
  'co.field.plannedAmount': 'Planned amount',
  'co.field.date': 'Posting date',
  'co.field.amount': 'Amount',
  'co.field.description': 'Description',
  'co.field.reference': 'Reference',
  'co.plan.title': 'Annual plan',
  'co.post.title': 'Cost posting',
  'co.error.required': 'Cost center and planned amount are required.',
  'co.error.postRequired': 'Cost center, date and a positive amount are required.',
  'nav.bank':             'Bank reconciliation',
  'nav.paymentRuns':      'Payment run',

  // Payment run (F110)
  'pr.title': 'Payment run',
  'pr.subtitle': 'Bundle open vendor invoices and settle them in one run.',
  'pr.empty': 'No payment runs.',
  'pr.col.number': 'No.',
  'pr.col.paymentDate': 'Payment date',
  'pr.col.dueBy': 'Due by',
  'pr.col.count': 'Items',
  'pr.col.total': 'Total',
  'pr.status.PROPOSED': 'Proposal',
  'pr.status.EXECUTED': 'Executed',
  'pr.status.CANCELLED': 'Cancelled',
  'pr.action.new': 'New payment run',
  'pr.action.view': 'Open',
  'pr.action.execute': 'Execute',
  'pr.action.cancel': 'Cancel',
  'pr.metric.proposed': 'Proposals',
  'pr.metric.executed': 'Executed',
  'pr.field.dueBy': 'Due by',
  'pr.modal.title': 'Create payment proposal',
  'pr.modal.hint': 'Open CHF vendor invoices due on/before the selected date are proposed.',
  'pr.modal.propose': 'Create proposal',
  'pr.modal.creating': 'Creating',
  'pr.error.required': 'Payment date and due date are required.',
  'pr.detail.executed': '{n} invoice(s) paid.',
  'pr.detail.noItems': 'No due invoices.',
  'pr.item.invoice': 'Invoice',
  'pr.item.amount': 'Amount',
  'pr.item.state': 'State',
  'pr.item.paid': 'Paid',
  'pr.item.failed': 'Failed',
  'pr.item.pending': 'Proposed',
  'nav.vat':              'VAT return',
  'bank.title': 'Bank reconciliation',
  'bank.subtitle': 'Import bank statements and match payments to invoices',
  'bank.loading': 'Loading',
  'bank.tab.unmatched': 'Open',
  'bank.tab.matched': 'Matched',
  'bank.tab.ignored': 'Ignored',
  'bank.col.date': 'Date',
  'bank.col.direction': 'Direction',
  'bank.col.amount': 'Amount',
  'bank.col.reference': 'Reference',
  'bank.col.counterparty': 'Counterparty',
  'bank.col.suggestion': 'Suggestion',
  'bank.dir.credit': 'Incoming',
  'bank.dir.debit': 'Outgoing',
  'bank.action.import': 'Import statement',
  'bank.action.match': 'Match',
  'bank.action.ignore': 'Ignore',
  'bank.empty.unmatched': 'No open transactions',
  'bank.empty.matched': 'No matched transactions yet',
  'bank.empty.ignored': 'No ignored transactions',
  'bank.import.title': 'Import bank statement',
  'bank.import.fileLabel': 'File (CAMT.053 XML or CSV)',
  'bank.import.formatLabel': 'Format',
  'bank.import.formatCamt': 'CAMT.053 (XML)',
  'bank.import.formatCsv': 'CSV',
  'bank.import.action': 'Import',
  'bank.import.success': '{count} transactions imported',
  'bank.import.fileRequired': 'Please select a file first',
  'bank.match.title': 'Match transaction',
  'bank.match.invoiceLabel': 'Invoice',
  'bank.match.placeholder': 'Select an invoice …',
  'bank.match.open': 'Open',
  'bank.match.confirm': 'Match',
  'bank.match.noCandidates': 'No matching open invoices found',
  'bank.match.selectRequired': 'Please select an invoice',
  'bank.ignore.title': 'Ignore transaction',
  'bank.ignore.message': 'This transaction will be marked as ignored and removed from the list of open transactions.',
  'cc.title': 'Cost centers',
  'cc.subtitle': 'Budget vs. actual per cost center',
  'cc.action.new': 'New cost center',
  'cc.action.edit': 'Edit',
  'cc.empty': 'No cost centers yet',
  'cc.active': 'Active',
  'cc.inactive': 'Inactive',
  'cc.metric.count': 'Cost centers',
  'cc.metric.budget': 'Total budget',
  'cc.metric.actual': 'Total actual',
  'cc.metric.utilization': 'Utilization',
  'cc.col.code': 'Code',
  'cc.col.name': 'Name',
  'cc.col.budget': 'Budget',
  'cc.col.actual': 'Actual',
  'cc.col.remaining': 'Remaining',
  'cc.col.utilization': 'Utilization',
  'cc.modal.title': 'New cost center',
  'cc.modal.editTitle': 'Edit cost center',
  'cc.field.code': 'Code',
  'cc.field.name': 'Name',
  'cc.field.budget': 'Annual budget',
  'cc.field.parent': 'Parent cost center',
  'cc.field.noParent': '- none -',
  'cc.field.currency': 'Currency',
  'cc.field.active': 'Active',
  'cc.field.notes': 'Notes',
  'dunning.title': 'Dunning',
  'dunning.subtitle': 'Detect overdue invoices and send reminders',
  'dunning.tab.overdue': 'Overdue',
  'dunning.tab.notices': 'Reminders',
  'dunning.level': 'Level',
  'dunning.maxReached': 'Max level reached',
  'dunning.action.create': 'Reminder level',
  'dunning.action.markPaid': 'Paid',
  'dunning.action.view': 'View',
  'dunning.print.heading': 'Payment reminder',
  'dunning.print.greeting': 'Dear Sir or Madam',
  'dunning.print.body': 'Despite the due date, the invoice listed below is still open. Please settle the outstanding amount including the reminder fee by the date stated below.',
  'dunning.print.amountDue': 'Outstanding invoice amount',
  'dunning.print.total': 'Amount due (incl. fee)',
  'dunning.print.payBy': 'Payable by',
  'dunning.print.closing': 'If you have any questions, please get in touch. Kind regards',
  'dunning.action.cancel': 'Cancel',
  'dunning.empty.overdue': 'No overdue invoices 🎉',
  'dunning.empty.notices': 'No reminders yet',
  'dunning.metric.overdue': 'Overdue invoices',
  'dunning.metric.outstanding': 'Outstanding amount',
  'dunning.metric.openNotices': 'Open reminders',
  'dunning.metric.totalNotices': 'Total reminders',
  'dunning.col.invoice': 'Invoice',
  'dunning.col.daysOverdue': 'Days overdue',
  'dunning.col.outstanding': 'Outstanding',
  'dunning.col.lastLevel': 'Last level',
  'dunning.col.date': 'Date',
  'dunning.col.level': 'Level',
  'dunning.col.fee': 'Fee',
  'dunning.status.OPEN': 'Open',
  'dunning.status.PAID': 'Paid',
  'dunning.status.CANCELLED': 'Cancelled',
  'nav.reports':          'Reports',
  'nav.employees':        'Employees',
  'nav.leave':            'Leave',
  'nav.payroll':          'Payroll',
  'nav.products':         'Products',
  'nav.lowStock':         'Low Stock',
  'nav.purchaseOrders':   'Purchase Orders',
  'nav.customers':        'Customers',
  'nav.orders':           'Orders',
  'nav.creditManagement': 'Credit management',

  // Credit management
  'cm.title': 'Credit management',
  'cm.subtitle': 'Release/reject credit-blocked orders; credit limit & exposure per customer.',
  'cm.empty': 'No blocked orders.',
  'cm.holds': 'Credit hold queue',
  'cm.lookup': 'Credit overview per customer',
  'cm.selectCustomer': 'Select a customer…',
  'cm.col.order': 'Order',
  'cm.col.customer': 'Customer',
  'cm.col.amount': 'Amount',
  'cm.col.date': 'Date',
  'cm.action.release': 'Release',
  'cm.action.reject': 'Reject',
  'cm.metric.holds': 'Blocked orders',
  'cm.metric.blocked': 'Blocked value',
  'cm.limit': 'Credit limit',
  'cm.exposure': 'Exposure (open)',
  'cm.available': 'Available',
  'cm.unlimited': 'Unlimited',
  'cm.within': 'Within limit',
  'cm.exceeded': 'Limit exceeded',
  'nav.deliveries': 'Delivery notes',
  'delivery.title': 'Delivery notes',
  'delivery.subtitle': 'All shipments from fulfilled orders.',
  'delivery.empty': 'No delivery notes yet.',
  'delivery.shipping': 'Shipping details',
  'delivery.carrier': 'Carrier / method',
  'delivery.tracking': 'Tracking no.',
  'delivery.packages': 'Packages',
  'delivery.weight': 'Weight (kg)',
  'delivery.deliveryDate': 'Delivery date',
  'delivery.shippingDate': 'Shipping date',
  'delivery.qtyDelivered': 'Delivered qty',
  'delivery.print.heading': 'Delivery note',
  'delivery.print.shipTo': 'Ship to',
  'nav.pipeline':         'Pipeline',
  'nav.settings':         'Settings',

  'dashboard.title':       'Dashboard',
  'dashboard.subtitle':    'Live snapshot of revenue, cash, AR/AP, and pipeline forecast.',
  'dashboard.config.button': 'Customize',
  'dashboard.config.title':  'Customize dashboard',
  'dashboard.config.intro':  'Choose which metrics and charts to display.',
  'dashboard.config.all':    'All',
  'dashboard.revenue':     'Revenue (period)',
  'dashboard.expenses':    'Expenses (period)',
  'dashboard.netProfit':   'Net profit',
  'dashboard.cash':        'Cash on hand',
  'dashboard.ar':          'Accounts receivable',
  'dashboard.ap':          'Accounts payable',
  'dashboard.openSales':   'Open sales invoices',
  'dashboard.openPurchases': 'Open purchase invoices',
  'dashboard.overdue':       'Overdue (receivables)',
  'dashboard.forecast':    'Pipeline forecast',
  'dashboard.chartTitle':  'Revenue vs expenses',
  'dashboard.deltaPrevMonth': 'vs. prior month',

  // Dashboard: action center + empty states
  'dashboard.actions.title': 'Needs attention',
  'dashboard.actions.creditHolds': 'orders on credit hold',
  'dashboard.actions.backordersReady': 'backorders ready to fulfill',
  'dashboard.actions.poApprovals': 'POs awaiting approval',
  'dashboard.actions.banfPending': 'requisitions to approve',
  'dashboard.actions.overdueAr': 'invoices overdue',
  'dashboard.actions.recurringDue': 'recurring entries due',
  'dashboard.actions.toInbox': 'All tasks →',
  'dashboard.empty.trend': 'No postings yet - create your first invoice.',
  'dashboard.empty.trendCta': 'Create invoice',
  'dashboard.empty.pipeline': 'No opportunities in the pipeline yet.',
  'dashboard.empty.pipelineCta': 'Create first opportunity',
  'dashboard.empty.agingGood': 'No overdue receivables - all clear.',

  // Insight bars (generic) + detail metrics
  'insight.byStatus': 'By status',
  'insight.byType': 'By type',
  'insight.bySeverity': 'By severity',
  'insight.bySource': 'By source',
  'insight.byStage': 'By stage',
  'insight.byCarrier': 'By carrier',
  'insight.byDirection': 'By direction',
  'insight.count': 'Count',
  'insight.active': 'Active',
  'insight.inactive': 'Inactive',
  'insight.total': 'Total',
  'insight.open': 'Open',
  'inv.products.insight.avgPrice': 'Avg. list price',
  'inv.suppliers.insight.withEmail': 'With email',
  'inv.movements.insight.totalValue': 'Total goods value',
  'inv.movements.insight.inflow': 'Inbound',
  'inv.movements.insight.outflow': 'Outbound',
  'inv.lowStock.insight.affected': 'Affected items',
  'inv.lowStock.insight.outOfStock': 'Out of stock',
  'inv.lowStock.insight.shortfall': 'Total shortfall',
  'hr.employees.insight.headcount': 'Headcount',
  'hr.employees.insight.payrollSum': 'Payroll total',
  'hr.employees.insight.avgSalary': 'Avg. salary',
  'hr.payroll.insight.runs': 'Payroll runs',
  'hr.payroll.insight.gross': 'Total gross',
  'hr.payroll.insight.net': 'Total net',
  'hr.payroll.insight.deductions': 'Deductions',
  'hr.leave.insight.requests': 'Requests',
  'hr.leave.insight.days': 'Total days',
  'rec.candidates.insight.sources': 'Sources',
  'rec.candidates.insight.withPhone': 'With phone',
  'rec.applications.insight.hireRate': 'Hire rate',
  'projects.insight.budget': 'Total budget',
  'projects.insight.spent': 'Spent',
  'finance.accounts.insight.types': 'Account types',
  'creditNote.insight.postedSum': 'Posted (total)',
  'delivery.insight.thisMonth': 'This month',
  'delivery.insight.withTracking': 'With tracking',
  'delivery.insight.carriers': 'Carriers',
  'bank.insight.inflow': 'Inflows',
  'bank.insight.outflow': 'Outflows',
  'bank.insight.balance': 'Balance',
  'detail.metric.total': 'Total',
  'detail.metric.paid': 'Paid',
  'detail.metric.outstanding': 'Outstanding',
  'detail.metric.dueInDays': 'Due in (days)',
  'detail.metric.overdueDays': 'Overdue (days)',
  'detail.metric.date': 'Date',
  'detail.metric.validUntil': 'Valid until',
  'detail.metric.expected': 'Expected on',
  'detail.metric.creditLimit': 'Credit limit',

  'settings.title':        'Settings',
  'settings.subtitle':     'Personal settings for your account.',
  'settings.nav.general':       'General',
  'settings.nav.general.desc':  'Appearance, language and currency.',
  'settings.nav.company':       'Company',
  'settings.nav.users':         'Users & Roles',
  'settings.nav.currencies': 'Currencies & rates',
  'settings.nav.currencies.desc': 'Enable foreign currencies and maintain exchange rates.',
  'settings.appearance':   'Appearance',
  'settings.appearance.intro':       'Choose how the interface should look.',
  'settings.appearance.active':      'Active:',
  'settings.appearance.followsSystem':'(follows your system)',
  'settings.theme.light':       'Light',
  'settings.theme.light.desc':  'Light surfaces, dark text.',
  'settings.theme.dark':        'Dark',
  'settings.theme.dark.desc':   'Dark background, easy on the eyes at night.',
  'settings.theme.system':      'System',
  'settings.theme.system.desc': 'Follows your device system setting.',
  'settings.language':          'Language',
  'settings.language.intro':    'Interface language.',
  'settings.language.de':       'Deutsch',
  'settings.language.de.desc':  'Standard.',
  'settings.language.en':       'English',
  'settings.language.en.desc':  'English interface.',
  'settings.language.fr':       'Français',
  'settings.language.fr.desc':  'Interface en français.',
  'settings.currency':          'Currency',
  'settings.currency.intro':    'Display currency for all amounts.',
  'settings.currency.CHF':      'Swiss Franc (CHF)',
  'settings.currency.CHF.desc': 'Default.',
  'settings.currency.EUR':      'Euro (EUR)',
  'settings.currency.EUR.desc': 'Show amounts in euros.',
  'settings.currency.USD':      'US Dollar (USD)',
  'settings.currency.USD.desc': 'Show amounts in US dollars.',
  'settings.currency.GBP':      'British Pound (GBP)',
  'settings.currency.GBP.desc': 'Show amounts in pounds.',

  'finance.accounts.action.new': 'New account',
  'finance.accounts.modal.title': 'New account',
  'finance.accounts.modal.parent': 'Parent account (optional)',
  'finance.invoices.action.new': 'New invoice',
  'finance.invoices.modal.title': 'New invoice',
  'finance.invoices.modal.customer': 'Customer',
  'finance.invoices.modal.vendor': 'Vendor',
  'finance.invoices.modal.invoiceDate': 'Invoice date',
  'finance.invoices.modal.dueDate': 'Due date',
  'finance.invoices.modal.notes': 'Notes',
  'finance.invoices.modal.lines': 'Invoice lines',
  'finance.invoices.modal.addLine': 'Add line',
  'finance.invoices.modal.removeLine': 'Remove',
  'finance.invoices.modal.account': 'Account',
  'finance.invoices.modal.lineDescription': 'Description',
  'finance.invoices.modal.quantity': 'Quantity',
  'finance.invoices.modal.unitPrice': 'Unit price',
  'finance.invoices.modal.lineTotal': 'Line total',
  'finance.invoices.modal.invoiceTotal': 'Invoice total',
  'finance.invoices.modal.pickCounterparty': '- Please select -',
  'finance.invoices.modal.searchCounterparty': 'Search (code, name, email)…',
  'finance.invoices.modal.noCounterparty': 'No matches',
  'finance.invoices.action.pay': 'Pay',
  'finance.invoices.pay.title': 'Record payment',
  'finance.invoices.pay.outstanding': 'Outstanding',
  'finance.invoices.pay.amount': 'Payment amount',
  'finance.invoices.pay.date': 'Payment date',

  // 3-way match (purchase order <-> goods receipt <-> purchase invoice)
  'match.title': '3-Way-Match',
  'match.status.MATCHED': 'Matched',
  'match.status.OVER_BILLED': 'Over-billed',
  'match.status.UNDER_BILLED': 'Under-billed',
  'match.status.NO_RECEIPT': 'No goods receipt',
  'match.receivedAt': 'Received on',
  'match.receivedValue': 'Received value',
  'match.billedNet': 'Billed (net)',
  'match.difference': 'Difference',
  'match.unitCost': 'Unit cost',
  'match.lineValue': 'Value',
  'match.poSelect': 'Purchase order (3-way match)',
  'match.poNone': 'None',
  'match.overWarning': 'Invoice exceeds the received value by {diff}.',
  'match.forceLabel': 'Pay despite the mismatch (override)',
  'match.underHint': 'Invoice is below the received value.',
  'match.noReceiptHint': 'No goods-receipt match possible (no complete goods receipt recorded).',
  'match.okHint': 'Matched against the goods receipt.',
  'match.alreadyBilled': 'Invoice {number} already exists for this purchase order.',

  'hr.employees.action.new': 'New employee',
  'hr.employees.action.terminate': 'Terminate',
  'hr.employees.modal.title': 'New employee',
  'hr.employees.modal.firstName': 'First name',
  'hr.employees.modal.lastName': 'Last name',
  'hr.employees.modal.phone': 'Phone',
  'hr.employees.modal.hireDate': 'Hire date',
  'hr.employees.modal.department': 'Department',
  'hr.employees.modal.position': 'Position',
  'hr.employees.modal.baseSalary': 'Base salary',
  'hr.employees.modal.currency': 'Currency',
  'hr.employees.modal.optional': '- None -',
  'hr.employees.terminate.title': 'Terminate employee',
  'hr.employees.terminate.date': 'Termination date',
  'hr.employees.terminate.confirm': 'Confirm termination of',
  'hr.leave.action.new': 'New request',
  'hr.leave.modal.title': 'New leave request',
  'hr.leave.modal.employee': 'Employee',
  'hr.leave.modal.leaveType': 'Leave type',
  'hr.leave.modal.startDate': 'Start date',
  'hr.leave.modal.endDate': 'End date',
  'hr.leave.modal.reason': 'Reason',
  'hr.payroll.action.new': 'New run',
  'hr.payroll.modal.title': 'New payroll run',
  'hr.payroll.modal.year': 'Year',
  'hr.payroll.modal.month': 'Month',
  'hr.payroll.modal.note': 'The run processes every active employee for the selected period.',

  'month.1': 'January',
  'month.2': 'February',
  'month.3': 'March',
  'month.4': 'April',
  'month.5': 'May',
  'month.6': 'June',
  'month.7': 'July',
  'month.8': 'August',
  'month.9': 'September',
  'month.10': 'October',
  'month.11': 'November',
  'month.12': 'December',

  'nav.suppliers': 'Suppliers',
  'nav.stockMovements': 'Stock Movements',

  'inv.suppliers.title': 'Suppliers',
  'inv.suppliers.subtitle': 'Master supplier data for purchase orders.',
  'inv.suppliers.action.new': 'New supplier',
  'inv.suppliers.modal.title': 'New supplier',
  'inv.suppliers.modal.address': 'Address',
  'inv.suppliers.modal.phone': 'Phone',

  'inv.po.action.new': 'New purchase order',
  'inv.po.action.receive': 'Receive',
  'inv.po.action.cancel': 'Cancel',
  'inv.po.modal.title': 'New purchase order',
  'inv.po.modal.supplier': 'Supplier',
  'inv.po.modal.warehouse': 'Warehouse',
  'inv.po.modal.orderDate': 'Order date',
  'inv.po.modal.expectedDate': 'Expected date',
  'inv.po.modal.notes': 'Notes',
  'inv.po.modal.lines': 'PO lines',
  'inv.po.modal.product': 'Product',
  'inv.po.modal.quantity': 'Quantity',
  'inv.po.modal.unitCost': 'Unit cost',
  'inv.po.modal.lineTotal': 'Line total',
  'inv.po.modal.poTotal': 'PO total',
  'inv.po.modal.pickProduct': '- Choose product -',
  'inv.po.receive.title': 'Receive goods',
  'inv.po.receive.intro': 'Confirm the quantity actually received for each line. Empty or 0 = nothing received.',
  'inv.po.receive.ordered': 'Ordered',
  'inv.po.receive.alreadyReceived': 'Already',
  'inv.po.receive.outstanding': 'Outstanding',
  'inv.po.receive.thisReceipt': 'Received now',

  'inv.movements.title': 'Stock Movements',
  'inv.movements.subtitle': 'Every receipt, issue, transfer, and adjustment.',
  'inv.movements.action.receive': 'Receive',
  'inv.movements.action.issue': 'Issue',
  'inv.movements.action.transfer': 'Transfer',
  'inv.movements.action.adjust': 'Adjust',
  'inv.movements.col.date': 'Date',
  'inv.movements.col.product': 'Product',
  'inv.movements.col.warehouse': 'Warehouse',
  'inv.movements.col.type': 'Type',
  'inv.movements.col.quantity': 'Quantity',
  'inv.movements.col.unitCost': 'Unit cost',
  'inv.movements.col.totalCost': 'Total cost',
  'inv.movements.col.notes': 'Notes',
  'inv.movements.type.IN': 'Receipt',
  'inv.movements.type.OUT': 'Issue',
  'inv.movements.type.TRANSFER_IN': 'Transfer in',
  'inv.movements.type.TRANSFER_OUT': 'Transfer out',
  'inv.movements.type.ADJUSTMENT': 'Adjustment',
  'inv.movements.empty': 'No movements yet',
  'inv.movements.receive.title': 'Receive stock',
  'inv.movements.issue.title': 'Issue stock',
  'inv.movements.transfer.title': 'Transfer stock',
  'inv.movements.adjust.title': 'Adjust stock',
  'inv.movements.modal.product': 'Product',
  'inv.movements.modal.warehouse': 'Warehouse',
  'inv.movements.modal.fromWarehouse': 'Source warehouse',
  'inv.movements.modal.toWarehouse': 'Destination warehouse',
  'inv.movements.modal.quantity': 'Quantity',
  'inv.movements.modal.delta': 'Delta (+/-)',
  'inv.movements.modal.unitCost': 'Unit cost',
  'inv.movements.modal.notes': 'Note',
  'inv.movements.adjust.note': 'Positive = replenishment (requires unit cost). Negative = shrinkage / write-off.',

  'nav.quotes': 'Quotes',

  'sales.quotes.title': 'Quotes',
  'sales.quotes.subtitle': 'Quotes to your customers: create, send, record their decision and convert into orders.',
  'sales.quotes.insight.dist': 'Quotes by status',
  'sales.quotes.insight.open': 'Open quotes',
  'sales.quotes.insight.openValue': 'Open value',
  'sales.quotes.insight.acceptance': 'Acceptance rate',
  'sales.quotes.insight.expiring': 'Expiring soon',
  'sales.quotes.action.new': 'New quote',
  'sales.quotes.action.send': 'Send to customer',
  'sales.quotes.action.accept': 'Customer accepted',
  'sales.quotes.action.reject': 'Customer declined',
  'sales.quotes.action.convert': 'Convert to order',
  'sales.quotes.col.validUntil': 'Valid until',
  'sales.quotes.empty': 'No quotes yet',
  'sales.quotes.modal.title': 'New quote',
  'sales.quotes.modal.editTitle': 'Edit quote',
  'sales.quotes.modal.customer': 'Customer',
  'sales.quotes.modal.quoteDate': 'Quote date',
  'sales.quotes.modal.validUntil': 'Valid until',
  'sales.quotes.modal.notes': 'Notes',
  'sales.quotes.modal.lines': 'Quote lines',
  'sales.quotes.modal.product': 'Product',
  'sales.quotes.modal.description': 'Description',
  'sales.quotes.modal.quantity': 'Quantity',
  'sales.quotes.modal.unitPrice': 'Sales price',
  'sales.quotes.modal.lineTotal': 'Line total',
  'sales.quotes.modal.quoteTotal': 'Quote total',
  'sales.quotes.convert.title': 'Convert quote to order',
  'sales.quotes.convert.intro': 'The order is created from this quote. You can adjust the order date and the required delivery date.',
  'sales.quotes.convert.orderDate': 'Order date',
  'sales.quotes.convert.requiredDate': 'Required date',

  'sales.orders.action.new': 'New order',
  'sales.orders.action.fulfill': 'Fulfil',
  'sales.orders.action.email': 'Send confirmation',
  'sales.orders.modal.title': 'New sales order',
  'sales.orders.modal.customer': 'Customer',
  'sales.orders.modal.orderDate': 'Order date',
  'sales.orders.modal.requiredDate': 'Required date',
  'sales.orders.modal.notes': 'Notes',
  'sales.orders.modal.lines': 'Order lines',
  'sales.orders.modal.product': 'Product',
  'sales.orders.modal.description': 'Description',
  'sales.orders.modal.quantity': 'Quantity',
  'sales.orders.modal.unitPrice': 'Sales price',
  'sales.orders.modal.lineTotal': 'Line total',
  'sales.orders.modal.orderTotal': 'Order total',
  'sales.orders.fulfill.title': 'Record fulfilment',
  'sales.orders.fulfill.intro': 'Enter the quantity shipped per line. When every line is fully shipped, the order flips to FULFILLED and the AR invoice is generated automatically.',
  'sales.orders.fulfill.ordered': 'Ordered',
  'sales.orders.fulfill.already': 'Already',
  'sales.orders.fulfill.outstanding': 'Outstanding',
  'sales.orders.fulfill.now': 'Fulfilled now',

  'detail.back': 'Back',
  'detail.header': 'Header',
  'detail.lines': 'Lines',
  'detail.related': 'Related',
  'flow.title': 'Document flow',
  'flow.quote': 'Quote',
  'flow.order': 'Order',
  'flow.delivery': 'Delivery',
  'flow.invoice': 'Invoice',
  'flow.creditNote': 'Credit note',
  'flow.return': 'Return',
  'flow.none': '-',
  'detail.actions': 'Actions',
  'detail.created': 'Created',
  'detail.updated': 'Updated',
  'detail.postedAt': 'Posted',
  'detail.fulfilledAt': 'Fulfilled',
  'detail.confirmedAt': 'Confirmed',
  'detail.receivedAt': 'Received',
  'detail.invoicedAt': 'Invoiced',
  'detail.closedAt': 'Closed',
  'detail.subtotal': 'Subtotal',
  'detail.outstanding': 'Outstanding',
  'detail.notes': 'Notes',
  'detail.fromQuote': 'From quote',
  'detail.toInvoice': 'Invoice',
  'detail.fromOrder': 'From order',
  'detail.fromPO': 'From PO',
  'detail.linkedInvoice': 'Linked invoice',
  'detail.lineDescription': 'Description',
  'detail.lineQty': 'Quantity',
  'detail.lineFulfilled': 'Fulfilled',
  'detail.lineReceived': 'Received',
  'detail.lineUnitPrice': 'Unit price',
  'detail.lineUnitCost': 'Unit cost',
  'detail.lineTotal': 'Total',
  'detail.lineAccount': 'Account',
  'detail.lineProduct': 'Product',

  'nav.section.recruitment': 'Recruitment',
  'nav.jobPostings': 'Job Postings',
  'nav.candidates': 'Candidates',
  'nav.applications': 'Applications',

  'stage.APPLIED': 'Applied',
  'stage.SCREEN': 'Screening',
  'stage.INTERVIEW': 'Interview',
  'stage.OFFER': 'Offer',
  'stage.HIRED': 'Hired',
  'stage.REJECTED': 'Rejected',

  'rec.postings.title': 'Job Postings',
  'rec.postings.subtitle': 'Open and closed positions.',
  'rec.postings.action.new': 'New posting',
  'rec.postings.col.title': 'Title',
  'rec.postings.col.opens': 'Opens',
  'rec.postings.col.closes': 'Closes',
  'rec.postings.empty': 'No postings yet',
  'rec.postings.action.pause': 'Pause',
  'rec.postings.action.reopen': 'Reopen',
  'rec.postings.action.close': 'Close',
  'rec.postings.modal.title': 'New job posting',
  'rec.postings.modal.titleField': 'Title',
  'rec.postings.modal.department': 'Department',
  'rec.postings.modal.position': 'Position',
  'rec.postings.modal.description': 'Description',
  'rec.postings.modal.opensAt': 'Opens at',
  'rec.postings.modal.closesAt': 'Closes at',

  'rec.candidates.title': 'Candidates',
  'rec.candidates.subtitle': 'Applicant pool across all postings.',
  'rec.candidates.action.new': 'New candidate',
  'rec.candidates.col.source': 'Source',
  'rec.candidates.col.phone': 'Phone',
  'rec.candidates.empty': 'No candidates yet',
  'rec.candidates.modal.title': 'New candidate',
  'rec.candidates.modal.firstName': 'First name',
  'rec.candidates.modal.lastName': 'Last name',
  'rec.candidates.modal.phone': 'Phone',
  'rec.candidates.modal.source': 'Source',
  'rec.candidates.modal.resumeUrl': 'Resume URL',
  'rec.candidates.modal.notes': 'Notes',

  'rec.applications.title': 'Applications',
  'rec.applications.subtitle': 'Applications with their pipeline stage per posting.',
  'rec.applications.action.new': 'New application',
  'rec.applications.col.candidate': 'Candidate',
  'rec.applications.col.posting': 'Posting',
  'rec.applications.col.stage': 'Stage',
  'rec.applications.empty': 'No applications yet',
  'rec.applications.filterStage.all': 'All stages',
  'rec.applications.modal.title': 'New application',
  'rec.applications.modal.posting': 'Job posting',
  'rec.applications.modal.candidate': 'Candidate',
  'rec.applications.modal.notes': 'Notes',
  'nav.financeDashboard': 'Overview',
  'common.noData': 'No data for this period',
  'finance.dashboard.title': 'Financial Overview',
  'finance.dashboard.subtitle': 'KPIs and trends at a glance',
  'finance.dashboard.lastMonths': 'Last {count} months',
  'finance.chart.trend': 'Revenue, Cost & Profit',
  'finance.chart.trendSub': 'Monthly trend',
  'finance.chart.aging': 'Outstanding Receivables (Aging)',
  'finance.chart.openAr': 'Open receivables',
  'finance.chart.expenseBreakdown': 'Expense Breakdown',
  'finance.chart.invoiceStatus': 'Invoices by Status',
  'finance.chart.invoiceCount': 'Invoice count',
  'nav.salesDashboard': 'Overview',
  'sales.dashboard.title': 'Sales Overview',
  'sales.dashboard.subtitle': 'Orders, pipeline and top customers at a glance',
  'sales.dashboard.lastMonths': 'Last {count} months',
  'sales.metric.revenue': 'Booked revenue',
  'sales.metric.orders': 'Orders',
  'sales.metric.openPipeline': 'Open pipeline',
  'sales.metric.weighted': 'Weighted pipeline',
  'sales.chart.bookings': 'Order Bookings',
  'sales.chart.bookingsSub': 'Monthly revenue',
  'sales.chart.revenue': 'Revenue',
  'sales.chart.pipeline': 'Pipeline by Stage',
  'sales.chart.pipelineAmount': 'Pipeline amount',
  'sales.chart.orderStatus': 'Orders by Status',
  'sales.chart.topCustomers': 'Top Customers by Revenue',
  'nav.inventoryDashboard': 'Overview',
  'inventory.dashboard.title': 'Inventory Overview',
  'inventory.dashboard.subtitle': 'Stock value, movements and purchase orders at a glance',
  'inventory.dashboard.lastMonths': 'Last {count} months',
  'inventory.metric.stockValue': 'Stock value',
  'inventory.metric.openPo': 'Open purchase orders (value)',
  'inventory.metric.openPoCount': 'Open purchase orders',
  'inventory.metric.categories': 'Categories',
  'inventory.chart.movements': 'Stock Movements',
  'inventory.chart.movementsSub': 'Inbound vs outbound per month',
  'inventory.chart.inbound': 'Inbound',
  'inventory.chart.outbound': 'Outbound',
  'inventory.chart.stockValue': 'Stock Value by Category',
  'inventory.chart.poStatus': 'Purchase Orders by Status',
  'inventory.chart.poCount': 'Order count',
  'inventory.chart.topProducts': 'Top Products by Stock Value',
  'nav.hrDashboard': 'Overview',
  'hr.dashboard.title': 'HR Overview',
  'hr.dashboard.subtitle': 'Headcount, payroll cost and recruiting at a glance',
  'hr.dashboard.lastMonths': 'Last {count} months',
  'hr.metric.headcount': 'Active headcount',
  'hr.metric.payroll': 'Payroll cost (latest run)',
  'hr.metric.applications': 'Applications',
  'hr.metric.hired': 'Hired',
  'hr.chart.payroll': 'Payroll Cost Trend',
  'hr.chart.payrollSub': 'Gross, net & tax per month',
  'hr.chart.gross': 'Gross',
  'hr.chart.net': 'Net',
  'hr.chart.tax': 'Tax',
  'hr.chart.headcount': 'Headcount by Department',
  'hr.chart.employeeStatus': 'Employees by Status',
  'hr.chart.recruitment': 'Recruitment Funnel',
  'hr.chart.applications': 'Applications',
  'dashboard.pipeline': 'Sales Pipeline',

  // Projects
  'nav.section.projects': 'Projects',
  'nav.projectsDashboard': 'Overview',
  'nav.projectsList': 'Projects',

  // Production (PP)
  'nav.section.production': 'Production',
  'nav.productionDashboard': 'Overview',
  'nav.boms': 'Bills of Materials',
  'nav.workCenters': 'Work Centers',
  'nav.workOrders': 'Work Orders',
  'nav.mrp': 'MRP Planning',
  'nav.capacity': 'Capacity',

  // Capacity planning (PP)
  'cap.title': 'Capacity planning',
  'cap.subtitle': 'Work-center utilisation: planned load of open orders vs. capacity.',
  'cap.empty': 'No work centers.',
  'cap.col.code': 'Work center',
  'cap.col.name': 'Name',
  'cap.col.perDay': 'Cap./day (h)',
  'cap.col.available': 'Available',
  'cap.col.load': 'Load (open)',
  'cap.col.utilization': 'Utilisation',
  'cap.overloaded': 'Overloaded',
  'cap.horizon': 'Horizon: {n} days',
  'cap.metric.available': 'Total available',
  'cap.metric.load': 'Total load',
  'cap.metric.utilization': 'Utilisation',
  'cap.metric.overloaded': 'Overloaded',
  'production.mrp.title': 'Material Requirements (MRP)',
  'production.mrp.subtitle': 'Explode a BOM and net requirements against stock',
  'production.mrp.run': 'Run plan',
  'production.mrp.buy': 'Purchase components',
  'production.mrp.make': 'Sub-assemblies to produce',
  'production.mrp.empty': 'No purchased components required',
  'production.mrp.onHand': 'On hand',
  'production.mrp.shortage': 'Shortage',
  'common.status': 'Status',
  'common.active': 'Active',
  'common.inactive': 'Inactive',
  'common.select': 'Select…',
  'common.error': 'Something went wrong',
  'production.dashboard.title': 'Production Overview',
  'production.dashboard.subtitle': 'Work orders, capacity and output at a glance',
  'production.metric.active': 'Active orders',
  'production.metric.draft': 'Draft orders',
  'production.metric.completed': 'Completed orders',
  'production.metric.completedValue': 'Completed value',
  'production.centers.title': 'Work Centers',
  'production.centers.subtitle': 'Where production happens - drives labour costing',
  'production.centers.new': 'New work center',
  'production.centers.empty': 'No work centers yet',
  'production.centers.code': 'Code',
  'production.centers.name': 'Name',
  'production.centers.description': 'Description',
  'production.centers.hourlyRate': 'Hourly rate',
  'production.centers.capacity': 'Capacity / day',
  'production.boms.title': 'Bills of Materials',
  'production.boms.subtitle': 'What each finished product is assembled from',
  'production.boms.new': 'New BOM',
  'production.boms.empty': 'No bills of materials yet',
  'production.boms.code': 'Code',
  'production.boms.name': 'Name',
  'production.boms.product': 'Product',
  'production.boms.outputQuantity': 'Output qty',
  'production.boms.components': 'Components',
  'production.boms.explode': 'Explode',
  'production.boms.explodeTitle': 'BOM explosion',
  'production.boms.structure': 'Multi-level structure',
  'production.boms.requirements': 'Total requirements (raw materials)',
  'production.boms.component': 'Component',
  'production.boms.quantity': 'Quantity',
  'production.boms.material': 'Material',
  'production.boms.totalQty': 'Total qty',
  'production.boms.addComponent': 'Add component',
  'production.orders.title': 'Work Orders',
  'production.orders.subtitle': 'Produce finished goods - consumes components, receives output',
  'production.orders.new': 'New work order',
  'production.orders.empty': 'No work orders yet',
  'production.orders.number': 'Number',
  'production.orders.bom': 'Bill of materials',
  'production.orders.quantity': 'Quantity',
  'production.orders.warehouse': 'Warehouse',
  'production.orders.workCenter': 'Work center',
  'production.orders.laborHours': 'Labour hours',
  'production.orders.materialPreview': 'Material requirements (MRP)',
  'production.orders.required': 'Required',
  'production.orders.totalCost': 'Total cost',
  'production.orders.unitCost': 'Unit cost',
  'production.orders.materialCost': 'Material cost',
  'production.orders.laborCost': 'Labour cost',
  'production.orders.componentsTitle': 'Components',
  'production.orders.noComponents': 'This work order has no components',
  'production.orders.consumed': 'Consumed',
  'production.orders.release': 'Release',
  'production.orders.start': 'Start',
  'production.orders.complete': 'Complete',

  // Production confirmation (partial)
  'pc2.title': 'Confirmation',
  'pc2.action.button': 'Confirm qty',
  'pc2.action.confirm': 'Confirm',
  'pc2.confirmed': 'Confirmed',
  'pc2.remaining': 'Open',
  'pc2.quantity': 'Quantity',
  'pc2.scrap': 'Scrap',
  'pc2.labor': 'Labour hours',
  'pc2.history': 'Previous confirmations',
  'pc2.col.number': 'No.',
  'pc2.col.time': 'Time',
  'pc2.error.qty': 'Quantity is required.',
  'pc2.error.over': 'Exceeds the open quantity ({remaining}).',
  'production.orders.cancel': 'Cancel',
  'production.orders.completedToast': 'Work order completed - stock updated',
  'production.status.DRAFT': 'Draft',
  'production.status.RELEASED': 'Released',
  'production.status.IN_PROGRESS': 'In progress',
  'production.status.COMPLETED': 'Completed',
  'production.status.CANCELLED': 'Cancelled',
  'common.none': '-',
  'projects.dashboard.title': 'Projects Overview',
  'projects.dashboard.subtitle': 'Status, budget and tasks at a glance',
  'projects.metric.active': 'Active projects',
  'projects.metric.budget': 'Total budget',
  'projects.metric.actual': 'Total actual',
  'projects.metric.openTasks': 'Open tasks',
  'projects.chart.budget': 'Budget vs. Actual',
  'projects.chart.budgetSub': 'Per active project',
  'projects.chart.budgetPlanned': 'Budget',
  'projects.chart.budgetActual': 'Actual',
  'projects.chart.status': 'Projects by Status',
  'projects.chart.tasks': 'Tasks by Status',
  'projects.chart.taskCount': 'Task count',
  'projects.list.title': 'Projects',
  'projects.list.subtitle': 'All projects as cards',
  'projects.list.new': 'New project',
  'projects.list.empty': 'No projects yet',
  'projects.create.title': 'New project',
  'projects.create.name': 'Project name',
  'projects.create.customer': 'Customer',
  'projects.create.owner': 'Owner',
  'projects.create.start': 'Start date',
  'projects.create.end': 'End date',
  'projects.create.budget': 'Budget',
  'projects.detail.owner': 'Owner',
  'projects.detail.spent': 'Spent',
  'projects.detail.tasksDone': 'Tasks done',
  'projects.detail.nextMilestone': 'Next milestone',
  'projects.detail.board': 'Task board',
  'projects.detail.milestones': 'Milestones',
  'projects.detail.notFound': 'Project not found',
  'projects.detail.noTasks': 'No tasks yet',
  'projects.detail.noMilestones': 'No milestones yet',
  'projects.status.PLANNED': 'Planned',
  'projects.status.ACTIVE': 'Active',
  'projects.status.PAUSED': 'Paused',
  'projects.status.COMPLETED': 'Completed',
  'projects.status.CANCELLED': 'Cancelled',
  'task.status.TODO': 'To-do',
  'task.status.IN_PROGRESS': 'In progress',
  'task.status.REVIEW': 'Review',
  'task.status.DONE': 'Done',
  'task.priority.LOW': 'Low',
  'task.priority.MEDIUM': 'Medium',
  'task.priority.HIGH': 'High',

  // Time tracking
  'nav.projectsTime': 'Project time',
  'nav.projectsExpenses': 'Expenses',
  'expense.title': 'Expenses & travel',
  'expense.subtitle': 'Capture receipts, approve and bill them',
  'expense.action.new': 'Add expense',
  'expense.action.approve': 'Approve',
  'expense.action.reject': 'Reject',
  'expense.action.reimburse': 'Reimbursed',
  'expense.action.delete': 'Delete',
  'expense.empty': 'No expenses yet',
  'expense.metric.total': 'Total amount',
  'expense.metric.billable': 'Billable',
  'expense.metric.open': 'Open',
  'expense.metric.count': 'Receipts',
  'expense.col.date': 'Date',
  'expense.col.employee': 'Employee',
  'expense.col.category': 'Category',
  'expense.col.amount': 'Amount',
  'expense.col.billable': 'Billable',
  'expense.col.receipt': 'Receipt',
  'expense.receiptLink': 'Open',
  'expense.status.OPEN': 'Open',
  'expense.status.APPROVED': 'Approved',
  'expense.status.REJECTED': 'Rejected',
  'expense.status.REIMBURSED': 'Reimbursed',
  'expense.modal.title': 'Add expense',
  'expense.field.date': 'Date',
  'expense.field.category': 'Category',
  'expense.field.amount': 'Amount',
  'expense.field.employee': 'Employee',
  'expense.field.project': 'Project (optional)',
  'expense.field.description': 'Description',
  'expense.field.receipt': 'Receipt link',
  'expense.field.billable': 'Billable',
  'expense.category.TRAVEL': 'Travel',
  'expense.category.MEALS': 'Meals',
  'expense.category.ACCOMMODATION': 'Accommodation',
  'expense.category.TRANSPORT': 'Transport',
  'expense.category.SUPPLIES': 'Supplies',
  'expense.category.OTHER': 'Other',
  'time.title': 'Project time',
  'time.subtitle': 'Log working time against projects and tasks',
  'time.action.new': 'Log time',
  'time.action.approve': 'Approve',
  'time.action.delete': 'Delete',
  'time.empty': 'No time entries yet',
  'time.metric.total': 'Total hours',
  'time.metric.billable': 'Billable',
  'time.metric.open': 'Open',
  'time.metric.projects': 'Projects',
  'time.col.date': 'Date',
  'time.col.employee': 'Employee',
  'time.col.hours': 'Hours',
  'time.col.billable': 'Billable',
  'time.yes': 'Yes',
  'time.no': 'No',
  'time.status.OPEN': 'Open',
  'time.status.APPROVED': 'Approved',
  'time.status.REJECTED': 'Rejected',
  'time.modal.title': 'Log time',
  'time.field.project': 'Project',
  'time.field.task': 'Task (optional)',
  'time.field.employee': 'Employee',
  'time.field.date': 'Date',
  'time.field.hours': 'Hours',
  'time.field.hoursHint': 'e.g. 1.5',
  'time.field.start': 'From',
  'time.field.end': 'To',
  'time.field.rate': 'Hourly rate',
  'time.field.billable': 'Billable',
  'time.field.description': 'Description',

  // RBAC
  'roles.admin':           'Administrator',
  'roles.accountant':      'Accounting',
  'roles.hr':              'Human Resources',
  'roles.purchaser':       'Purchasing/Warehouse',
  'roles.sales':           'Sales',
  'roles.project_manager': 'Project Lead',
  'roles.executive':       'Executive',
  'access.denied':         'You do not have permission for this action',
  'access.denied.title':   'No access',
  'access.denied.body':    'You do not have permission for this area. Contact an administrator.',
  'settings.users.title':      'Users & Roles',
  'settings.users.intro':      'Assign job roles to users. Permissions are the union of all roles.',
  'settings.users.activate':   'Activate',
  'settings.users.deactivate': 'Deactivate',
  'settings.users.active':     'Active',
  'settings.users.inactive':   'Inactive',
  'settings.users.count':      '{count} users',
  'settings.users.search':     'Search users…',
  'settings.users.noRoles':    'No role',
  'settings.users.editRoles':  'Roles',
  'settings.users.empty':      'No users found.',
  'settings.users.allRoles':   'All roles',
  'settings.users.countFiltered': '{shown} of {total}',
  'settings.users.new': 'New user',
  'settings.users.create.title': 'Create user',
  'settings.users.firstName': 'First name',
  'settings.users.lastName': 'Last name',
  'settings.users.email': 'Email',
  'settings.users.password': 'Password',
  'settings.users.passwordHint': 'At least 10 characters, upper/lowercase and a digit.',
  'settings.users.roles': 'Roles',

  // Performance reviews
  'nav.reviews': 'Reviews',
  'rev.title': 'Performance reviews',
  'rev.subtitle': 'Appraise performance per period - with goals and an overall rating.',
  'rev.empty': 'No reviews.',
  'rev.col.number': 'No.',
  'rev.col.employee': 'Employee',
  'rev.col.period': 'Period',
  'rev.col.rating': 'Rating',
  'rev.status.DRAFT': 'Draft',
  'rev.status.SUBMITTED': 'Submitted',
  'rev.status.ACKNOWLEDGED': 'Acknowledged',
  'rev.action.new': 'New review',
  'rev.action.view': 'Open',
  'rev.action.submit': 'Submit',
  'rev.action.acknowledge': 'Acknowledge',
  'rev.metric.total': 'Reviews',
  'rev.metric.draft': 'Drafts',
  'rev.metric.acknowledged': 'Acknowledged',
  'rev.field.employee': 'Employee',
  'rev.field.period': 'Period',
  'rev.field.rating': 'Overall rating',
  'rev.field.strengths': 'Strengths',
  'rev.field.improvements': 'Development areas',
  'rev.field.goals': 'Goals',
  'rev.field.goalTitle': 'Goal',
  'rev.field.addGoal': '+ Goal',
  'rev.modal.title': 'New review',
  'rev.detail.title': 'Review',
  'rev.error.required': 'Employee and period are required.',

  // Time tracking
  'nav.time': 'Working time',
  'nav.travel': 'Travel expenses',

  // Travel expense reports
  'tr.title': 'Travel expenses',
  'tr.subtitle': 'Record, submit, approve and reimburse travel costs.',
  'tr.empty': 'No reports.',
  'tr.col.number': 'No.',
  'tr.col.employee': 'Employee',
  'tr.col.purpose': 'Purpose',
  'tr.col.period': 'Period',
  'tr.col.total': 'Total',
  'tr.col.category': 'Category',
  'tr.status.DRAFT': 'Draft',
  'tr.status.SUBMITTED': 'Submitted',
  'tr.status.APPROVED': 'Approved',
  'tr.status.REJECTED': 'Rejected',
  'tr.status.REIMBURSED': 'Reimbursed',
  'tr.action.new': 'New report',
  'tr.action.view': 'Open',
  'tr.action.submit': 'Submit',
  'tr.action.approve': 'Approve',
  'tr.action.reject': 'Reject',
  'tr.action.reimburse': 'Reimburse',
  'tr.metric.submitted': 'Submitted',
  'tr.metric.approved': 'Approved',
  'tr.metric.reimbursed': 'Reimbursed',
  'tr.field.employee': 'Employee',
  'tr.field.from': 'From',
  'tr.field.to': 'To',
  'tr.field.purpose': 'Trip purpose',
  'tr.field.items': 'Items',
  'tr.field.description': 'Description',
  'tr.field.amount': 'Amount',
  'tr.field.addItem': '+ Item',
  'tr.cat.MEALS': 'Meals',
  'tr.cat.LODGING': 'Lodging',
  'tr.cat.TRANSPORT': 'Transport',
  'tr.cat.MILEAGE': 'Mileage',
  'tr.cat.OTHER': 'Other',
  'tr.modal.title': 'New travel expense report',
  'tr.detail.title': 'Travel expense report',
  'tr.error.required': 'Employee and trip purpose are required.',
  'hrtime.title': 'Working time of employees',
  'hrtime.subtitle': 'Record working time per employee and report by period.',
  'hrtime.empty': 'No time entries.',
  'hrtime.col.date': 'Date',
  'hrtime.col.employee': 'Employee',
  'hrtime.col.type': 'Type',
  'hrtime.col.hours': 'Hours',
  'hrtime.col.note': 'Note',
  'hrtime.type.REGULAR': 'Regular',
  'hrtime.type.OVERTIME': 'Overtime',
  'hrtime.type.SICK': 'Sick',
  'hrtime.type.HOLIDAY': 'Holiday',
  'hrtime.type.TRAINING': 'Training',
  'hrtime.action.add': 'Record',
  'hrtime.action.delete': 'Delete',
  'hrtime.field.employee': 'Employee',
  'hrtime.field.date': 'Date',
  'hrtime.field.hours': 'Hours',
  'hrtime.field.type': 'Type',
  'hrtime.field.note': 'Note',
  'hrtime.field.from': 'From',
  'hrtime.field.to': 'To',
  'hrtime.filter.employee': 'Employee',
  'hrtime.filter.all': 'All employees',
  'hrtime.metric.total': 'Total',
  'hrtime.error.required': 'Employee, date and hours are required.',

  'settings.nav.ebics':        'EBICS bank connection',
  'ebics.intro':               'Automatic retrieval of bank statements (camt.053) via the EBICS banking protocol.',
  'ebics.experimental':        'Experimental - requires an active EBICS contract with your bank and a manual activation (INI letter). Key generation and the INI letter work locally; sending to the bank and downloading statements only work after the bank has activated the subscriber.',
  'ebics.statusLabel':         'Status:',
  'ebics.status.NEW':          'New',
  'ebics.status.INI_SENT':     'INI sent',
  'ebics.status.HIA_SENT':     'HIA sent',
  'ebics.status.READY':        'Ready',
  'ebics.status.ERROR':        'Error',
  'ebics.masterKeyMissing':    'EBICS_MASTER_KEY is not configured. Set a 32-byte key (64 hex chars) as an environment variable before generating keys.',
  'ebics.bankName':            'Bank name',
  'ebics.hostId':              'Host ID',
  'ebics.partnerId':           'Partner ID (customer ID)',
  'ebics.userId':              'User ID (subscriber ID)',
  'ebics.version':             'EBICS version',
  'ebics.url':                 'EBICS URL',
  'ebics.accountIban':         'Account IBAN',
  'ebics.saved':               'Connection settings saved.',
  'ebics.workflow':            'Setup workflow',
  'ebics.workflow.intro':      'Order: save settings → generate keys → print, sign and mail the INI letter to the bank → send INI & HIA → wait for the bank to activate → fetch bank keys (HPB) → download statements.',
  'ebics.btn.initKeys':        'Generate keys',
  'ebics.btn.letter':          'Download INI letter',
  'ebics.btn.ini':             'Send INI',
  'ebics.btn.hia':             'Send HIA',
  'ebics.btn.hpb':             'Fetch bank keys (HPB)',
  'ebics.btn.download':        'Download statement',
  'ebics.letterHint':          'Keys generated. Download the INI letter (button above) to obtain the key hashes.',
  'ebics.download.title':      'Download statement (camt.053)',
  'ebics.download.from':       'From',
  'ebics.download.to':         'To',
  'ebics.download.imported':   '{n} transactions imported.',
  'ebics.download.goToBank':   'Go to reconciliation',
  'ebics.letter.heading':      'EBICS initialisation letter (INI)',
  'ebics.letter.date':         'Date',
  'ebics.letter.a006':         'Electronic signature (A006)',
  'ebics.letter.x002':         'Authentication (X002)',
  'ebics.letter.e002':         'Encryption (E002)',
  'ebics.letter.note':         'Please verify the public-key hashes below and activate the subscriber. Signed by:',
  'ebics.letter.signature':    'Date, Place, Signature',

  // Credit notes / refunds
  'creditNote.title': 'Credit notes',
  'creditNote.subtitle': 'Credit notes for posted invoices - sales and purchase.',
  'creditNote.empty': 'No credit notes yet.',
  'creditNote.credited': 'Credited',
  'creditNote.col.type': 'Type',
  'creditNote.type.SALES': 'Customer',
  'creditNote.type.PURCHASE': 'Supplier',
  'creditNote.typeFilter.all': 'All types',
  'creditNote.create.title': 'Create credit note',
  'creditNote.create.intro': 'Pick lines and enter the quantity to credit.',
  'creditNote.create.creditQty': 'Quantity to credit',
  'creditNote.create.submit': 'Create credit note',
  'creditNote.create.pickLine': 'Pick at least one line with quantity > 0.',
  'creditNote.print.heading': 'Credit note',
  'creditNote.print.forInvoice': 'For invoice',
  'creditNote.print.total': 'Credit total',
  'creditNote.print.headingVendor': 'Supplier credit note',
  'invoice.refund.action': 'Pay out refund',
  'invoice.refund.amount': 'Refund amount',
  'invoice.refund.balance': 'Credit balance / refund due',
  'invoice.refund.receiveAction': 'Record reimbursement',
  'invoice.refund.receiveBalance': 'Credit with supplier',

  // Multi-currency
  'currency.col.code': 'Code',
  'currency.col.name': 'Name',
  'currency.col.active': 'Active',
  'currency.add': 'Add currency',
  'currency.baseNote': 'CHF is the base currency.',
  'currency.rates.title': 'Exchange rates',
  'currency.rates.intro': 'Rate = CHF per 1 unit of foreign currency.',
  'currency.rates.date': 'Date',
  'currency.rates.rate': 'Rate',
  'currency.rates.source': 'Source',
  'currency.rates.add': 'Add rate',
  'currency.rates.fetch': 'Fetch rates (ECB)',
  'currency.rates.fetched': '{count} rates updated.',
  'currency.rates.fetchFailed': 'Rate fetch failed: {reason}',
  'invoice.fx.currency': 'Currency',
  'invoice.fx.rate': 'Rate',
  'invoice.fx.chfEquivalent': 'CHF equivalent',
  'invoice.fx.paymentRate': 'Payment rate',
  'invoice.fx.refundRate': 'Refund rate',
  'invoice.fx.bankAmount': 'Bank (CHF)',
  'invoice.fx.diff': 'FX difference',
  'invoice.fx.noRate': 'No rate stored for {currency} - maintain it in settings.',

  // Recurring invoices (subscriptions)
  'recurring.title': 'Recurring invoices',
  'recurring.subtitle': 'Templates that generate due invoices automatically - checked hourly.',
  'recurring.col.name': 'Name',
  'recurring.col.customer': 'Customer',
  'recurring.col.interval': 'Interval',
  'recurring.col.nextRun': 'Next invoice',
  'recurring.col.amount': 'Amount',
  'recurring.interval.MONTHLY': 'Monthly',
  'recurring.interval.QUARTERLY': 'Quarterly',
  'recurring.interval.YEARLY': 'Yearly',
  'recurring.active': 'Active',
  'recurring.paused': 'Paused',
  'recurring.action.new': 'New subscription',
  'recurring.action.generate': 'Generate now',
  'recurring.action.pause': 'Pause',
  'recurring.action.resume': 'Resume',
  'recurring.action.edit': 'Edit',
  'recurring.action.delete': 'Delete',
  'recurring.generated': 'Invoice generated:',
  'recurring.insight.byInterval': 'By interval',
  'recurring.insight.active': 'Active subscriptions',
  'recurring.insight.monthly': 'Monthly volume',
  'recurring.insight.due30': 'Due within 30 days',
  'recurring.form.startDate': 'Start',
  'recurring.form.endDate': 'End (optional)',
  'recurring.form.dueDays': 'Payment terms (days)',
  'recurring.form.autoPost': 'Post automatically',
  'recurring.form.invalid': 'Name, customer and at least one valid line are required.',
  'recurring.modal.editTitle': 'Edit subscription',
  'recurring.confirmDelete': 'Really delete this subscription?',
  'recurring.empty': 'No subscriptions yet.',
  'recurring.runs.title': 'Generated invoices',
  'recurring.runs.empty': 'No invoices generated yet.',
  'recurring.toggleRuns': 'Show generated invoices',

  // Command palette (Ctrl+K)
  'palette.placeholder': 'Search or jump to…',
  'palette.pages': 'Pages',
  'palette.customers': 'Customers',
  'palette.products': 'Products',
  'palette.invoices': 'Invoices',
  'palette.projects': 'Projects',
  'palette.orders': 'Orders',
  'palette.quotes': 'Quotes',
  'palette.tickets': 'Tickets',
  'palette.equipment': 'Equipment',
  'palette.suppliers': 'Suppliers',
  'palette.employees': 'Employees',
  'palette.purchaseOrders': 'Purchase orders',
  'palette.noResults': 'No results',
  'palette.hint': 'Type to search customers, invoices, products and projects',
  'palette.open': 'Open search',

  // Audit log (Settings → Audit log)
  'settings.nav.audit': 'Audit log',
  'audit.intro': 'Who changed what and when - every write action with its user.',
  'audit.col.time': 'Time',
  'audit.col.user': 'User',
  'audit.col.module': 'Module',
  'audit.col.action': 'Action',
  'audit.col.entity': 'Object',
  'audit.col.status': 'Status',
  'audit.filter.allModules': 'All modules',
  'audit.filter.allActions': 'All actions',
  'audit.filter.from': 'From',
  'audit.filter.to': 'To',
  'audit.toggleDetails': 'Show details',
  'audit.module.auth': 'Authentication',
  'audit.module.admin': 'Administration',
  'audit.action.create': 'Created',
  'audit.action.update': 'Updated',
  'audit.action.delete': 'Deleted',
  'audit.action.login': 'Login',
  'audit.action.login_failed': 'Login failed',
  'audit.action.logout': 'Logout',
  'audit.action.register': 'Registration',
  'audit.empty': 'No entries yet.',
  'audit.pagination.of': 'of',
  'audit.prev': 'Previous',
  'audit.next': 'Next',

  // Notifications (bell)
  'notif.title': 'Notifications',
  'notif.bell': 'Open notifications',
  'notif.markAll': 'Mark all read',
  'notif.empty': 'No notifications.',
  'notif.stock_low': 'Low stock: {sku} ({quantity} / reorder point {reorderPoint})',
  'notif.po_approval_requested': 'Purchase order {poNumber} of {totalAmount} awaits approval',
  'notif.po_approved': 'Purchase order {poNumber} was approved',
  'notif.po_rejected': 'Purchase order {poNumber} was rejected',
  'notif.leave_requested': 'Leave request from {employeeName}: {days} days from {startDate}',
  'notif.leave_approved': 'Leave request for {employeeName} was approved',
  'notif.leave_rejected': 'Leave request for {employeeName} was rejected',
  'notif.expense_requested': 'New expense from {employeeName}: {amount}',
  'notif.expense_approved': 'Expense from {employeeName} ({amount}) was approved',
  'notif.expense_rejected': 'Expense from {employeeName} ({amount}) was rejected',
  'notif.expense_reimbursed': 'Expense from {employeeName} ({amount}) was reimbursed',
  'notif.demo_requested': 'New demo request from {name} ({company})',

  // Price lists & quantity tiers
  'nav.priceLists': 'Price lists',
  'priceList.title': 'Price lists',
  'priceList.subtitle': 'Customer-specific prices with quantity tiers - applied automatically in quotes and orders.',
  'priceList.col.products': 'Products',
  'priceList.col.tiers': 'Tier rows',
  'priceList.col.customers': 'Customers',
  'priceList.action.new': 'New price list',
  'priceList.action.edit': 'Edit',
  'priceList.action.activate': 'Activate',
  'priceList.action.deactivate': 'Deactivate',
  'priceList.action.delete': 'Delete',
  'priceList.confirmDelete': 'Delete this price list? {count} customer(s) fall back to the list price.',
  'priceList.empty': 'No price lists yet.',
  'priceList.modal.editTitle': 'Edit price list',
  'priceList.items': 'Tier prices',
  'priceList.form.active': 'Active',
  'priceList.form.product': 'Product',
  'priceList.form.minQuantity': 'Minimum quantity',
  'priceList.form.unitPrice': 'Unit price',
  'priceList.form.invalid': 'Name is required.',
  'priceList.tierHint': 'Multiple rows per product = quantity tiers (applies from the minimum quantity).',
  'priceList.applied': 'Price list {name} · from {minQuantity}',
  'priceList.duplicateTier': 'Duplicate tier: same product with the same minimum quantity.',
  'priceList.assign': 'Price list',
  'priceList.none': 'None (list price)',
  'customer.priceListSaved': 'Price list saved.',

  // Fixed assets
  'nav.fixedAssets': 'Fixed assets',
  'nav.maintenance': 'Maintenance',

  // Plant maintenance (PM)
  'pm.title': 'Plant maintenance',
  'pm.subtitle': 'Equipment and maintenance orders with costs and status.',
  'pm.section.orders': 'Maintenance orders',
  'pm.section.equipment': 'Equipment',
  'pm.col.number': 'Order',
  'pm.col.equipment': 'Equipment',
  'pm.col.title': 'Title',
  'pm.col.priority': 'Priority',
  'pm.col.cost': 'Cost',
  'pm.status.OPEN': 'Open',
  'pm.status.IN_PROGRESS': 'In progress',
  'pm.status.COMPLETED': 'Completed',
  'pm.status.CANCELLED': 'Cancelled',
  'pm.priority.LOW': 'Low',
  'pm.priority.MEDIUM': 'Medium',
  'pm.priority.HIGH': 'High',
  'pm.priority.URGENT': 'Urgent',
  'pm.action.view': 'Open',
  'pm.action.newEquipment': 'New equipment',
  'pm.action.newOrder': 'New order',
  'pm.action.start': 'Start',
  'pm.action.complete': 'Complete',
  'pm.action.cancel': 'Cancel',
  'pm.metric.openOrders': 'Open orders',
  'pm.metric.down': 'Down',
  'pm.metric.equipment': 'Equipment',
  'pm.orders.empty': 'No orders.',
  'pm.eq.number': 'No.',
  'pm.eq.name': 'Name',
  'pm.eq.location': 'Location',
  'pm.eq.asset': 'Asset',
  'pm.eq.noAsset': '- none -',
  'pm.eq.notes': 'Notes',
  'pm.eq.empty': 'No equipment.',
  'pm.eq.markDown': 'Mark down',
  'pm.eq.markUp': 'Mark operational',
  'pm.eqStatus.OPERATIONAL': 'Operational',
  'pm.eqStatus.DOWN': 'Down',
  'pm.eqStatus.RETIRED': 'Retired',
  'pm.eqModal.title': 'New equipment',
  'pm.orderModal.title': 'New maintenance order',
  'pm.detail.title': 'Maintenance order',
  'pm.field.description': 'Description',
  'pm.field.plannedDate': 'Planned date',
  'pm.costs': 'Costs',
  'pm.materialCost': 'Material cost',
  'pm.laborCost': 'Labor cost',
  'pm.error.name': 'Name is required.',
  'pm.error.order': 'Equipment and title are required.',
  'pm.action.newPlan': 'New plan',
  'pm.action.generateDue': 'Generate due',
  'pm.section.plans': 'Maintenance plans',
  'pm.plan.number': 'Plan',
  'pm.plan.interval': 'Interval',
  'pm.plan.days': 'days',
  'pm.plan.nextDue': 'Next due',
  'pm.plan.active': 'Active',
  'pm.plan.on': 'Active',
  'pm.plan.off': 'Inactive',
  'pm.plan.empty': 'No maintenance plans.',
  'pm.plan.generated': '{n} order(s) generated.',
  'pm.planModal.title': 'New maintenance plan',
  'pm.error.plan': 'Equipment, title, interval and due date are required.',
  'fa.title': 'Fixed assets',
  'fa.subtitle': 'Asset register, scheduled depreciation and disposals.',
  'fa.action.new': 'New asset',
  'fa.action.dispose': 'Dispose',
  'fa.empty': 'No fixed assets yet.',
  'fa.col.number': 'No.',
  'fa.col.name': 'Name',
  'fa.col.category': 'Category',
  'fa.col.cost': 'Acquisition',
  'fa.col.accumulated': 'Accum. depreciation',
  'fa.col.nbv': 'Net book value',
  'fa.status.ACTIVE': 'Active',
  'fa.status.FULLY_DEPRECIATED': 'Fully depreciated',
  'fa.status.DISPOSED': 'Disposed',
  'fa.metric.active': 'Active assets',
  'fa.metric.cost': 'Acquisition value',
  'fa.metric.accumulated': 'Accum. depreciation',
  'fa.metric.nbv': 'Net book value',
  'fa.run.period': 'Period',
  'fa.run.action': 'Depreciation run',
  'fa.run.done': '{count} asset(s) depreciated, total {total}.',
  'fa.modal.title': 'New asset',
  'fa.field.name': 'Name',
  'fa.field.category': 'Category',
  'fa.field.acquisitionDate': 'Acquisition date',
  'fa.field.cost': 'Acquisition cost',
  'fa.field.salvage': 'Salvage value',
  'fa.field.usefulLife': 'Useful life (months)',
  'fa.field.method': 'Method',
  'fa.field.decliningRate': 'Rate (% p.a.)',
  'fa.field.assetAccount': 'Asset account',
  'fa.field.expenseAccount': 'Depreciation expense account',
  'fa.field.accumulatedAccount': 'Accumulated depreciation account',
  'fa.field.fundingAccount': 'Funding account (acquisition posting)',
  'fa.field.fundingNone': '- no posting -',
  'fa.method.LINEAR': 'Straight-line',
  'fa.method.DECLINING_BALANCE': 'Declining balance',
  'fa.preview.firstPeriod': 'First monthly charge: {amount}',
  'fa.dispose.title': 'Dispose: {name}',
  'fa.dispose.confirm': 'Post disposal',
  'fa.dispose.date': 'Disposal date',
  'fa.dispose.proceeds': 'Sale proceeds',
  'fa.dispose.nbv': 'Net book value {amount}',
  'fa.dispose.gain': 'Gain {amount}',
  'fa.dispose.loss': 'Loss {amount}',

  // Period / year-end close
  'nav.periodClose': 'Period close',
  'period.title': 'Period & year-end close',
  'period.subtitle': 'Closed periods block every posting; the year-end close settles the income statement.',
  'period.year': 'Year',
  'period.empty': 'No periods.',
  'period.col.period': 'Period',
  'period.col.status': 'Status',
  'period.status.open': 'Open',
  'period.status.closed': 'Closed',
  'period.action.close': 'Close',
  'period.action.reopen': 'Reopen',
  'period.yearClosed': 'Year closed',
  'period.yearEnd.action': 'Year-end close',
  'period.yearEnd.confirm': 'Close fiscal year {year}? The income statement is posted to retained earnings and all months are locked.',
  'period.yearEnd.done': 'Year-end close posted. Net result: {net}.',
  'period.metric.year': 'Fiscal year',
  'period.metric.closed': 'Closed months',
  'period.metric.state': 'Year status',

  // Extended VAT (net tax rate, acquisition tax, eCH-0217)
  'settings.vat.title': 'Value-added tax',
  'settings.vat.method': 'Reporting method',
  'settings.vat.effective': 'Effective',
  'settings.vat.saldo': 'Net tax rate (Saldo)',
  'settings.vat.saldoRate1': 'Net tax rate 1 (%)',
  'settings.vat.saldoRate2': 'Net tax rate 2 (%)',
  'invoice.reverseCharge': 'Reverse charge (acquisition tax on services from abroad)',
  'vat.ech0217': 'eCH-0217 XML',
  'vat.method.EFFECTIVE': 'Effective method',
  'vat.method.NET_TAX_RATE': 'Net-tax-rate method',
  'vat.row.saldo': 'Net tax rate',
  'vat.row.acquisitionTax': 'Acquisition tax',

  // Cycle counts
  'common.close': 'Close',
  'nav.cycleCounts': 'Cycle counts',
  'cyc.title': 'Cycle counts',
  'cyc.subtitle': 'Count stock and post differences as adjustment movements.',
  'cyc.empty': 'No cycle counts yet.',
  'cyc.col.date': 'Date',
  'cyc.col.warehouse': 'Warehouse',
  'cyc.status.OPEN': 'Open',
  'cyc.status.POSTED': 'Posted',
  'cyc.status.CANCELLED': 'Cancelled',
  'cyc.action.new': 'New count',
  'cyc.action.view': 'View',
  'cyc.action.post': 'Post',
  'cyc.action.addLine': '+ Line',
  'cyc.metric.total': 'Counts',
  'cyc.metric.open': 'Open',
  'cyc.metric.posted': 'Posted',
  'cyc.field.warehouse': 'Warehouse',
  'cyc.field.date': 'Count date',
  'cyc.field.product': 'Product',
  'cyc.field.expected': 'Expected',
  'cyc.field.counted': 'Counted',
  'cyc.field.variance': 'Variance',
  'cyc.modal.title': 'New cycle count',
  'cyc.detail.title': 'Cycle count',
  'cyc.detail.willAdjust': '{count} adjustment(s) will post.',
  'cyc.error.required': 'Warehouse and at least one line are required.',

  // Purchase requisitions (BANF)
  'nav.requisitions': 'Requisitions',
  'req.title': 'Purchase requisitions',
  'req.subtitle': 'Raise demand, get it approved and convert it into purchase orders.',
  'req.empty': 'No requisitions yet.',
  'req.col.number': 'No.',
  'req.col.neededBy': 'Needed by',
  'req.status.DRAFT': 'Draft',
  'req.status.SUBMITTED': 'Submitted',
  'req.status.APPROVED': 'Approved',
  'req.status.REJECTED': 'Rejected',
  'req.status.CONVERTED': 'Converted',
  'req.action.new': 'New requisition',
  'req.action.view': 'View',
  'req.action.submit': 'Submit',
  'req.action.approve': 'Approve',
  'req.action.reject': 'Reject',
  'req.action.convert': 'Convert to PO',
  'req.action.addLine': '+ Line',
  'req.metric.total': 'Requisitions',
  'req.metric.submitted': 'Submitted',
  'req.metric.approved': 'Approved',
  'req.field.warehouse': 'Warehouse',
  'req.field.neededBy': 'Needed by',
  'req.field.justification': 'Justification',
  'req.field.product': 'Product',
  'req.field.quantity': 'Quantity',
  'req.field.estCost': 'Estimated cost',
  'req.field.supplier': 'Supplier',
  'req.modal.title': 'New requisition',
  'req.detail.title': 'Requisition',
  'req.detail.converted': 'Converted into a purchase order.',
  'req.error.lines': 'At least one line with a product and quantity is required.',
  'req.action.autoReorder': 'Auto reorder',
  'req.autoReorder.done': '{products} product(s) below reorder point → {count} requisition(s) created.',
  'req.autoReorder.none': 'No product below its reorder point.',

  // Stock reservations
  'nav.reservations': 'Reservations',
  'res.title': 'Stock reservations',
  'res.subtitle': 'Hold stock; available = on-hand minus reserved.',
  'res.empty': 'No reservations.',
  'res.col.date': 'Date',
  'res.col.product': 'Product',
  'res.col.warehouse': 'Warehouse',
  'res.col.quantity': 'Quantity',
  'res.status.OPEN': 'Open',
  'res.status.RELEASED': 'Released',
  'res.action.new': 'Reserve',
  'res.action.release': 'Release',
  'res.metric.open': 'Open reservations',
  'res.metric.reserved': 'Reserved quantity',
  'res.metric.total': 'Total',
  'res.field.product': 'Product',
  'res.field.warehouse': 'Warehouse',
  'res.field.quantity': 'Quantity',
  'res.field.available': 'Available: {qty}',
  'res.modal.title': 'Reserve stock',
  'res.error.required': 'Product, warehouse and quantity are required.',

  // Batch / serial tracking
  'inv.track.tracking': 'Traceability',
  'inv.track.NONE': 'None',
  'inv.track.BATCH': 'Batches (with expiry date)',
  'inv.track.SERIAL': 'Serial numbers',
  'inv.track.batchNumber': 'Batch number',
  'inv.track.expiryDate': 'Expiry date',
  'inv.track.serialNumbers': 'Serial numbers',
  'inv.track.serialHint': 'One serial per line (count must equal quantity).',
  'nav.lots': 'Batches',
  'lot.title': 'Batches & traceability',
  'lot.subtitle': 'Trace stock lots by batch/expiry; issues are FEFO.',
  'lot.empty': 'No lots found.',
  'lot.col.product': 'Product',
  'lot.col.batch': 'Batch/serial',
  'lot.col.warehouse': 'Warehouse',
  'lot.col.expiry': 'Expiry',
  'lot.col.remaining': 'Remaining',
  'lot.action.expiring': 'Expiring soon',
  'lot.filter.batch': 'Search batch',
  'lot.filter.inStock': 'In stock only',
  'lot.metric.expiring': 'Expiring (30 days)',
  'lot.metric.expired': 'Expired',

  // Bins
  'nav.bins': 'Bins',
  'nav.quality': 'Quality',
  'nav.consignment': 'Consignment',
  'nav.purchaseContracts': 'Contracts',
  'nav.schedulingAgreements': 'Scheduling agreements',
  'nav.serials': 'Serial numbers',
  'nav.vendorEvaluation': 'Vendor evaluation',
  'nav.uom': 'Units of measure',
  'nav.backorders': 'Backorders',
  'nav.mrpRun': 'MRP run',

  // MRP run (requirements planning)
  'mr.title': 'MRP run',
  'mr.subtitle': 'Net requirement per product (reorder point + backorders − on-hand − on-order) → procurement proposals → requisition.',
  'mr.runs': 'Runs',
  'mr.noRuns': 'No runs yet. Start an MRP run.',
  'mr.proposals': 'Procurement proposals',
  'mr.noProposals': 'No proposals - all requirements covered.',
  'mr.warehouse': 'Target warehouse (requisition)',
  'mr.col.run': 'Run',
  'mr.col.date': 'Date',
  'mr.col.count': 'Proposals',
  'mr.col.product': 'Product',
  'mr.col.onHand': 'On hand',
  'mr.col.onOrder': 'On order',
  'mr.col.backordered': 'Backordered',
  'mr.col.reorder': 'Reorder point',
  'mr.col.net': 'Net requirement',
  'mr.col.suggested': 'Suggested',
  'mr.status.OPEN': 'Open',
  'mr.status.CONVERTED': 'Converted to requisition',
  'mr.action.run': 'Run MRP',
  'mr.action.convert': 'Convert to requisition',
  'mr.metric.proposals': 'Proposals',

  // Backorders
  'bo.title': 'Backorders',
  'bo.subtitle': 'Quantities that could not be issued on confirmation; fulfill once stock is available.',
  'bo.empty': 'No backorders.',
  'bo.all': 'All',
  'bo.col.product': 'Product',
  'bo.col.order': 'Order',
  'bo.col.quantity': 'Backordered',
  'bo.col.available': 'Available',
  'bo.col.date': 'Date',
  'bo.status.OPEN': 'Open',
  'bo.status.FULFILLED': 'Fulfilled',
  'bo.status.CANCELLED': 'Cancelled',
  'bo.action.fulfill': 'Fulfill',
  'bo.metric.open': 'Open backorders',
  'bo.metric.ready': 'Ready to fulfill',

  // Units of measure conversion
  'uom.title': 'Units of measure',
  'uom.subtitle': 'Alternative units per product (e.g. 1 box = 12 each) + converter.',
  'uom.empty': 'No units.',
  'uom.selectProduct': 'Select a product…',
  'uom.base': 'Base',
  'uom.col.unit': 'Unit',
  'uom.col.factor': 'Factor',
  'uom.add': 'Add alternative unit',
  'uom.factorLabel': 'Factor (× {base})',
  'uom.action.add': 'Add',
  'uom.converter': 'Converter',
  'uom.quantity': 'Quantity',
  'uom.from': 'From',
  'uom.to': 'To',
  'uom.action.convert': 'Convert',

  // Vendor evaluation (MM)
  've.title': 'Vendor evaluation',
  've.subtitle': 'Score suppliers on price, quality, delivery and service; overall grade + ranking.',
  've.empty': 'No evaluations.',
  've.noRanking': 'No evaluations yet.',
  've.col.supplier': 'Supplier',
  've.col.avg': 'Avg score',
  've.col.grade': 'Grade',
  've.col.latest': 'Latest',
  've.col.count': 'Count',
  've.col.date': 'Date',
  've.col.price': 'Price',
  've.col.quality': 'Quality',
  've.col.delivery': 'Delivery',
  've.col.service': 'Service',
  've.col.overall': 'Overall',
  've.action.new': 'New evaluation',
  've.ranking': 'Ranking',
  've.evaluations': 'Evaluations',
  've.modal.title': 'New vendor evaluation',
  've.field.notes': 'Note',
  've.error.required': 'Supplier is required.',

  // Serial number history
  'sn.title': 'Serial numbers',
  'sn.subtitle': 'Registry of serial-tracked units with a lifecycle (receipt → issue).',
  'sn.empty': 'No serial numbers.',
  'sn.search': 'Search serial…',
  'sn.allStatus': 'All statuses',
  'sn.col.serial': 'Serial number',
  'sn.col.product': 'Product',
  'sn.col.updated': 'Updated',
  'sn.status.IN_STOCK': 'In stock',
  'sn.status.ISSUED': 'Issued',
  'sn.action.view': 'Open',
  'sn.action.issue': 'Issue',
  'sn.metric.inStock': 'In stock',
  'sn.metric.issued': 'Issued',
  'sn.metric.total': 'Total',
  'sn.detail.title': 'Serial number',
  'sn.field.reference': 'Reference',
  'sn.lifecycle': 'Lifecycle',
  'sn.mv.type': 'Operation',
  'sn.mv.time': 'Time',
  'sn.mv.RECEIVED': 'Receipt',
  'sn.mv.ISSUED': 'Issue',

  // Scheduling agreements (MM)
  'lp.title': 'Scheduling agreements',
  'lp.subtitle': 'Scheduling agreements per supplier/product with dated schedule lines and goods receipt per line.',
  'lp.empty': 'No scheduling agreements.',
  'lp.col.number': 'No.',
  'lp.col.supplier': 'Supplier',
  'lp.col.product': 'Product',
  'lp.col.planned': 'Planned',
  'lp.col.received': 'Received',
  'lp.status.ACTIVE': 'Active',
  'lp.status.CLOSED': 'Closed',
  'lp.action.new': 'New agreement',
  'lp.action.view': 'Open',
  'lp.action.receive': 'GR',
  'lp.action.close': 'Close',
  'lp.metric.active': 'Active',
  'lp.metric.total': 'Agreements',
  'lp.field.price': 'Price',
  'lp.field.from': 'Valid from',
  'lp.field.to': 'Valid to',
  'lp.field.lines': 'Schedule lines',
  'lp.field.qty': 'Quantity',
  'lp.field.addLine': '+ Line',
  'lp.modal.title': 'New scheduling agreement',
  'lp.error.required': 'Supplier and product are required.',
  'lp.error.lines': 'At least one schedule line with a date and quantity.',
  'lp.line.date': 'Delivery date',
  'lp.line.planned': 'Planned',
  'lp.line.received': 'Received',
  'lp.line.OPEN': 'Open',
  'lp.line.PARTIAL': 'Partial',
  'lp.line.COMPLETED': 'Completed',
  'nav.atp': 'Availability',

  // Availability check (ATP)
  'atp.title': 'Availability check',
  'atp.subtitle': 'Checks whether a quantity is deliverable across all warehouses (available = on-hand − reserved − blocked).',
  'atp.field.product': 'Product',
  'atp.field.quantity': 'Quantity',
  'atp.action.check': 'Check',
  'atp.metric.requested': 'Requested',
  'atp.metric.available': 'Total available',
  'atp.metric.result': 'Result',
  'atp.metric.shortfall': 'Shortfall',
  'atp.deliverable': 'Deliverable',
  'atp.notDeliverable': 'Not deliverable',
  'atp.byWarehouse': 'Availability by warehouse',
  'atp.col.warehouse': 'Warehouse',
  'atp.col.name': 'Name',
  'atp.col.available': 'Available',
  'atp.noStock': 'No stock.',
  'atp.error.required': 'Product and quantity are required.',

  // Outline agreements / contracts (MM)
  'ct.title': 'Outline agreements',
  'ct.subtitle': 'Quantity contracts per supplier/product; call-offs draw against the target.',
  'ct.empty': 'No contracts.',
  'ct.col.number': 'No.',
  'ct.col.supplier': 'Supplier',
  'ct.col.product': 'Product',
  'ct.col.target': 'Target',
  'ct.col.released': 'Called off',
  'ct.col.remaining': 'Remaining',
  'ct.col.time': 'Time',
  'ct.status.ACTIVE': 'Active',
  'ct.status.CLOSED': 'Closed',
  'ct.action.new': 'New contract',
  'ct.action.view': 'Open',
  'ct.action.release': 'Call off',
  'ct.action.close': 'Close',
  'ct.metric.active': 'Active',
  'ct.metric.total': 'Contracts',
  'ct.field.target': 'Target quantity',
  'ct.field.price': 'Price',
  'ct.field.from': 'Valid from',
  'ct.field.to': 'Valid to',
  'ct.field.callOffQty': 'Call-off qty',
  'ct.field.reference': 'Reference',
  'ct.modal.title': 'New outline agreement',
  'ct.releases': 'Call-offs',
  'ct.noReleases': 'No call-offs yet.',
  'ct.error.required': 'Supplier, product and target quantity are required.',

  // Consignment stock
  'cons.title': 'Consignment stock',
  'cons.subtitle': 'Supplier-owned stock at our site; withdrawal creates a liability.',
  'cons.empty': 'No consignment stock.',
  'cons.col.product': 'Product',
  'cons.col.supplier': 'Supplier',
  'cons.col.warehouse': 'Warehouse',
  'cons.col.quantity': 'Quantity',
  'cons.col.price': 'Price',
  'cons.col.value': 'Value',
  'cons.action.book': 'Book',
  'cons.action.view': 'Open',
  'cons.metric.lines': 'Lines',
  'cons.metric.suppliers': 'Suppliers',
  'cons.metric.value': 'Stock value',
  'cons.op.title': 'Consignment booking',
  'cons.op.type': 'Operation',
  'cons.op.receive': 'Receipt (supplier delivers)',
  'cons.op.withdraw': 'Withdrawal (consumption)',
  'cons.field.note': 'Note',
  'cons.error.required': 'Product, supplier, warehouse and quantity are required.',
  'cons.detail.title': 'Consignment stock',
  'cons.movements': 'Movements',
  'cons.noMovements': 'No movements.',
  'cons.mv.type': 'Type',
  'cons.mv.time': 'Time',
  'cons.mv.RECEIPT': 'Receipt',
  'cons.mv.WITHDRAWAL': 'Withdrawal',

  // Quality management (QM)
  'qm.title': 'Quality management',
  'qm.subtitle': 'Inspection lots with a usage decision - rejecting blocks available stock.',
  'qm.empty': 'No inspection lots.',
  'qm.col.number': 'Lot',
  'qm.col.product': 'Product',
  'qm.col.quantity': 'Quantity',
  'qm.col.source': 'Source',
  'qm.status.OPEN': 'Open',
  'qm.status.ACCEPTED': 'Accepted',
  'qm.status.REJECTED': 'Blocked',
  'qm.source.MANUAL': 'Manual',
  'qm.source.GOODS_RECEIPT': 'Goods receipt',
  'qm.source.PRODUCTION': 'Production',
  'qm.action.new': 'New inspection lot',
  'qm.action.view': 'Open',
  'qm.action.accept': 'Accept',
  'qm.action.reject': 'Reject',
  'qm.metric.open': 'Open',
  'qm.metric.accepted': 'Accepted',
  'qm.metric.rejected': 'Blocked',
  'qm.field.product': 'Product',
  'qm.field.warehouse': 'Warehouse',
  'qm.field.quantity': 'Quantity',
  'qm.field.source': 'Source',
  'qm.field.characteristics': 'Characteristics',
  'qm.field.charName': 'Characteristic',
  'qm.field.addChar': '+ Characteristic',
  'qm.result.OK': 'OK',
  'qm.result.NOK': 'NOK',
  'qm.modal.title': 'New inspection lot',
  'qm.detail.title': 'Inspection lot',
  'qm.detail.blocked': '{qty} units blocked - available stock reduced.',
  'qm.noChars': 'No characteristics yet.',
  'qm.error.required': 'Product, warehouse and quantity are required.',
  'bin.title': 'Storage bins',
  'bin.subtitle': 'Put away, pick and move stock at bin level.',
  'bin.empty': 'No bin stock.',
  'bin.col.bin': 'Bin',
  'bin.col.product': 'Product',
  'bin.col.quantity': 'Quantity',
  'bin.action.newBin': 'New bin',
  'bin.action.book': 'Book',
  'bin.field.warehouse': 'Warehouse',
  'bin.field.product': 'Product',
  'bin.field.bin': 'Bin',
  'bin.field.fromBin': 'From bin',
  'bin.field.toBin': 'To bin',
  'bin.field.quantity': 'Quantity',
  'bin.metric.bins': 'Bins',
  'bin.metric.occupied': 'Occupied',
  'bin.metric.lines': 'Lines',
  'bin.op.title': 'Bin operation',
  'bin.op.type': 'Operation',
  'bin.op.putaway': 'Put away',
  'bin.op.pick': 'Pick',
  'bin.op.move': 'Move',
  'bin.create.title': 'Create bin',
  'bin.create.code': 'Code',
  'bin.create.label': 'Label',
  'bin.error.required': 'Product, bin and quantity are required.',
  'bin.error.code': 'Code is required.',

  // Customer returns
  'nav.returns': 'Returns',
  'ret.title': 'Returns',
  'ret.subtitle': 'Record customer returns against an order; receipt books stock back in.',
  'ret.empty': 'No returns.',
  'ret.col.number': 'No.',
  'ret.col.date': 'Date',
  'ret.col.reason': 'Reason',
  'ret.status.REQUESTED': 'Requested',
  'ret.status.APPROVED': 'Approved',
  'ret.status.RECEIVED': 'Received',
  'ret.status.REJECTED': 'Rejected',
  'ret.action.new': 'New return',
  'ret.action.view': 'View',
  'ret.action.approve': 'Approve',
  'ret.action.reject': 'Reject',
  'ret.action.receive': 'Receive goods',
  'ret.metric.requested': 'Requested',
  'ret.metric.approved': 'Approved',
  'ret.metric.received': 'Received',
  'ret.field.order': 'Order',
  'ret.field.reason': 'Reason',
  'ret.field.product': 'Product',
  'ret.field.ordered': 'Ordered',
  'ret.field.returnQty': 'Return qty',
  'ret.field.lineReason': 'Reason',
  'ret.modal.title': 'New return',
  'ret.detail.title': 'Return',
  'ret.detail.received': 'Goods received; stock booked back in.',
  'ret.error.lines': 'An order and at least one return quantity are required.',

  // Service contracts
  'nav.contracts': 'Contracts',
  'sc.title': 'Service contracts',
  'sc.subtitle': 'Service and maintenance contracts per customer.',
  'sc.empty': 'No contracts.',
  'sc.col.number': 'No.',
  'sc.col.customer': 'Customer',
  'sc.col.title': 'Title',
  'sc.col.period': 'Period',
  'sc.status.ACTIVE': 'Active',
  'sc.status.CANCELLED': 'Cancelled',
  'sc.status.EXPIRED': 'Expired',
  'sc.action.new': 'New contract',
  'sc.action.cancel': 'Cancel',
  'sc.metric.total': 'Contracts',
  'sc.metric.active': 'Active',
  'sc.field.customer': 'Customer',
  'sc.field.title': 'Title',
  'sc.field.start': 'Start',
  'sc.field.end': 'End',
  'sc.modal.title': 'New service contract',
  'sc.error.required': 'Customer and title are required.',

  // Support tickets (after-sales)
  'nav.tickets': 'Tickets',
  'tk.title': 'Support tickets',
  'tk.subtitle': 'Capture, prioritise and work customer requests.',
  'tk.empty': 'No tickets.',
  'tk.col.number': 'No.',
  'tk.col.customer': 'Customer',
  'tk.col.subject': 'Subject',
  'tk.col.priority': 'Priority',
  'tk.status.OPEN': 'Open',
  'tk.status.IN_PROGRESS': 'In progress',
  'tk.status.RESOLVED': 'Resolved',
  'tk.status.CLOSED': 'Closed',
  'tk.priority.LOW': 'Low',
  'tk.priority.MEDIUM': 'Medium',
  'tk.priority.HIGH': 'High',
  'tk.priority.URGENT': 'Urgent',
  'tk.action.new': 'New ticket',
  'tk.action.view': 'Open',
  'tk.filter.all': 'All statuses',
  'tk.metric.total': 'Tickets',
  'tk.metric.open': 'Open/In progress',
  'tk.metric.urgent': 'Urgent',
  'tk.field.customer': 'Customer',
  'tk.field.priority': 'Priority',
  'tk.field.contract': 'Contract',
  'tk.field.noContract': 'No contract',
  'tk.field.subject': 'Subject',
  'tk.field.description': 'Description',
  'tk.modal.title': 'New ticket',
  'tk.error.required': 'Customer and subject are required.',
  'tk.detail.title': 'Ticket',
  'tk.move.OPEN': 'Reopen',
  'tk.move.IN_PROGRESS': 'Start',
  'tk.move.RESOLVED': 'Resolve',
  'tk.move.CLOSED': 'Close',
  'tk.comments': 'History',
  'tk.noComments': 'No comments yet.',
  'tk.addComment': 'Add a comment…',
  'tk.send': 'Send',

  // Public landing page
  'landing.nav.login': 'Sign in',
  'landing.hero.line1': 'Clarity for',
  'landing.hero.line2': 'your entire business.',
  'landing.hero.sub':
    'Finance, people, inventory and sales in one system. Ready in days, not months.',
  'landing.hero.cta': 'Book a demo',
  'landing.hero.more': 'Learn more',
  'landing.value1.title': 'Everything in one system',
  'landing.value1.text':
    'Invoices, payroll, stock and orders work as one, with no interfaces and no double entry.',
  'landing.value2.title': 'Swiss precision',
  'landing.value2.text':
    'VAT, QR-bill, dunning and payroll to Swiss standards, accurate to the centime.',
  'landing.value3.title': 'Ready in days',
  'landing.value3.text':
    'No months-long rollout: book a demo, get your access, start working.',
  'landing.stat1.label': 'Modules',
  'landing.stat2.label': 'Languages',
  'landing.stat3.label': 'System',
  'landing.form.title': 'Book a demo',
  'landing.form.sub':
    'Tell us briefly who you are. We will get back to you within one business day.',
  'landing.form.point1': 'A reply within one business day',
  'landing.form.point2': 'Tailored to your company',
  'landing.form.point3': 'No sales pressure, no obligation',
  'landing.form.name.label': 'What is your name?',
  'landing.form.name.placeholder': 'First and last name',
  'landing.form.company.label': 'Which company do you work for?',
  'landing.form.company.placeholder': 'Company name',
  'landing.form.email.label': 'How can we reach you?',
  'landing.form.email.placeholder': 'name@company.com',
  'landing.form.message.label': 'Anything you would like to add?',
  'landing.form.message.placeholder': 'Optional: what should we prepare for you?',
  'landing.form.next': 'Next',
  'landing.form.back': 'Back',
  'landing.form.skip': 'Skip',
  'landing.form.enter': 'or press Enter',
  'landing.form.review.title': 'All set.',
  'landing.form.review.name': 'Name',
  'landing.form.review.company': 'Company',
  'landing.form.review.email': 'E-mail',
  'landing.form.review.message': 'Message',
  'landing.form.submit': 'Send request',
  'landing.form.sending': 'Sending…',
  'landing.form.error.required': 'Please fill in this field.',
  'landing.form.error.email': 'Please enter a valid e-mail address.',
  'landing.form.error.submit': 'That did not work. Please try again.',
  'landing.form.done.title': 'Thank you!',
  'landing.form.done.text':
    'Your request has been received. We will get back to you within one business day.',
  'landing.footer.copyright': '© {year} Recica Solutions',
  'landing.claim': 'Fewer tools, less double entry, more clarity.',
  'landing.modules.title': 'Everything an ERP needs to do',
  'landing.modules.sub':
    'Seven modules on one shared data foundation. Every number is entered once and correct everywhere.',
  'landing.module.finance.name': 'Finance',
  'landing.module.finance.text':
    'Double-entry accounting, invoices with QR payment part, VAT, dunning, fixed assets and period close.',
  'landing.module.hr.name': 'People',
  'landing.module.hr.text':
    'Employee files, payroll, absences, expenses and recruiting in one place.',
  'landing.module.inventory.name': 'Inventory & purchasing',
  'landing.module.inventory.text':
    'Real-time stock, purchase orders with approvals, stocktaking, lots and planning.',
  'landing.module.sales.name': 'Sales',
  'landing.module.sales.text':
    'From quote through order and delivery to invoice, with price lists and credit limits.',
  'landing.module.projects.name': 'Projects',
  'landing.module.projects.text':
    'Projects, time tracking and expenses, billable down to the line item.',
  'landing.module.production.name': 'Production',
  'landing.module.production.text':
    'Bills of material, work orders, work centers and capacity planning for manufacturing.',
  'landing.module.automation.name': 'Automation',
  'landing.module.automation.text':
    'Rules and alerts handle routine work before it reaches your desk.',
  'landing.feat1.title': 'From quote to paid invoice',
  'landing.feat1.text':
    'One document leads to the next: quote, order, delivery, invoice, payment. No retyping, no media breaks.',
  'landing.feat1.point1': 'Invoices with Swiss QR payment part',
  'landing.feat1.point2': 'Automatic three-level dunning',
  'landing.feat1.point3': 'Recurring invoices for subscriptions and contracts',
  'landing.feat2.title': 'Numbers you can trust',
  'landing.feat2.text':
    'Dashboards and reports straight from the books, accurate to the centime and always current.',
  'landing.feat2.point1': 'P&L and balance sheet at the press of a button',
  'landing.feat2.point2': 'Cost centers and budgets in view',
  'landing.feat2.point3': 'VAT return prepared for you',
  'landing.feat3.title': 'One calendar for the whole company',
  'landing.feat3.text':
    'Absences, events and due dates in one place - everyone sees what is coming.',
  'landing.feat3.point1': 'Leave requests with approval flow',
  'landing.feat3.point2': 'Payroll prepared in one click',
  'landing.feat3.point3': 'Notifications in the inbox and by e-mail',
  'landing.how.title': 'Up and running in three steps',
  'landing.how1.title': 'Book a demo',
  'landing.how1.text':
    'Get in touch - we show you the system and set up your access. No installation, no project team.',
  'landing.how2.title': 'Add master data',
  'landing.how2.text': 'Import or create customers, products and accounts.',
  'landing.how3.title': 'Start working',
  'landing.how3.text': 'The first document is done in minutes. Your team finds its way without training.',
  'landing.module.finance.f1': 'Invoices, credit notes & subscriptions',
  'landing.module.finance.f2': 'QR-bill & dunning',
  'landing.module.finance.f3': 'General ledger, balance sheet & P&L',
  'landing.module.finance.f4': 'Cost centers, budgets & controlling',
  'landing.module.finance.f5': 'Fixed assets & period close',
  'landing.module.finance.f6': 'Payment runs, bank & VAT',
  'landing.module.hr.f1': 'Employee files',
  'landing.module.hr.f2': 'Time tracking',
  'landing.module.hr.f3': 'Absences & vacation',
  'landing.module.hr.f4': 'Payroll',
  'landing.module.hr.f5': 'Expenses & travel costs',
  'landing.module.hr.f6': 'Recruiting & performance reviews',
  'landing.module.inventory.f1': 'Items & real-time stock',
  'landing.module.inventory.f2': 'Purchase orders with approvals',
  'landing.module.inventory.f3': 'Suppliers & vendor rating',
  'landing.module.inventory.f4': 'Lots, serials & bin locations',
  'landing.module.inventory.f5': 'Stocktaking & quality checks',
  'landing.module.inventory.f6': 'Planning & availability',
  'landing.module.sales.f1': 'Customers & price lists',
  'landing.module.sales.f2': 'Quotes & orders',
  'landing.module.sales.f3': 'Delivery notes & returns',
  'landing.module.sales.f4': 'Sales pipeline at a glance',
  'landing.module.sales.f5': 'Service contracts & tickets',
  'landing.module.sales.f6': 'Credit limits & reports',
  'landing.module.projects.f1': 'Projects & tasks',
  'landing.module.projects.f2': 'Time tracking on projects',
  'landing.module.projects.f3': 'Expenses with approval',
  'landing.module.projects.f4': 'Billing down to the line item',
  'landing.module.production.f1': 'Bills of material',
  'landing.module.production.f2': 'Work orders & confirmations',
  'landing.module.production.f3': 'Work centers',
  'landing.module.production.f4': 'Capacity planning',
  'landing.module.production.f5': 'Material requirements planning',
  'landing.module.automation.f1': 'Automatic rules',
  'landing.module.automation.f2': 'Alerts & reminders',
  'landing.module.automation.f3': 'Inbox notifications',
  'landing.module.automation.f4': 'E-mail dispatch',
  'landing.extras.title': 'Included in every module',
  'landing.extras.i1': 'Personal dashboard with key figures',
  'landing.extras.i2': 'Inbox & notifications',
  'landing.extras.i3': 'Company calendar with events & absences',
  'landing.extras.i4': 'Global search across everything',
  'landing.extras.i5': 'Roles & permissions',
  'landing.extras.i6': 'Complete audit trail',
  'landing.extras.i7': 'Multiple currencies',
  'landing.extras.i8': 'German, English, French',
  'landing.nav.modules': 'Modules',
  'landing.nav.features': 'Features',
  'landing.nav.how': 'How it works',
  'landing.hero.eyebrow': 'Swiss business software',
  'landing.hero.cue': 'Scroll',
  'landing.hero.meta': '7 modules · 3 languages · 1 data set',
  'landing.values.kicker': 'Why RSZ ERP',
  'landing.values.title': 'One system instead of five silos',
  'landing.claim.note':
    'One data set for finance, people, inventory, sales, projects and production.',
  'landing.modules.kicker': 'Modules',
  'landing.extras.kicker': 'Included',
  'landing.features.kicker': 'Document flow',
  'landing.how.kicker': 'Process',
  'landing.close.text': 'Seven modules, one data set, one interface.',
  'landing.frame.debtors': 'Receivables',
  'landing.frame.report': 'Income statement',
  'landing.frame.calendar': 'Company calendar',
  'landing.frame.week': 'Week 31',
  'landing.kpi.open': 'Open items',
  'landing.kpi.overdue': 'Overdue',
  'landing.kpi.terms': 'Payment terms',
  'landing.kpi.termsValue': '24 days',
  'landing.state.open': 'Open',
  'landing.state.paid': 'Paid',
  'landing.state.dunned': 'Reminder 1',
  'landing.doc.quote': 'Quote',
  'landing.doc.order': 'Order',
  'landing.doc.invoice': 'Invoice',
  'landing.doc.qr': 'QR payment part',

  // ----- Anbieterebene (/platform) -----
  'platform.badge': 'Provider view',
  'platform.signOut': 'Sign out',
  'platform.nav.tenants': 'Tenants',
  'platform.nav.demoRequests': 'Demo requests',
  'platform.roles.owner': 'Full access',
  'platform.roles.support': 'Support',
  'platform.login.title': 'Provider sign-in',
  'platform.login.hint': 'A separate account from your normal sign-in. Both sessions can be open at the same time.',
  'platform.login.cta': 'Sign in',
  'platform.login.cta.loading': 'Signing in…',
  'platform.login.failed': 'Sign-in failed',
  'platform.tenants.title': 'Tenants',
  'platform.tenants.subtitle': 'Every company running the ERP. Not to be confused with sales customers, which are debtors.',
  'platform.tenants.col.slug': 'Key',
  'platform.tenants.col.name': 'Company',
  'platform.tenants.col.contact': 'Contact',
  'platform.tenants.col.phone': 'Phone',
  'platform.tenants.col.created': 'Created',
  'platform.tenants.status.all': 'All statuses',
  'platform.tenants.status.active': 'Active',
  'platform.tenants.status.provisioning': 'Setting up',
  'platform.tenants.status.blocked': 'Blocked',
  'platform.tenants.status.failed': 'Failed',
  'platform.tenants.status.deleting': 'Tearing down',
  'platform.tenants.status.deleted': 'Removed',
  'platform.tenants.block': 'Block',
  'platform.tenants.unblock': 'Unblock',
  'platform.tenants.create.cta': 'New company',
  'platform.tenants.create.title': 'Create a company',
  'platform.tenants.create.hint': 'Creates the company and sets it up: its own databases, chart of accounts and first account. This takes a few seconds.',
  'platform.tenants.create.saving': 'Creating…',
  'platform.tenants.create.failed': 'The company could not be created',
  'platform.tenants.delete.cta': 'Remove company',
  'platform.tenants.delete.title': 'Remove {name}',
  'platform.tenants.delete.working': 'Removing…',
  'platform.tenants.delete.failed': 'Removal not possible',
  'platform.tenants.delete.warning': 'All eight databases of this company, its database role and all its accounts will be removed. This cannot be undone.',
  'platform.tenants.delete.backupHint': 'Back up first. The command creates a folder with all eight dumps and instructions for restoring them:',
  'platform.tenants.delete.confirmLabel': 'Type {slug} to confirm',
  'platform.users.title': 'Users of the company',
  'platform.users.hint': 'Create, block and reset passwords. Signing in as the customer is not possible - there is no path in the program for it.',
  'platform.users.empty': 'This company has no users yet.',
  'platform.users.loading': 'Loading users…',
  'platform.users.col.name': 'Name',
  'platform.users.col.roles': 'Roles',
  'platform.users.col.status': 'State',
  'platform.users.active': 'Active',
  'platform.users.blocked': 'Blocked',
  'platform.users.block': 'Block',
  'platform.users.unblock': 'Unblock',
  'platform.users.update.failed': 'Change not possible',
  'platform.users.create.cta': 'Create user',
  'platform.users.create.title': 'Create a new user',
  'platform.users.create.saving': 'Creating…',
  'platform.users.create.failed': 'The user could not be created',
  'platform.users.create.passwordHint': 'At least 10 characters. The user should change it after signing in.',
  'platform.users.reset.cta': 'Reset password',
  'platform.users.reset.title': 'One-time link for setting the password',
  'platform.users.reset.explain': 'Pass this link on to {email}. They choose the password themselves - you never learn it.',
  'platform.users.reset.once': 'The link works exactly once and expires after 24 hours. All of this person sessions have already ended.',
  'platform.users.reset.failed': 'Reset not possible',
  'setPassword.title': 'Set your password',
  'setPassword.hint': 'Choose a new password. You can sign in with it afterwards.',
  'setPassword.new': 'New password',
  'setPassword.repeat': 'Repeat',
  'setPassword.tooShort': 'At least 10 characters.',
  'setPassword.mismatch': 'The two entries do not match.',
  'setPassword.cta': 'Set password',
  'setPassword.saving': 'Setting…',
  'setPassword.failed': 'That did not work.',
  'setPassword.noToken': 'This call is missing the link. Please open the full link from the message.',
  'setPassword.done': 'Done. You can now sign in with {email}.',
  'setPassword.toLogin': 'To the sign-in page',
  'platform.tenants.section.company': 'Company',
  'platform.tenants.section.admin': 'First account',
  'platform.tenants.section.admin.hint': 'This is how the company signs in for the first time. There is no public registration through which it could create one itself.',
  'platform.tenants.section.letterhead': 'Letterhead',
  'platform.tenants.section.letterhead.hint': 'Appears on the company invoices, dunning notices and delivery notes. Can be changed later in its settings.',
  'platform.tenants.admin.email': 'Sign-in address',
  'platform.tenants.admin.password': 'Password',
  'platform.tenants.admin.password.hint': 'At least 10 characters. The customer should change it after signing in.',
  'platform.tenants.admin.firstName': 'First name',
  'platform.tenants.admin.lastName': 'Last name',
  'platform.tenants.company.address': 'Street and number',
  'platform.tenants.company.zip': 'Postcode',
  'platform.tenants.company.city': 'City',
  'platform.tenants.company.iban': 'IBAN',
  'platform.tenants.company.vat': 'VAT number',
  'platform.provisioning.title': 'Setting up the company',
  'platform.provisioning.starting': 'Picking up the job…',
  'platform.provisioning.running': 'Running:',
  'platform.provisioning.done': 'Done. The company is live.',
  'platform.provisioning.failed': 'Setup failed.',
  'platform.provisioning.rolledBack': 'Setup was rolled back.',
  'platform.provisioning.rolledBack.hint': 'No databases and no accounts were left behind. The key is available again right away.',
  'platform.provisioning.pleaseWait': 'Please wait…',
  'platform.provisioning.readyHint': 'The company can now sign in with {email}.',
  'platform.provisioning.step.role': 'Create database role',
  'platform.provisioning.step.registry': 'Register the mapping',
  'platform.provisioning.step.company': 'Store the letterhead',
  'platform.provisioning.step.admin': 'Create the first account',
  'platform.provisioning.step.smoke': 'Verify',
  'platform.provisioning.step.activate': 'Go live',
  'platform.provisioning.step.db': 'Database {service}',
  'platform.provisioning.step.migrate': 'Tables {service}',
  'platform.provisioning.step.drop': 'Remove database {name}',
  'platform.tenants.slug.hint': 'Lower-case letter first, then lower-case letters, digits or underscore. It forms the database names later and cannot be changed afterwards.',
  'platform.tenants.searchPlaceholder': 'Search company or key…',
  'platform.tenants.count': '{count} companies',
  'platform.tenants.empty': 'No company created yet',
  'platform.tenants.provisioningNote': 'Companies marked Setting up have no databases of their own yet, so their users cannot sign in. One-click provisioning arrives in a later stage.',
  'platform.demo.title': 'Demo requests',
  'platform.demo.subtitle': 'Requests from the public site form. Visible only here, never inside a customer installation.',
  'platform.demo.col.received': 'Received',
  'platform.demo.col.company': 'Company',
  'platform.demo.col.name': 'Name',
  'platform.demo.col.message': 'Message',
  'platform.demo.status.all': 'All statuses',
  'platform.demo.status.new': 'New',
  'platform.demo.status.seen': 'Seen',
  'platform.demo.status.contacted': 'Contacted',
  'platform.demo.status.closed': 'Closed',
  'platform.demo.searchPlaceholder': 'Search company, name or e-mail…',
  'platform.demo.count': '{count} requests',
  'platform.demo.empty': 'No request received yet',

  // ----- Entscheidung über einen Ferienantrag -----
  'hr.leave.action.cancel': 'Cancel absence',
  'hr.leave.decide.approve.title': 'Approve request',
  'hr.leave.decide.reject.title': 'Reject request',
  'hr.leave.decide.cancel.title': 'Cancel absence',
  'hr.leave.decide.noteRequired': 'Reason (required)',
  'hr.leave.decide.noteOptional': 'Note (optional)',

  // ----- Mandantenakte und Anbieterprotokoll -----
  'platform.tenants.masterData': 'Master data',
  'platform.tenants.col.plan': 'Contract',
  'platform.tenants.col.contractStart': 'Contract start',
  'platform.tenants.col.contractEnd': 'Contract end',
  'platform.tenants.col.notes': 'Notes',
  'platform.tenants.saved': 'Saved.',
  'platform.tenants.save.failed': 'Could not save',
  'platform.tenants.blockedNote': 'This company is blocked. Its users cannot sign in, but all data is kept.',
  'platform.tenants.loading': 'Loading…',
  'platform.audit.title': 'What we did to this company',
  'platform.audit.subtitle': 'Provider actions only. What happens inside the company is in its own log and cannot be read from here.',
  'platform.audit.empty': 'No action recorded yet',
  'platform.audit.col.when': 'When',
  'platform.audit.col.who': 'Who',
  'platform.audit.col.what': 'What',
  'platform.audit.col.entity': 'Affects',
  'platform.audit.action.create': 'Created',
  'platform.audit.action.update': 'Changed',
  'platform.audit.action.delete': 'Deleted',
  // ---- Month closing and the manager view (package 7)
  'month.name.1': 'January',
  'month.name.2': 'February',
  'month.name.3': 'March',
  'month.name.4': 'April',
  'month.name.5': 'May',
  'month.name.6': 'June',
  'month.name.7': 'July',
  'month.name.8': 'August',
  'month.name.9': 'September',
  'month.name.10': 'October',
  'month.name.11': 'November',
  'month.name.12': 'December',
  'nav.myTeam': 'For my decision',
  'month.status.DRAFT': 'In progress',
  'month.status.SUBMITTED': 'Submitted',
  'month.status.APPROVED': 'Approved',
  'month.status.REJECTED': 'Rejected',
  'month.target': 'Target',
  'month.actual': 'Actual',
  'month.balance': 'Balance',
  'month.submit': 'Submit month',
  'month.withdraw': 'Withdraw',
  'month.waiting': 'Awaiting approval',
  'month.approvedHint': 'Approved - changes require reopening',
  'month.rejectedNote': 'Rejected: {note}',
  'team.title': 'For my decision',
  'team.subtitle': 'Leave requests and monthly timesheets from the people who report to me.',
  'team.noReports': 'Nobody reports to you at the moment. Once someone is assigned to you, their requests appear here.',
  'team.col.who': 'Who',
  'team.col.range': 'Period',
  'team.col.days': 'Days',
  'team.col.reason': 'Reason',
  'team.col.month': 'Month',
  'team.col.hours': 'Hours',
  'team.col.status': 'State',
  'team.check': 'Review',
  'team.approve': 'Approve',
  'team.approveMonth': 'Approve',
  'team.reject': 'Reject',
  'team.daysUnit': 'days',
  'team.leave.title': 'Leave requests',
  'team.leave.hint': 'Open requests. Before deciding you can see who else is away.',
  'team.leave.empty': 'No open leave request.',
  'team.leave.decide': 'Decide leave request',
  'team.months.title': 'Monthly timesheets',
  'team.months.hint': 'Submitted months. Once approved, nothing can be changed.',
  'team.months.empty': 'No month is awaiting approval.',
  'team.months.decide': 'Decide month',
  'team.months.note': 'Note',
  'team.months.notePlaceholder': 'If rejecting: what is missing?',
  'team.overlaps.title': 'Who else is away?',
  'team.overlaps.none': 'Nobody else in this period.',
  'hr.employees.modal.manager': 'Manager',
  'hr.employees.modal.noManager': 'None',
  'hr.employees.modal.managerHint': 'Decides on this person\'s leave requests and monthly timesheets.',
  // ---- Half days, year change and carry-over (package 8)
  'self.leave.startHalf': 'First day half only',
  'self.leave.endHalf': 'Last day half only',
  'self.leave.preview.cost': 'Costs you',
  'self.leave.preview.year': '{cost} days - {after} left of {before}',
  'self.leave.preview.short': 'Not enough balance',
  'hr.leave.close.title': 'Annual leave year-end',
  'hr.leave.close.subtitle': 'Carry remaining leave into the new year - with a date on which it expires.',
  'hr.leave.close.year': 'Year',
  'hr.leave.close.maxCarry': 'Carry at most',
  'hr.leave.close.maxCarryHint': 'Empty means carry everything. Zero means nothing.',
  'hr.leave.close.expires': 'Expires on',
  'hr.leave.close.preview': 'Preview',
  'hr.leave.close.run': 'Run year-end',
  'hr.leave.close.col.carry': 'Carried',
  'hr.leave.close.col.forfeited': 'Forfeited',
  'hr.leave.close.col.remaining': 'Remaining',
  'hr.leave.close.done': '{count} people closed, {carried} days carried over.',
  'hr.leave.close.skipped': 'Already closed and therefore skipped: {names}',
  'hr.leave.col.carriedOver': 'Carried over',
  'hr.employees.modal.annualLeave': 'Annual leave days',
  'hr.employees.modal.annualLeaveHint': 'Empty means the leave type default applies. Joining mid-year is counted pro rata.',
  // ---- Swiss leave types and maintainable holidays (package 9)
  'nav.leaveTypes': 'Types and holidays',
  'leave.type.ANNUAL': 'Annual leave',
  'leave.type.SICK': 'Sick leave',
  'leave.type.UNFALL': 'Accident',
  'leave.type.MILITAER': 'Military and civil service',
  'leave.type.MUTTERSCHAFT': 'Maternity',
  'leave.type.VATERSCHAFT': 'Paternity',
  'leave.type.BETREUUNG': 'Caring for a relative',
  'leave.type.KURZABSENZ': 'Short absence',
  'leave.type.KOMPENSATION': 'Time off in lieu',
  'leave.type.UNPAID': 'Unpaid leave',
  'leave.type.WEITERBILDUNG': 'Training',
  'leave.type.PARENT': 'Parental leave (legacy)',
  'hr.types.title': 'Leave types and public holidays',
  'hr.types.subtitle': 'What can be requested, under which rules - and which days cost no balance.',
  'hr.types.tab': 'Leave types',
  'hr.types.new': 'New type',
  'hr.types.edit': 'Edit type',
  'hr.types.empty': 'No leave type yet.',
  'hr.types.inactive': 'Retired',
  'hr.types.col.name': 'Name',
  'hr.types.col.code': 'Code',
  'hr.types.col.quota': 'Quota',
  'hr.types.col.rules': 'Rules',
  'hr.types.codeHint': 'Cannot be changed later - balances and requests depend on it.',
  'hr.types.color': 'Colour',
  'hr.types.colorHint': 'A name, not a colour value. Styling comes from the design tokens and knows both schemes.',
  'hr.types.color.neutral': 'Neutral',
  'hr.types.color.info': 'Blue',
  'hr.types.color.success': 'Green',
  'hr.types.color.warning': 'Yellow',
  'hr.types.color.danger': 'Red',
  'hr.types.color.accent': 'Accent',
  'hr.types.notice': 'Notice in days',
  'hr.types.quota': 'Days per year',
  'hr.types.isPaid': 'Paid',
  'hr.types.active': 'Offer for selection',
  'hr.types.activeHint': 'Retired types stay readable but no longer appear in any request.',
  'hr.types.requiresBalance': 'Book against an annual quota',
  'hr.types.requiresBalanceHint': 'In Switzerland sickness is not a quota.',
  'hr.types.requiresApproval': 'Needs approval',
  'hr.types.requiresApprovalHint': 'Without the tick the request applies immediately - right for a sick note.',
  'hr.types.allowsRetroactive': 'Can be requested retroactively',
  'hr.types.allowsRetroactiveHint': 'Holidays are planned, illness is not.',
  'hr.types.requiresDocument': 'Document required',
  'hr.types.requiresDocumentHint': 'Medical certificate, marching orders, birth certificate. A hint, not a block.',
  'hr.types.flag.noApproval': 'applies at once',
  'hr.types.flag.noRetro': 'not retroactive',
  'hr.types.flag.document': 'document',
  'hr.types.flag.notice': '{days} days notice',
  'hr.holidays.tab': 'Public holidays',
  'hr.holidays.new': 'Add days',
  'hr.holidays.empty': 'No entries.',
  'hr.holidays.emptyYear': 'Not a single day is recorded for {year}. While that stays so, every public holiday that year costs a day of leave.',
  'hr.holidays.col.date': 'Date',
  'hr.holidays.col.name': 'Name',
  'hr.holidays.col.kind': 'Kind',
  'hr.holidays.kind.PUBLIC': 'Statutory',
  'hr.holidays.kind.BRIDGE': 'Bridge day',
  'hr.holidays.kind.COMPANY': 'Company shutdown',
  'hr.holidays.from': 'From',
  'hr.holidays.to': 'To',
  'hr.holidays.toHint': 'Leave empty for a single day.',
  'self.leave.preview.document': 'A document is required for this.',
  'self.leave.preview.noApproval': 'Applies immediately - no approval needed.',
  // ---- Absence calendar as a month grid (package 10)
  'weekday.short.mon': 'Mo',
  'weekday.short.tue': 'Tu',
  'weekday.short.wed': 'We',
  'weekday.short.thu': 'Th',
  'weekday.short.fri': 'Fr',
  'weekday.short.sat': 'Sa',
  'weekday.short.sun': 'Su',
  'hr.leave.calendar.loading': 'Loading calendar…',
  'hr.leave.calendar.thisMonth': 'This month',
  'hr.leave.calendar.showPending': 'Show open requests',
  'hr.leave.calendar.legend.approved': 'Approved',
  'hr.leave.calendar.legend.pending': 'Requested',
  // ---- Export, monthly report and filters (package 11)
  'hrtime.report.open': 'Monthly report',
  'hrtime.report.title': 'Monthly report',
  'hrtime.report.employeeNumber': 'Employee number',
  'hrtime.report.sum': 'Total',
  'hrtime.report.signEmployee': 'Signature employee',
  'hrtime.report.signManager': 'Signature manager',
  'hrtime.report.pickEmployee': 'A report always belongs to one person. Please select an employee above.',
  'hrtime.truncated': 'Showing {shown} of {total} rows. Narrow the period to see the full set.',
  'hr.leave.filter.status': 'State',
  'hr.leave.filter.all': 'All',
  'hr.leave.filter.count': '{shown} of {total} shown',
  'hrtime.type.ABSENCE': 'Absence',
  'hrtime.report.pickRange': 'A report needs a period. Please set From and To on the time page.',
  'hrtime.report.unknownEmployee': 'Unknown',
  'hrtime.exportBlocked': 'The list is truncated. Narrow the period for a complete file.',
  // ---- Reminders instead of chasing (package 12)
  'notif.time_submitted': 'Month {month}/{year} from {employeeName} submitted - awaiting approval',
  'notif.time_approved': 'Your month {month}/{year} was approved',
  'notif.time_rejected': 'Your month {month}/{year} was rejected - please correct it',
  'notif.time_gaps': '{missingCount} day(s) without time recorded between {from} and {to}',
  'notif.time_approval_due': 'Month {month}/{year} from {employeeName} has been waiting {waitingDays} days',
  'notif.leave_approval_due': 'Leave request from {employeeName} has been waiting {waitingDays} days',
  'platform.tenants.delete.mustBlockFirst': 'This company is still active. It can only be removed once blocked - that puts a pause between the decision and the deed.',
  // ---- The time account (package 13)
  'timeAccount.title': 'Time account',
  'timeAccount.unit': 'h',
  'timeAccount.asOf': 'As of {date}',
  'timeAccount.opening': 'Opening balance',
  'timeAccount.closedOne': 'One approved month',
  'timeAccount.closed': '{count} approved months',
  'timeAccount.open': 'Running since {from}',
  'timeAccount.compensated': 'Includes {hours} h of time off in lieu. It does not count as time worked - the balance has been used up.',
  'timeAccount.gap': 'Not approved without gaps: {months}. The figure is correct, it just does not come from an unbroken run of closed months.',
  'timeAccount.noStart': 'No start on file for this person. Without a hire date or a cut-off date there is no balance to compute.',
  'timeAccount.col.total': 'Account',
  'timeAccount.col.opening': 'Opening',
  'timeAccount.col.closed': 'Approved',
  'timeAccount.col.open': 'Running',
  'timeAccount.team.title': 'Time accounts',
  'timeAccount.team.hint': 'The overall balance of my reports. A day off in lieu uses it up - whoever decides should see it first.',
  'timeAccount.team.empty': 'No time account yet.',
  'timeAccount.forDecision': 'Time account: {hours} h',
  'time.week.compensated': '{hours} h in lieu',
  'time.balance.compensated': 'In lieu',
  'hr.types.countsAsWorktime': 'Counts as time worked',
  'hr.types.countsAsWorktimeHint': 'On means a day of this kind counts like a worked day and the time account stays as it is. Off means it uses up the balance - as with time off in lieu.',
  'hr.types.flag.consumesTime': 'uses time account',
  'timeAccount.setOpening': 'Set opening balance',
  'timeAccount.openingHint': 'Whoever introduces this system brings existing hours along. The cut-off date says from when the system computes on its own - before that only the opening balance counts.',
  'timeAccount.openingField': 'Opening balance (h)',
  'timeAccount.startField': 'Computes from',
  // ---- Documents spanning more than one sheet (package 1)
  'pdf.page': 'Page {n} of {total}',
  // ---- Change and reset a password (package 1)
  'common.saving': 'Saving…',
  'common.copy': 'Copy',
  'common.copied': 'Copied',
  'settings.password.title': 'Change password',
  'settings.password.hint': 'After the change you are signed out on every device, including this one.',
  'settings.password.current': 'Current password',
  'settings.password.new': 'New password',
  'settings.password.repeat': 'Repeat new password',
  'settings.password.mismatch': 'The two entries do not match.',
  'settings.password.submit': 'Change password',
  'settings.password.done': 'Password changed. You will have to sign in again.',
  'settings.password.ruleLength': 'at least 10 characters',
  'settings.password.ruleLower': 'one lowercase letter',
  'settings.password.ruleUpper': 'one uppercase letter',
  'settings.password.ruleDigit': 'one digit',
  'settings.users.resetPassword': 'Reset password',
  'settings.users.resetTitle': 'One-time link to set a password',
  'settings.users.resetDone': 'A one-time link is ready for {email}. All of their sessions have ended.',
  'settings.users.resetLink': 'Link',
  'settings.users.resetExpires': 'Valid briefly, usable once.',
  'settings.users.resetWarning': 'The link is shown only now. Hand it over in person - whoever reads it can set the password.',
  // ---- Production: an honest in-between state and product search (package 3)
  'production.status.COMPLETING': 'Posting',
  'production.orders.completing': 'Completion has been requested. The order is done only once the warehouse has consumed the components and received the output.',
  'production.orders.stockError': 'Nothing was posted: {reason}',
  'production.boms.search': 'Search products',
  'production.boms.searchHint': 'Number or name',
  'production.boms.truncated': '{shown} of {total} products loaded - search to find the rest.',
  'production.boms.noProducts': 'No products exist yet. Without products there is no bill of materials to build.',
  'production.boms.productsFailed': 'The product list could not be loaded: {message}',

  // ----- Journal (Belegliste und Storno)
  'nav.journal': 'Journal',
  'journal.title': 'Journal',
  'journal.subtitle': 'Every posting with its lines - and the way to take one back.',
  'journal.empty': 'Nothing posted in this period.',
  'journal.filter.from': 'From',
  'journal.filter.to': 'To',
  'journal.filter.account': 'Account',
  'journal.filter.allAccounts': 'All accounts',
  'journal.col.account': 'Account',
  'journal.col.debit': 'Debit',
  'journal.col.credit': 'Credit',
  'journal.badge.isReversal': 'Reversal',
  'journal.badge.reversedBy': 'reversed by {number}',
  'journal.action.reverse': 'Reverse',
  'journal.reverse.title': 'Reverse posting {number}',
  'journal.reverse.explain': 'This creates a counter-posting dated {date}, the day of the original entry. Both stay in the journal - nothing is deleted.',
  'journal.reverse.reason': 'Reason',
  'journal.reverse.reasonHint': 'Why is this being reversed?',
  'journal.pager.previous': 'Back',
  'journal.pager.next': 'Next',
  'journal.pager.position': '{from}-{to} of {total}',

  // ----- Berichte: Zeitraum, Kontozeilen, Ausfuhr
  'finance.reports.empty': 'No accounts with activity in this period.',
  'finance.reports.asOf': 'As of {date}',
  'finance.reports.action.export': 'Export',
  'finance.reports.col.amount': 'Amount',
  'finance.reports.col.balance': 'Balance',
  'finance.reports.section.revenue': 'Revenue',
  'finance.reports.section.expenses': 'Expenses',
  'finance.reports.section.assets': 'Assets',
  'finance.reports.section.liabilities': 'Liabilities',
  'finance.reports.section.equity': 'Equity',
  'finance.reports.range.thisYear': 'This year',
  'finance.reports.range.lastYear': 'Last year',
  'finance.reports.range.thisQuarter': 'This quarter',
  'finance.reports.range.thisMonth': 'This month',
  'finance.reports.file.income': 'income-statement',
  'finance.reports.file.balanceSheet': 'balance-sheet',
  'finance.reports.retainedEarnings': 'Included: current profit or loss of {amount}. It sits on no account - it is revenue minus expenses up to the reporting date.',

  // ----- Kassabuch: Gegenkonto und Datum
  'cb.field.counterAccount': 'Counter account',
  'cb.field.counterAccountPick': 'Choose an account',
  'cb.field.entryDate': 'Date',
  'cb.error.counterAccountRequired': 'Please choose a counter account. A cash entry posts to the ledger, and a posting has two sides.',
  'cb.hint.receipt': 'Receipt: debit cash, credit the counter account.',
  'cb.hint.payment': 'Payment: debit the counter account, credit cash.',
  'cb.field.account': 'Cash account',
  'cb.field.accountDefault': 'Company default cash account',

  // ----- Kontoblatt
  'journal.sheet.opening': 'Opening',
  'journal.sheet.closing': 'Closing balance',
  'journal.sheet.openingRow': 'Opening balance',
  'journal.sheet.closingRow': 'Totals and closing balance',
  'journal.sheet.running': 'Balance',
  'journal.sheet.counterAccount': 'Counter account',
  'journal.sheet.split': '{count} counter accounts',
  'journal.sheet.truncated': 'The list is truncated. The closing balance covers only the rows shown - please narrow the period.',

  // ----- Lohn: Arbeitgeberbeitraege
  'hr.payroll.col.employer': 'Employer contributions',
  'hr.payroll.employerHint': 'Employer contributions (AHV, ALV, FAK, BU, BVG) are not deducted from pay - they are an additional cost to the company.',

  // ----- Personalstamm: Quellensteuer, BVG, Kinder
  'hr.employees.modal.birthDate': 'Date of birth',
  'hr.employees.modal.birthDateHint': 'For the age-graded BVG credits. Without it, a flat rate applies.',
  'hr.employees.modal.children': 'Children',
  'hr.employees.modal.workCanton': 'Canton of work',
  'hr.employees.modal.workCantonHint': 'Where the work happens, not where the person lives.',
  'hr.employees.modal.qstLiable': 'Subject to withholding tax',
  'hr.employees.modal.qstCode': 'Tariff code',
  'hr.employees.modal.qstCodeHint': 'ESTV code, e.g. A0N or B2Y.',

  // ----- Quellensteuertarife
  'nav.withholdingTax': 'Payroll reference data',
  'hr.qst.title': 'Cantonal payroll reference data',
  'hr.qst.subtitle': 'Withholding tax tariffs and family allowances - both cantonal, neither shipped with the software.',
  'hr.qst.current': 'Stored tariffs',
  'hr.qst.empty': 'No tariff stored yet. Without one, payroll cannot be run for anyone subject to withholding tax - deliberately: an invented rate would be worse than none.',
  'hr.qst.import': 'Import a tariff file',
  'hr.qst.importIntro': 'The tariffs are not shipped with the software. They are cantonal, they change every year, and an invented rate looks official, computes consistently and deducts the wrong amount every month - until a back claim arrives.',
  'hr.qst.format': 'Format',
  'hr.qst.format.csv': 'CSV with column names',
  'hr.qst.format.estv': 'ESTV tariff file',
  'hr.qst.source': 'Source',
  'hr.qst.sourceHint': 'e.g. ESTV tariffs 2026, January edition',
  'hr.qst.csvHeader': 'Expected columns: Kanton;Tarifcode;Jahr;von;bis;Satz',
  'hr.qst.fileContent': 'File content',
  'hr.qst.filePlaceholder': 'Paste the tariff file content here',
  'hr.qst.action.preview': 'Read and show',
  'hr.qst.action.import': 'Apply',
  'hr.qst.action.importAnyway': 'Apply despite findings',
  'hr.qst.imported': '{tarife} tariffs with {stufen} brackets applied.',
  'hr.qst.preview.tariffs': 'Tariffs',
  'hr.qst.preview.brackets': 'Brackets',
  'hr.qst.preview.rateRange': 'Rate range',
  'hr.qst.preview.samples': 'First rows',
  'hr.qst.col.canton': 'Canton',
  'hr.qst.col.code': 'Tariff code',
  'hr.qst.col.year': 'Year',
  'hr.qst.col.brackets': 'Brackets',
  'hr.qst.col.rateRange': 'Rates',
  'hr.qst.col.source': 'Source',
  'hr.qst.col.imported': 'Imported',
  'hr.qst.col.from': 'From',
  'hr.qst.col.to': 'To',
  'hr.qst.col.rate': 'Rate',

  // ----- Lohnlauf stornieren
  'hr.payroll.col.withholding': 'Withholding tax',
  'hr.payroll.action.cancel': 'Cancel run',
  'hr.payroll.cancel.title': 'Cancel payroll run {period}',
  'hr.payroll.cancel.explain': 'The run is not deleted but taken back - both stay on record. The month can then be run again, and accounting reverses its posting on its own.',
  'hr.payroll.cancel.reason': 'Reason',
  'hr.payroll.cancel.reasonHint': 'Why is this run being taken back?',
  'hr.fam.title': 'Family allowances',
  'hr.fam.intro': 'These amounts are cantonal too. Federal law sets a minimum and most cantons exceed it - a silent default would permanently underpay the person concerned, and nobody would notice.',
  'hr.fam.empty': 'No rate stored yet. Without one, payroll cannot be run for anyone with children.',
  'hr.fam.col.child': 'Child allowance',
  'hr.fam.col.education': 'Education allowance',
  'hr.fam.action.save': 'Save rate',
  'hr.fam.educationNote': 'The education allowance is recorded but not yet applied: that needs each child\'s age, and the employee record only carries their number. Guessing it would be wrong in both directions.',

  // --- Errors the server cannot explain itself --------------------------
  'fehler.abgebrochen': 'The request was cancelled.',
  'fehler.keineVerbindung': 'No connection to the server. Check your network and try again.',
  'fehler.zeitueberschreitung': 'The server did not answer in time. Please try again.',
  'fehler.zuVieleAnfragen': 'Too many attempts in a short time. Wait a moment and try again.',
  'fehler.zuVieleAnfragen.warten': 'Too many attempts in a short time. You can try again in {sekunden} seconds.',
  'fehler.zuGross': 'The file is too large to send.',
  'fehler.dienstNichtErreichbar': 'This area is not reachable right now. Try again in a moment.',
  'fehler.serverfehler': 'Something went wrong on the server. The action was not carried out.',
  'fehler.unbekannt': 'The request failed (status {status}).',

  // --- Error boundary ---------------------------------------------------
  'fehler.grenze.titel': 'This view could not be displayed',
  'fehler.grenze.text': 'The error affects this page only. Your data is untouched and the rest of the application keeps running.',
  'fehler.grenze.neuLaden': 'Reload page',
  'fehler.grenze.zurueck': 'Back to overview',
  'fehler.grenze.details': 'Technical details',

  // --- Truncated lists --------------------------------------------------
  'insight.gekuerzt': 'The figures cover {gezeigt} of {gesamt} rows. Narrow the period or the filter to make them complete.',
  'tabelle.fehler': 'The list could not be loaded',
  'tabelle.gekuerzt': '{gezeigt} of {gesamt} rows. Narrow the period or the filter to see the rest.',

  // --- What the server objects to in a form -----------------------------
  // The rule names come from Joi and are a small, fixed set.

  // --- Feldnamen fuer Formularfehler ------------------------------------
  'feld.name': 'Name',
  'feld.code': 'Code',
  'feld.status': 'Status',
  'feld.type': 'Type',
  'feld.notes': 'Notes',
  'feld.note': 'Note',
  'feld.comment': 'Comment',
  'feld.description': 'Description',
  'feld.reason': 'Reason',
  'feld.title': 'Title',
  'feld.email': 'Email',
  'feld.phone': 'Phone',
  'feld.password': 'Password',
  'feld.firstName': 'First name',
  'feld.lastName': 'Last name',
  'feld.amount': 'Amount',
  'feld.unitPrice': 'Unit price',
  'feld.quantity': 'Quantity',
  'feld.currency': 'Currency',
  'feld.taxRate': 'Tax rate',
  'feld.lines': 'Line items',
  'feld.items': 'Items',
  'feld.hours': 'Hours',
  'feld.months': 'Months',
  'feld.month': 'Month',
  'feld.year': 'Year',
  'feld.fiscalYear': 'Fiscal year',
  'feld.canton': 'Canton',
  'feld.breakMinutes': 'Break in minutes',
  'feld.position': 'Position',
  'feld.stage': 'Stage',
  'feld.priority': 'Priority',
  'feld.category': 'Category',
  'feld.source': 'Source',
  'feld.reference': 'Reference',
  'feld.filename': 'File name',
  'feld.probability': 'Probability',
  'feld.limit': 'Row count',
  'feld.offset': 'Start row',
  'feld.productId': 'Product',
  'feld.customerId': 'Customer',
  'feld.supplierId': 'Supplier',
  'feld.employeeId': 'Employee',
  'feld.warehouseId': 'Warehouse',
  'feld.accountId': 'Account',
  'feld.invoiceId': 'Invoice',
  'feld.projectId': 'Project',
  'feld.leaveTypeId': 'Leave type',
  'feld.costCenterId': 'Cost centre',
  'feld.departmentId': 'Department',
  'feld.managerId': 'Manager',
  'feld.ownerId': 'Owner',
  'feld.assigneeId': 'Assignee',
  'feld.equipmentId': 'Equipment',
  'feld.positionId': 'Position',
  'feld.parentId': 'Parent',

  'feldfehler.mehrere': '{anzahl} fields are not right yet.',
  'feldfehler.unbekannt': 'The value is not valid.',
  'feldfehler.any.required': '{feld} is required.',
  'feldfehler.any.only': '{feld} is not one of the allowed values.',
  'feldfehler.any.invalid': '{feld} is not one of the allowed values.',
  'feldfehler.string.empty': '{feld} must not be empty.',
  'feldfehler.string.base': '{feld} must be text.',
  'feldfehler.string.email': '{feld} is not a valid email address.',
  'feldfehler.string.uri': '{feld} is not a valid address.',
  'feldfehler.string.guid': '{feld} is not a valid identifier.',
  'feldfehler.string.min': '{feld} needs at least {grenze} characters.',
  'feldfehler.string.max': '{feld} may have at most {grenze} characters.',
  'feldfehler.string.length': '{feld} must have exactly {grenze} characters.',
  'feldfehler.string.pattern.base': '{feld} does not have the expected form.',
  'feldfehler.string.isoDate': '{feld} is not a valid date.',
  'feldfehler.number.base': '{feld} must be a number.',
  'feldfehler.number.min': '{feld} must be at least {grenze}.',
  'feldfehler.number.max': '{feld} may be at most {grenze}.',
  'feldfehler.number.integer': '{feld} must be a whole number.',
  'feldfehler.number.positive': '{feld} must be greater than zero.',
  'feldfehler.number.greater': '{feld} must be greater than {grenze}.',
  'feldfehler.number.less': '{feld} must be less than {grenze}.',
  'feldfehler.number.unsafe': '{feld} is too large.',
  'feldfehler.date.base': '{feld} is not a valid date.',
  'feldfehler.date.min': '{feld} is too early.',
  'feldfehler.date.max': '{feld} is too late.',
  'feldfehler.array.base': '{feld} must be a list.',
  'feldfehler.array.min': '{feld} needs at least {grenze} entries.',
  'feldfehler.array.max': '{feld} may have at most {grenze} entries.',
  'feldfehler.array.includesRequiredUnknowns': '{feld} is incomplete.',
  'feldfehler.object.base': '{feld} does not have the expected form.',
  'feldfehler.object.unknown': '{feld} is not expected here.',
  'feldfehler.boolean.base': '{feld} must be yes or no.',
  'feldfehler.object.missing': 'At least one field must be filled in.',

  // --- "Das gibt es nicht" ----------------------------------------------
  'fehler.nichtGefunden.account': 'That account does not exist.',
  'fehler.nichtGefunden.attachment': 'That attachment does not exist.',
  'fehler.nichtGefunden.backorder': 'That backorder does not exist.',
  'fehler.nichtGefunden.bankTransaction': 'That bank transaction does not exist.',
  'fehler.nichtGefunden.bin': 'That bin does not exist.',
  'fehler.nichtGefunden.bom': 'That bill of materials does not exist.',
  'fehler.nichtGefunden.candidate': 'That candidate does not exist.',
  'fehler.nichtGefunden.cashJournal': 'That cash journal does not exist.',
  'fehler.nichtGefunden.company': 'That company does not exist.',
  'fehler.nichtGefunden.consignment': 'That consignment does not exist.',
  'fehler.nichtGefunden.contract': 'That contract does not exist.',
  'fehler.nichtGefunden.costCenter': 'That cost centre does not exist.',
  'fehler.nichtGefunden.creditNote': 'That credit note does not exist.',
  'fehler.nichtGefunden.currency': 'That currency does not exist.',
  'fehler.nichtGefunden.customer': 'That customer does not exist.',
  'fehler.nichtGefunden.cycleCount': 'That cycle count does not exist.',
  'fehler.nichtGefunden.delivery': 'That delivery does not exist.',
  'fehler.nichtGefunden.demoRequest': 'That request does not exist.',
  'fehler.nichtGefunden.downPayment': 'That down payment does not exist.',
  'fehler.nichtGefunden.dunningNotice': 'That dunning notice does not exist.',
  'fehler.nichtGefunden.employee': 'That person is not in the employee list.',
  'fehler.nichtGefunden.equipment': 'That equipment does not exist.',
  'fehler.nichtGefunden.expense': 'That expense does not exist.',
  'fehler.nichtGefunden.fixedAsset': 'That fixed asset does not exist.',
  'fehler.nichtGefunden.inspectionLot': 'That inspection lot does not exist.',
  'fehler.nichtGefunden.holiday': 'That public holiday does not exist.',
  'fehler.nichtGefunden.companyEvent': 'That event does not exist.',
  'fehler.termin.nurUrheberDarfLoeschen': 'Only whoever created the event can remove it - or someone with admin rights.',
  'fehler.datenbank.schonVorhanden': 'That entry already exists.',
  'fehler.datenbank.verweistAufNichts': 'The entry refers to something that does not exist.',
  'fehler.nichtGefunden.invoice': 'That invoice does not exist.',
  'fehler.nichtGefunden.item': 'That item does not exist.',
  'fehler.nichtGefunden.jobPosting': 'That job posting does not exist.',
  'fehler.nichtGefunden.journal': 'That journal entry does not exist.',
  'fehler.nichtGefunden.leaveRequest': 'That request does not exist.',
  'fehler.nichtGefunden.leaveType': 'That leave type does not exist.',
  'fehler.nichtGefunden.maintenanceOrder': 'That maintenance order does not exist.',
  'fehler.nichtGefunden.maintenancePlan': 'That maintenance plan does not exist.',
  'fehler.nichtGefunden.month': 'That month does not exist.',
  'fehler.nichtGefunden.mrpRun': 'That MRP run does not exist.',
  'fehler.nichtGefunden.notification': 'That notification does not exist.',
  'fehler.nichtGefunden.opportunity': 'That opportunity does not exist.',
  'fehler.nichtGefunden.paymentRun': 'That payment run does not exist.',
  'fehler.nichtGefunden.paymentTerm': 'That payment term does not exist.',
  'fehler.nichtGefunden.payrollRun': 'That payroll run does not exist.',
  'fehler.nichtGefunden.payslip': 'That payslip does not exist.',
  'fehler.nichtGefunden.priceList': 'That price list does not exist.',
  'fehler.nichtGefunden.product': 'That product does not exist.',
  'fehler.nichtGefunden.profitCenter': 'That profit centre does not exist.',
  'fehler.nichtGefunden.project': 'That project does not exist.',
  'fehler.nichtGefunden.provisioningJob': 'That provisioning job does not exist.',
  'fehler.nichtGefunden.purchaseOrder': 'That purchase order does not exist.',
  'fehler.nichtGefunden.quote': 'That quote does not exist.',
  'fehler.nichtGefunden.recurringInvoice': 'That recurring invoice does not exist.',
  'fehler.nichtGefunden.recurringJournal': 'That recurring journal does not exist.',
  'fehler.nichtGefunden.report': 'That report does not exist.',
  'fehler.nichtGefunden.requisition': 'That requisition does not exist.',
  'fehler.nichtGefunden.reservation': 'That reservation does not exist.',
  'fehler.nichtGefunden.review': 'That review does not exist.',
  'fehler.nichtGefunden.rule': 'That rule does not exist.',
  'fehler.nichtGefunden.run': 'That run does not exist.',
  'fehler.nichtGefunden.salesOrder': 'That sales order does not exist.',
  'fehler.nichtGefunden.salesReturn': 'That return does not exist.',
  'fehler.nichtGefunden.scheduleLine': 'That schedule line does not exist.',
  'fehler.nichtGefunden.schedulingAgreement': 'That scheduling agreement does not exist.',
  'fehler.nichtGefunden.serialUnit': 'That serial number does not exist.',
  'fehler.nichtGefunden.supplier': 'That supplier does not exist.',
  'fehler.nichtGefunden.tenant': 'That company does not exist.',
  'fehler.nichtGefunden.ticket': 'That ticket does not exist.',
  'fehler.nichtGefunden.timeEntry': 'That time entry does not exist.',
  'fehler.nichtGefunden.travelReport': 'That travel report does not exist.',
  'fehler.nichtGefunden.user': 'That user account does not exist.',
  'fehler.nichtGefunden.warehouse': 'That warehouse does not exist.',
  'fehler.nichtGefunden.workCenter': 'That work centre does not exist.',
  'fehler.nichtGefunden.workOrder': 'That work order does not exist.',
  'fehler.nichtGefunden.workSchedule': 'No weekly schedule is stored for that person.',

  'fehler.anmeldung.falsch': 'That email or password is not right.',
  'fehler.anmeldung.abgelaufen': 'Your session has expired. Please sign in again.',
  'fehler.anmeldung.abgelaufen': 'Your session has expired. Please sign in again.',
  'fehler.anmeldung.abgelaufen': 'Your session has expired. Please sign in again.',
  'fehler.anmeldung.abgelaufen': 'Your session has expired. Please sign in again.',
  'fehler.anmeldung.abgelaufen': 'Your session has expired. Please sign in again.',
  'fehler.anmeldung.abgelaufen': 'Your session has expired. Please sign in again.',
  'fehler.anmeldung.kontoGesperrt': 'This account is blocked. Please contact your company administrator.',
  'fehler.anmeldung.kontoGesperrt': 'This account is blocked. Please contact your company administrator.',
  'fehler.zugriff.fehlendeBerechtigung': 'You do not have permission for this area.',
  'fehler.zugriff.keinAnbietertoken': 'This area is reserved for the provider.',
  'fehler.zugriff.adresseNichtErlaubt': 'Access is not allowed from this network address.',
  'fehler.benutzer.letzteVerwaltung': 'This is the last account with admin rights. Without one, nobody could reach the settings any more.',
  'fehler.benutzer.adresseVergeben': 'That email address is already in use.',
  'fehler.benutzer.adresseVergeben': 'That email address is already in use.',
  'fehler.benutzer.adresseVergeben': 'That email address is already in use.',
  'fehler.kennwort.gleichWieBisher': 'The new password must differ from the current one.',
  'fehler.kennwort.linkAbgelaufen': 'This link is no longer valid. Please request a new one.',
  'fehler.kennwort.zuruecksetzenNichtEingerichtet': 'Password reset is not set up in this installation.',
  'fehler.firma.kuerzelVergeben': 'That short name is already taken.',
  'fehler.firma.kuerzelStimmtNicht': 'The short name you typed does not match the company’s.',
  'fehler.firma.nurAktivOderGesperrt': 'A company can only be active or blocked.',

  'fehler.eingabe.ungueltig': 'The input is incomplete or not valid.',
  'fehler.regel.unbekanntesEreignis': 'There is no such event - a rule cannot listen for it.',
  'fehler.regel.bedingungOhneVergleich': 'A field also needs to say HOW it should be compared.',
  'fehler.firma.anlageNichtVerfuegbar': 'Companies cannot be created on this server.',
  'fehler.firma.entfernenNichtVerfuegbar': 'Companies cannot be removed on this server.',
  'fehler.firma.erstSperrenDannEntfernen': 'A company can only be removed once it is blocked. Block it first, then remove it.',
  'fehler.firma.gesperrt': 'This company is blocked. Please contact the provider.',
  'fehler.firma.statusUnbekannt': 'The state of this company cannot be determined right now. Try again in a moment.',
  'fehler.route.gibtEsNicht': 'There is nothing at this address.',
  'fehler.kennwort.eigenesWirdGewechselt': 'You change your own password rather than resetting it - use "Change password".',
  'fehler.anmeldung.mehrereFirmen': 'This address exists in more than one company. Please enter the company short name.',
  'fehler.datei.artNichtErlaubt': 'That kind of file cannot be attached.',
  'fehler.datei.leer': 'That file is empty.',
  'fehler.datei.zuGross': 'That file is too large to attach.',
  'fehler.projekt.nichtsAusgewaehlt': 'Nothing is selected that could be billed.',
  'fehler.betrag.groesserNull': 'The amount must be greater than zero.',
  'fehler.status.ungueltig': 'There is no such status.',
  'fehler.status.ungueltig': 'There is no such status.',
  'fehler.status.ungueltig': 'There is no such status.',
  'fehler.status.ungueltig': 'There is no such status.',
  'fehler.status.wechselNichtMoeglich': 'That status change is not possible from here.',
  'fehler.zeit.keineStunden': 'Enter hours - or a start and end time that add up to more than zero.',

  'fehler.beleg.nurImStatus': 'That is only possible in status {erlaubt} - this document is {status}.',
  'fehler.beleg.nurImStatus': 'That is only possible in status {erlaubt} - this document is {status}.',
  'fehler.beleg.nurImStatus': 'That is only possible in status {erlaubt} - this document is {status}.',
  'fehler.beleg.nurImStatus': 'That is only possible in status {erlaubt} - this document is {status}.',
  'fehler.beleg.falscherStatus': 'That is not possible in this state - this document is {status}.',
  'fehler.beleg.nurImStatus': 'That is only possible in status {erlaubt} - this document is {status}.',
  'fehler.beleg.nurImStatus': 'That is only possible in status {erlaubt} - this document is {status}.',
  'fehler.beleg.nurImStatus': 'That is only possible in status {erlaubt} - this document is {status}.',
  'fehler.beleg.falscherStatus': 'That is not possible in this state - this document is {status}.',
  'fehler.beleg.falscherStatus': 'That is not possible in this state - this document is {status}.',
  'fehler.beleg.nurImStatus': 'That is only possible in status {erlaubt} - this document is {status}.',
  'fehler.beleg.nurImStatus': 'That is only possible in status {erlaubt} - this document is {status}.',
  'fehler.beleg.schonEntschieden': 'This return has already been decided.',
  'fehler.beleg.schonEingegangen': 'This return has already been received.',
  'fehler.beleg.falscherStatus': 'That is not possible in this state - this document is {status}.',
  'fehler.beleg.statuswechselNichtMoeglich': 'You cannot move directly from {von} to {nach}.',
  'fehler.kunde.falscherStatus': 'This customer is {status} - that does not allow this action.',
  'fehler.kunde.falscherStatus': 'This customer is {status} - that does not allow this action.',
  'fehler.kunde.nummerVergeben': 'That customer number is already in use.',
  'fehler.kunde.kreditlimitUeberschritten': 'This customer’s credit limit is reached: outstanding {offen} plus {dazu} exceeds the limit of {limit}.',
  'fehler.verkaufschance.unbekannteStufe': 'There is no such stage in the pipeline.',
  'fehler.verkaufschance.schonAufStufe': 'This opportunity is already {stufe}.',
  'fehler.kommentar.leer': 'A comment needs some text.',
  'fehler.beleg.ohnePositionen': 'This document needs at least one line item.',
  'fehler.beleg.ohnePositionen': 'This document needs at least one line item.',
  'fehler.position.nichtImAuftrag': 'That product is not on the order at all.',
  'fehler.position.nichtImAuftrag': 'That product is not on the order at all.',
  'fehler.position.mehrAlsBestellt': 'You cannot return {menge} - only {bestellt} were ordered.',
  'fehler.menge.groesserNull': 'The quantity must be greater than zero.',
  'fehler.menge.mehrAlsOffen': '{menge} is more than the {offen} still outstanding.',
  'fehler.preisliste.doppelteStaffel': 'The same product has this quantity tier twice.',
  'fehler.menge.groesserNull': 'The quantity must be greater than zero.',
  'fehler.menge.groesserNull': 'The quantity must be greater than zero.',
  'fehler.fertigung.ohneLager': 'A work order needs a warehouse - that is where material is taken from and the output is booked in.',
  'fehler.stueckliste.nummerVergeben': 'That bill-of-materials code is already taken.',
  'fehler.arbeitsplatz.nummerVergeben': 'That work centre code is already taken.',
  'fehler.stueckliste.stillgelegt': 'That bill of materials is inactive and can no longer be used.',
  'fehler.fertigung.ohneArtikelOderStueckliste': 'Without a bill of materials the order needs at least a product.',
  'fehler.beleg.statuswechselNichtMoeglich': 'You cannot move directly from {von} to {nach}.',
  'fehler.beleg.falscherStatus': 'That is not possible in this state - this document is {status}.',
  'fehler.beleg.falscherStatus': 'That is not possible in this state - this document is {status}.',
  'fehler.fertigung.teilrueckmeldungenLaufen': 'This order is being confirmed in partial quantities - finish it through the confirmations.',
  'fehler.menge.mehrAlsOffen': '{menge} is more than the {offen} still outstanding.',
  'fehler.fertigung.abschlussNichtAngestossen': 'The completion could not be started - nothing was posted. Please try again later.',

  'fehler.person.adresseVergeben': 'That email address already belongs to someone else.',
  'fehler.person.adresseVergeben': 'That email address already belongs to someone else.',
  'fehler.person.schonAusgetreten': 'This person has already left.',
  'fehler.person.austrittVorEintritt': 'The leaving date cannot be before the hire date.',
  'fehler.person.keinAntragMoeglich': 'This person is {status} - no request can be made for them.',
  'fehler.beleg.inzwischenGeaendert': 'Someone else changed this document in the meantime. Reload it and try again.',
  'fehler.gespraech.ohneZeitraum': 'A review needs the period it covers.',
  'fehler.spesen.ohneZweck': 'A travel report needs a purpose for the trip.',
  'fehler.stelle.geschlossen': 'This job posting is closed.',
  'fehler.lohn.laufSchonVorhanden': 'There is already a payroll run for this month.',
  'fehler.zeit.schonStorniert': 'This entry has already been reversed.',
  'fehler.zeitraum.unvollstaendig': 'Both a start and an end are needed.',
  'fehler.zeitraum.endeVorBeginn': 'The end is before the start.',
  'fehler.zeitraum.ohneJahr': 'The year is required.',
  'fehler.zeitraum.ohneJahrUndMonat': 'Both year and month are required.',
  'fehler.zeit.ohnePersonUndZeitraum': 'Both a person and a period are required.',
  'fehler.zeit.stempelungUnvollstaendig': 'A clock entry needs both a start and an end time.',
  'fehler.zeit.stundenAusserhalb': 'The hours must be between 0 and 24.',
  'fehler.datum.unlesbar': 'That date cannot be read.',
  'fehler.zeit.gehoertZuAbwesenheit': 'This entry belongs to approved leave. To remove it, cancel the leave request.',
  'fehler.monat.abschlussNichtEingerichtet': 'Month-end closing is not set up in this installation.',
  'fehler.monat.nichtsEingereicht': 'Nothing was submitted for this month.',
  'fehler.beleg.inzwischenGeaendert': 'Someone else changed this document in the meantime. Reload it and try again.',
  'fehler.lohn.soebenStorniert': 'Someone else just cancelled this payroll run.',
  'fehler.handlung.unbekannt': 'There is no such action.',
  'fehler.antrag.nichtUeberSichSelbst': 'You do not decide on your own request. Your manager or HR does that.',
  'fehler.antrag.andereZustaendig': 'This request is for the manager to decide, or HR as a fallback.',
  'fehler.antrag.nurOffeneZurueckziehen': 'Only a pending request can be withdrawn. For approved leave, ask your manager or HR.',
  'fehler.person.keinePersonalakte': 'There is no employee record linked to this account. HR needs to create the link.',
  'fehler.antrag.keinArbeitstag': 'This period contains no working day - there is nothing to request.',
  'fehler.antrag.schonVorhanden': 'There is already a request for this period.',
  'fehler.abwesenheitsart.stillgelegt': 'The leave type "{art}" is no longer in use. Please choose a current one.',
  'fehler.abwesenheitsart.nichtRueckwirkend': '{art} cannot be requested for the past. The earliest possible start is today.',
  'fehler.abwesenheitsart.brauchtVorlauf': '{art} needs {tage} days’ notice. The earliest possible start is {ab}.',
  'fehler.abwesenheitsart.kuerzelVergeben': 'That leave type already exists.',

  'fehler.lohn.zulageOhneKanton': '{person} has {kinder} child(ren) but no canton of work. Family allowances are cantonal - without a canton the rate cannot be determined.',
  'fehler.lohn.quellensteuerOhneAngaben': '{person} is subject to withholding tax but has no canton of work or tariff code. Both belong in the employee record.',

  'fehler.einheit.faktorGroesserNull': 'The conversion factor must be greater than zero.',
  'fehler.artikel.dienstleistungOhneBestand': 'That is a service - services carry no stock.',
  'fehler.artikel.nochBestandVorhanden': 'This product still has stock on hand - it cannot become a service.',
  'fehler.artikel.stillgelegt': 'This product is inactive and can no longer be moved.',
  'fehler.artikel.chargeGebraucht': 'This product is batch-tracked - a batch number is required.',
  'fehler.artikel.seriennummernGebraucht': 'This product is serial-tracked - exactly {anzahl} serial number(s) are required.',
  'fehler.bestand.zuWenig': 'Not enough stock: {vorhanden} on hand, {gewuenscht} requested.',
  'fehler.bestand.zuWenig': 'Not enough stock: {vorhanden} on hand, {gewuenscht} requested.',
  'fehler.bestand.zuWenig': 'Not enough stock: {vorhanden} on hand, {gewuenscht} requested.',
  'fehler.bestand.zuWenig': 'Not enough stock: {vorhanden} on hand, {gewuenscht} requested.',
  'fehler.bestand.zuWenigWegenReservation': 'Only {frei} can be issued - {reserviert} are reserved, {gewuenscht} were requested.',
  'fehler.bestand.fifoFehlbetrag': 'Stock is not enough under first-in-first-out: {fehlt} are missing.',
  'fehler.lagerplatz.zuWenig': 'This bin holds only {vorhanden} - {gewuenscht} cannot be picked.',
  'fehler.lagerplatz.zuWenig': 'This bin holds only {vorhanden} - {gewuenscht} cannot be picked.',
  'fehler.lagerplatz.nichtsEinzulagern': 'Only {frei} items are without a bin - no more can be put away.',
  'fehler.lagerplatz.gleicherPlatz': 'Source and destination must be different bins.',
  'fehler.lagerplatz.verschiedeneLager': 'Both bins must belong to the same warehouse.',
  'fehler.lager.gleichesLager': 'Source and destination must be different warehouses.',
  'fehler.bestand.korrekturNull': 'An adjustment of zero changes nothing.',
  'fehler.bestand.korrekturOhnePreis': 'An increase needs a unit cost - otherwise the stock valuation no longer adds up.',
  'fehler.freigabe.nichtEigene': 'You cannot approve your own request. Someone else has to do that.',
  'fehler.freigabe.nichtEigene': 'You cannot approve your own request. Someone else has to do that.',
  'fehler.freigabe.nichtEigene': 'You cannot approve your own request. Someone else has to do that.',
  'fehler.freigabe.nurVerwaltung': 'Only someone with admin rights can decide an approval.',
  'fehler.freigabe.nurVerwaltung': 'Only someone with admin rights can decide an approval.',
  'fehler.position.nichtImBeleg': 'That line item does not belong to this document.',
  'fehler.bedarfsmeldung.ohneLieferant': 'Without a supplier this cannot become a purchase order.',
  'fehler.abrufposition.unvollstaendig': 'Every schedule line needs a delivery date and a quantity greater than zero.',
  'fehler.abrufposition.unvollstaendig': 'Every schedule line needs a delivery date and a quantity greater than zero.',
  'fehler.bedarfslauf.keineVorschlaege': 'There are no open procurement proposals to convert.',
  'fehler.einheit.basiseinheitFest': 'That is the base unit - its factor is always 1.',
  'fehler.einheit.schonVorhanden': 'That unit already exists for this product.',
  'fehler.einheit.unbekannt': 'That unit does not exist for this product.',
  'fehler.einheit.unbekannt': 'That unit does not exist for this product.',
  'fehler.bedarfsmeldung.geaendertWaehrendUebernahme': 'The requisition changed during conversion. Purchase order {bestellung} was created but not linked - please check by hand.',

  'fehler.betrag.nichtNegativ': 'The amount must not be negative.',
  'fehler.systemkonto.nichtHinterlegt': 'No account is assigned for "{zweck}". Assign one under System accounts in the chart of accounts.',
  'fehler.systemkonto.stillgelegt': 'Account {konto} for "{zweck}" is inactive and cannot be posted to.',
  'fehler.konto.stillgelegtAlsSystemkonto': 'Account {konto} is inactive and cannot serve as a system account.',
  'fehler.konto.stillgelegt': 'Account {konto} is inactive and cannot be posted to.',
  'fehler.konto.nummerVergeben': 'That account number is already taken.',
  'fehler.konto.nummerVergebenAn': 'Number {nummer} already belongs to "{name}".',
  'fehler.konto.artWieUebergeordnet': 'A child account must have the same type as its parent.',
  'fehler.konto.artNichtMehrAenderbar': '"{name}" has {buchungen} postings. The account type can no longer be changed - every balance would shift.',
  'fehler.konto.falscheArt': 'Account {konto} should be of type {erwartet} but is {ist}.',
  'fehler.position.kontoartPasstNicht': 'The account type of this line does not fit the document (it is {ist}).',
  'fehler.position.kontoartPasstNicht': 'The account type of this line does not fit the document (it is {ist}).',
  'fehler.position.kontoartPasstNicht': 'The account type of this line does not fit the document (it is {ist}).',
  'fehler.budget.nurErfolgskonten': 'A budget only exists on revenue and expense accounts - this one is {ist}.',
  'fehler.budget.ueberschritten': 'This posting would exceed the budget for {konto}.',
  'fehler.buchung.zuWenigeZeilen': 'A journal entry needs at least two lines - a debit and a credit.',
  'fehler.buchung.zuWenigeZeilen': 'A journal entry needs at least two lines - a debit and a credit.',
  'fehler.buchung.zuWenigeZeilen': 'A journal entry needs at least two lines - a debit and a credit.',
  'fehler.buchung.nichtAusgeglichen': 'Debit and credit do not match: {soll} against {haben}.',
  'fehler.buchung.nichtAusgeglichen': 'Debit and credit do not match: {soll} against {haben}.',
  'fehler.periode.geschlossen': 'Period {periode} is closed. Reopen it to post into it.',
  'fehler.periode.schonGeschlossen': 'Period {periode} is already closed.',
  'fehler.periode.nichtGeschlossen': 'Period {periode} is not closed at all.',
  'fehler.geschaeftsjahr.schonAbgeschlossen': 'Fiscal year {jahr} is already closed.',
  'fehler.geschaeftsjahr.nichtsAbzuschliessen': 'There is no profit-and-loss activity to close for {jahr}.',
  'fehler.buchung.soebenStorniert': 'Someone else just reversed this journal entry.',
  'fehler.buchung.schonStorniert': 'Journal entry {beleg} was already reversed by {storno}.',
  'fehler.buchung.jahresabschlussNichtStornierbar': 'That is the year-end close. It cannot be reversed on its own - reopen the fiscal year instead.',
  'fehler.buchung.gehoertZuBeleg': 'This journal entry belongs to a document. A document is reversed on the document itself, not on its journal entry.',
  'fehler.buchung.ohneZeilen': 'This journal entry has no lines.',
  'fehler.beleg.schonVerarbeitet': 'This document has already been processed.',
  'fehler.beleg.summePasstNicht': 'The total {gesamt} does not match the sum of the lines ({positionen}).',
  'fehler.rechnung.schonBeglichen': 'This invoice is already fully settled.',
  'fehler.rechnung.schonBeglichen': 'This invoice is already fully settled.',
  'fehler.zahlung.mehrAlsOffen': 'The amount is higher than the outstanding balance of {offen}.',
  'fehler.zahlung.mehrAlsGuthaben': 'The amount is higher than the credit balance of {guthaben}.',
  'fehler.rechnung.keinGuthaben': 'There is no credit balance on this invoice to refund.',
  'fehler.rechnung.hatZahlungen': 'This invoice has payments. Reverse the payment first.',
  'fehler.rechnung.hatGutschriften': 'This invoice has credit notes. Cancel the credit notes first.',
  'fehler.rechnung.ueberWareneingang': 'The invoice exceeds the goods received by {differenz}. Confirm explicitly to pay anyway.',
  'fehler.rechnung.keineDebitorenrechnung': 'That is not a sales invoice.',
  'fehler.rechnung.andererKunde': 'This invoice belongs to a different customer.',
  'fehler.sammelrechnung.zuWenige': 'Combining needs at least two invoices.',
  'fehler.sammelrechnung.verschiedeneWaehrungen': 'All invoices must share the same currency.',
  'fehler.gutschrift.mehrAlsOffen': '{menge} cannot be credited - only {offen} remain.',
  'fehler.gutschrift.ueberRechnungsbetrag': '{neu} plus the existing {bisher} exceeds the invoice total of {gesamt}.',
  'fehler.anzahlung.ohneRechnung': 'A down payment cannot be applied without an invoice.',
  'fehler.anzahlung.ohneNamen': 'The name of the party is missing.',
  'fehler.mahnung.hoechsteStufe': 'The highest reminder level has already been reached.',
  'fehler.waehrung.kursGebraucht': 'An invoice in {waehrung} needs an exchange rate.',
  'fehler.waehrung.kursGebraucht': 'An invoice in {waehrung} needs an exchange rate.',
  'fehler.waehrung.kursGebraucht': 'An invoice in {waehrung} needs an exchange rate.',
  'fehler.waehrung.kursNurBeiFremdwaehrung': 'An exchange rate only belongs on a foreign-currency invoice.',
  'fehler.waehrung.kursNurBeiFremdwaehrung': 'An exchange rate only belongs on a foreign-currency invoice.',
  'fehler.waehrung.stillgelegt': 'Currency {waehrung} is inactive.',
  'fehler.waehrung.unbekannt': 'Currency {waehrung} is not set up.',
  'fehler.waehrung.schonVorhanden': 'That currency already exists.',
  'fehler.waehrung.keinKurs': 'There is no rate for {waehrung} on or before {datum}.',
  'fehler.waehrung.chfIstBasis': 'CHF is the base currency and has no exchange rate.',
  'fehler.waehrung.chfNichtStilllegbar': 'CHF is the base currency and cannot be deactivated.',
  'fehler.waehrung.kursdienstFehler': 'The rate service did not answer as expected. Try again later.',
  'fehler.waehrung.kursdienstFehler': 'The rate service did not answer as expected. Try again later.',
  'fehler.bankabgleich.waehrungenVerschieden': 'A bank movement in {bank} does not match an invoice in {rechnung}.',
  'fehler.bankabgleich.keineFremdwaehrung': 'A foreign-currency invoice cannot be settled through bank matching - pay it directly with an exchange rate.',
  'fehler.kasse.ohneKonto': 'No ledger account is set up for the cash box.',
  'fehler.kasse.ohneKonto': 'No ledger account is set up for the cash box.',
  'fehler.kasse.ohneGegenkonto': 'A cash entry needs a counter account - material, postage and drawings are different things.',
  'fehler.kasse.zuWenigBargeld': 'The cash box holds only {bestand} - {betrag} cannot be paid out.',
  'fehler.kasse.kuerzelVergeben': 'That cash journal code is already taken.',
  'fehler.kontenrahmen.umstellungNichtMoeglich': 'The chart of accounts cannot be converted like this. Check the preview - it names the reason.',
  'fehler.anlage.restwertZuHoch': 'The salvage value must be below the acquisition cost.',
  'fehler.anlage.abschreibungssatzFehlt': 'Declining-balance depreciation needs a rate greater than zero.',
  'fehler.anlage.schonAbgegangen': 'This fixed asset has already been disposed of.',
  'fehler.firma.gleicheFirma': 'Source and target must be different companies.',
  'fehler.zahlungsbedingung.kuerzelVergeben': 'That payment term code is already taken.',
  'fehler.profitcenter.kuerzelVergeben': 'That profit centre code is already taken.',
  'fehler.abo.hatRechnungen': '{anzahl} invoice(s) have already come from this template. Deactivate it instead of deleting it.',
  'fehler.abo.stillgelegt': 'This template is inactive.',
  'fehler.abo.nochNichtFaellig': 'This template is not due until {faellig}. Confirm explicitly to generate it early.',
  'fehler.abo.laufSchonVorhanden': 'There is already a run from this template for {datum}.',
  'fehler.abo.ohneNaechstenTermin': 'A recurring invoice needs a next run date.',
  'fehler.auswertung.unbekannteQuelle': 'There is no such data source.',
  'fehler.auswertung.unbekanntesFeld': 'There is no such field in this report.',
  'fehler.auswertung.unbekanntesFeld': 'There is no such field in this report.',
  'fehler.auswertung.vergleichNichtErlaubt': 'That comparison does not fit this field.',
  'fehler.auswertung.gruppierungNichtMoeglich': 'Grouping by that is not possible.',
  'fehler.auswertung.nichtAusfuehrbar': 'This report could not be run with the chosen filters.',
  'fehler.mail.nichtEingerichtet': 'Mail sending is not set up. Configure it under Settings → Company.',
  'fehler.mail.ohneAbsender': 'The sender address for mail is missing.',
  'fehler.mail.versandGescheitert': 'The mail could not be sent. Check the mail settings.',
  'fehler.ebics.nichtEingerichtet': 'The bank connection is not set up.',
  'fehler.ebics.ohneHauptschluessel': 'The master key for the bank connection is missing. Without it, bank keys cannot be stored securely.',
  'fehler.ebics.ohneHauptschluessel': 'The master key for the bank connection is missing. Without it, bank keys cannot be stored securely.',
  'fehler.ebics.ohneHauptschluessel': 'The master key for the bank connection is missing. Without it, bank keys cannot be stored securely.',
  'fehler.ebics.hauptschluesselFalscheLaenge': 'The bank connection master key has the wrong length - it must be exactly 32 bytes.',
  'fehler.ebics.schluesselUnlesbar': 'The stored bank key cannot be read.',
  'fehler.ebics.versionUngueltig': 'Only H004 or H005 is possible for the bank connection.',
  'fehler.ebics.nochNichtBereit': 'The bank connection is not ready yet. First submit the keys, have the bank activate them, and fetch the bank key.',
  'fehler.ebics.schluesselFehlen': 'Generate the bank connection keys first.',
  'fehler.ebics.angabenUnvollstaendig': 'The bank connection details are incomplete - address, host, partner and user ID are all required.',

  'fehler.tarifimport.keinBetrag': '{wo}: "{wert}" is not an amount.',
  'fehler.tarifimport.keinSteuersatz': '{wo}: "{wert}" is not a tax rate.',
  'fehler.tarifimport.satzAusserhalb': '{wo}: the tax rate {wert} is outside 0 to 100.',
  'fehler.tarifimport.keinKanton': '{wo}: "{wert}" is not a canton code.',
  'fehler.tarifimport.keinTarifcode': '{wo}: "{wert}" is not a tariff code - something like A0N or B2Y is expected.',
  'fehler.tarifimport.keinJahr': '{wo}: "{wert}" is not a validity year.',
  'fehler.import.keineZeilen': 'This file contains no data rows.',
  'fehler.import.spalteFehlt': 'The column {spalte} is missing. Found: {gefunden}.',
  'fehler.tarifimport.keineSaetze': 'No tariff rates were found in this file. Are the field boundaries right?',
  'fehler.tarifimport.mitBefunden': 'The tariff has {anzahl} findings and was NOT imported. Check the preview.',
  'fehler.quellensteuer.keinSatzFuerEinkommen': 'This tariff has no rate for a monthly income of {einkommen}.',
  'fehler.quellensteuer.keinTarif': 'No withholding tax tariff is stored for {kanton}/{tarif}/{jahr}. Import it before running payroll.',
  'fehler.zulage.keinAnsatz': 'No family allowance rate is stored for {kanton}/{jahr}. Enter it before running payroll.',
  'fehler.abwesenheitsart.nochVerwendet': '"{art}" is still in use ({antraege} requests). Deactivate it instead of deleting it - otherwise the old requests become unreadable.',
  'fehler.abwesenheitsart.grundbestand': '"{art}" is part of the standard set and cannot be deleted. Deactivating it works.',
  'fehler.antrag.schonVorhandenMitZeitraum': 'There is already a request for this period ({von} to {bis}, {status}).',
  'fehler.ferien.guthabenReichtNicht': 'The {jahr} balance is not enough: {beantragt} days requested, {verfuegbar} available.',
  'fehler.farbe.unbekannt': 'There is no such colour. Allowed are: {erlaubt}.',
  'fehler.lohn.schonStorniert': 'This payroll run has already been cancelled.',
  'fehler.monat.geschlossen': 'The month {monat}/{jahr} is {zustand} and therefore closed. Times can no longer be changed in it.',

  'fehler.monat.falscherZustand': 'The month is {zustand} - nothing can be changed on it now.',

  /* ---- Punch clock, account link, and the company switch ---- */

  'hr.employees.col.konto': 'Account',
  'hr.employees.action.link': 'Account',
  'hr.employees.link.title': 'Link an account to this employee',
  'hr.employees.link.hinweis': 'Which login account belongs to {name}? Without this link they cannot see their own time, leave or payslips.',
  'hr.employees.link.konto': 'Login account',
  'hr.employees.link.keins': 'No account',
  'hr.employees.link.belegt': 'already taken',
  'hr.employees.link.loesen': 'Unlink',
  'hr.employees.link.ja': 'linked',
  'hr.employees.link.nein': 'open',

  'platform.provisioning.step.adminEmployee': 'Employee record for the first account',

  'stempel.title': 'Punch clock',
  'stempel.bereit': 'Ready. One click on start and the clock runs.',
  'stempel.seit': 'since {zeit}',
  'stempel.pauseGesamt': '{minuten} min break',
  'stempel.pausiert': 'on break',
  'stempel.start': 'Start',
  'stempel.pause': 'Break',
  'stempel.weiter': 'Resume',
  'stempel.stopp': 'Stop',
  'stempel.vergessen': 'This punch has been running for more than {stunden} hours. It will not close by itself - stopping it will ask you for the right end time.',
  'stempel.korrektur.title': 'When did you finish?',
  'stempel.korrektur.hinweis': 'Started on {datum} at {zeit}. Guessing an end time would be worse than asking - it would stay in your working time for good.',
  'stempel.korrektur.ende': 'End',

  'settings.nav.zeit': 'Time recording',
  'settings.zeit.title': 'How does this company record time?',
  'settings.zeit.intro': 'You decide which ways your staff have for their OWN time. HR can always correct entries - otherwise a forgotten punch could never be put right.',
  'settings.zeit.beides': 'Both',
  'settings.zeit.beides.desc': 'Punch clock and manual entry. Right when not everyone is at a screen when work begins.',
  'settings.zeit.nurStempel': 'Punch clock only',
  'settings.zeit.nurStempel.desc': 'Start, break, stop - nothing else. Anyone who can type hours afterwards can also invent them.',
  'settings.zeit.nurManuell': 'Manual only',
  'settings.zeit.nurManuell.desc': 'Shifts are typed in, not punched. Right for field work and building sites.',
  'settings.zeit.maxStunden': 'When does a punch count as forgotten?',
  'settings.zeit.maxStunden.hint': 'Hours. After that it is not closed; stopping it asks for the end time.',
  'settings.zeit.gespeichert': 'Saved.',

  'fehler.person.kontoSchonVerknuepft': 'This account already belongs to another employee record. Unlink it there first.',
  'fehler.zeit.stempeluhrAus': 'This company records time manually. The punch clock is switched off.',
  'fehler.zeit.handerfassungAus': 'This company records time with the punch clock. Only HR can enter hours by hand.',
  'fehler.zeit.stempelungLaeuftSchon': 'A punch is already running. Possibly on another device.',
  'fehler.zeit.keineStempelungOffen': 'No punch is running right now.',
  'fehler.zeit.pauseLaeuftSchon': 'The break is already running.',
  'fehler.zeit.keinePauseOffen': 'No break is running right now.',
  'fehler.zeit.stempelZuLang': 'This punch has been running for more than {stunden} hours. Enter the right end time - it will not be guessed.',
  'fehler.zeit.stempelZuKurz': 'Less than a minute is not a shift.',
  'fehler.zeit.endeVorBeginn': 'The end is before the start.',
  'fehler.zeit.endeInDerZukunft': 'The end is in the future.',
  'fehler.zeit.endeUnlesbar': 'That end time cannot be read.',
  'fehler.zeit.zeitzoneUnbekannt': 'The time zone {zone} is unknown.',
  'fehler.einstellung.fehlt': 'This company has no settings row. The installation is not up to date.',

  /* Searching for "time" finds three pages. These half-sentences say which
     one is meant - before, only the English path stood underneath. */
  'nav.myTime.hint': 'punch or enter your own working time',
  'nav.time.hint': 'view and correct the working time of all employees',
  'nav.projectsTime.hint': 'book hours to a project, for billing',

};
